//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AppPagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/app-pages/contents?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getAppPages(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, states?: PublicationState[] | null | undefined, search?: string | null | undefined, projectId?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfAppPageListItemDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPages(_response);
        });
    }

    protected processGetAppPages(response: Response): Promise<PaginatedListOfAppPageListItemDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAppPageListItemDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAppPageListItemDto>(null as any);
    }

    createAppPage(command: CreateAppPageCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/app-pages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAppPage(_response);
        });
    }

    protected processCreateAppPage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAppPagesTree(projectId?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<AppPageDto[]> {
        let url_ = this.baseUrl + "/api/v1/app-pages/tree?";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPagesTree(_response);
        });
    }

    protected processGetAppPagesTree(response: Response): Promise<AppPageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppPageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDto[]>(null as any);
    }

    getAppPage(appPageId: string, signal?: AbortSignal): Promise<AppPageDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPage(_response);
        });
    }

    protected processGetAppPage(response: Response): Promise<AppPageDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPageDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDetailsDto>(null as any);
    }

    updateAppPage(appPageId: string, command: UpdateAppPageCommand, signal?: AbortSignal): Promise<AppPageDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAppPage(_response);
        });
    }

    protected processUpdateAppPage(response: Response): Promise<AppPageDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppPageDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppPageDetailsDto>(null as any);
    }

    deleteAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAppPage(_response);
        });
    }

    protected processDeleteAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    moveAppPage(appPageId: string, command: MoveAppPageCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/move";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAppPage(_response);
        });
    }

    protected processMoveAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/hide";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideAppPage(_response);
        });
    }

    protected processHideAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/publish";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishAppPage(_response);
        });
    }

    protected processPublishAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishAppPage(appPageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/unpublish";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishAppPage(_response);
        });
    }

    protected processUnpublishAppPage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAppPageHistory(appPageId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/history?";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPageHistory(_response);
        });
    }

    protected processGetAppPageHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getAppPageHistoryDetails(appPageId: string, appPageVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/app-pages/{appPageId}/history/{appPageVersion}";
        if (appPageId === undefined || appPageId === null)
            throw new Error("The parameter 'appPageId' must be defined.");
        url_ = url_.replace("{appPageId}", encodeURIComponent("" + appPageId));
        if (appPageVersion === undefined || appPageVersion === null)
            throw new Error("The parameter 'appPageVersion' must be defined.");
        url_ = url_.replace("{appPageVersion}", encodeURIComponent("" + appPageVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAppPageHistoryDetails(_response);
        });
    }

    protected processGetAppPageHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }
}

export class AppsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getApps(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAppDto> {
        let url_ = this.baseUrl + "/api/v1/apps?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApps(_response);
        });
    }

    protected processGetApps(response: Response): Promise<PaginatedListOfAppDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAppDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAppDto>(null as any);
    }

    createApp(command: CreateAppCommand, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateApp(_response);
        });
    }

    protected processCreateApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    getApp(appId: string, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetApp(_response);
        });
    }

    protected processGetApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    updateApp(appId: string, command: UpdateAppCommand, signal?: AbortSignal): Promise<AppDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateApp(_response);
        });
    }

    protected processUpdateApp(response: Response): Promise<AppDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppDetailsDto>(null as any);
    }

    deleteApp(appId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/apps/{appId}";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined.");
        url_ = url_.replace("{appId}", encodeURIComponent("" + appId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteApp(_response);
        });
    }

    protected processDeleteApp(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AssetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAssets(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, assetIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (assetIds !== undefined && assetIds !== null)
            assetIds && assetIds.forEach(item => { url_ += "assetIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssets(_response);
        });
    }

    protected processGetAssets(response: Response): Promise<PaginatedListOfAssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAssetDto>(null as any);
    }

    createAsset(command: CreateAssetCommand, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAsset(_response);
        });
    }

    protected processCreateAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    getAsset(assetId: string, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAsset(_response);
        });
    }

    protected processGetAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    updateAsset(assetId: string, command: UpdateAssetCommand, signal?: AbortSignal): Promise<AssetDto> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: Response): Promise<AssetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetDto>(null as any);
    }

    deleteAsset(assetId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAsset(_response);
        });
    }

    protected processDeleteAsset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAssetFile(assetId: string, size?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, x?: number | null | undefined, y?: number | null | undefined, webp?: boolean | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}/file?";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (width !== undefined && width !== null)
            url_ += "w=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "h=" + encodeURIComponent("" + height) + "&";
        if (x !== undefined && x !== null)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (y !== undefined && y !== null)
            url_ += "y=" + encodeURIComponent("" + y) + "&";
        if (webp !== undefined && webp !== null)
            url_ += "webp=" + encodeURIComponent("" + webp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFile(_response);
        });
    }

    protected processGetAssetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAssetFoldersRoot(signal?: AbortSignal): Promise<AssetFolderDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/root";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFoldersRoot(_response);
        });
    }

    protected processGetAssetFoldersRoot(response: Response): Promise<AssetFolderDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDetailsDto>(null as any);
    }

    getAssetFolder(assetFolderId: string, signal?: AbortSignal): Promise<AssetFolderDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAssetFolder(_response);
        });
    }

    protected processGetAssetFolder(response: Response): Promise<AssetFolderDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDetailsDto>(null as any);
    }

    updateAssetFolder(assetFolderId: string, command: UpdateAssetFolderCommand, signal?: AbortSignal): Promise<AssetFolderDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAssetFolder(_response);
        });
    }

    protected processUpdateAssetFolder(response: Response): Promise<AssetFolderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDto>(null as any);
    }

    deleteAssetFolder(assetFolderId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAssetFolder(_response);
        });
    }

    protected processDeleteAssetFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createAssetFolder(command: CreateAssetFolderCommand, signal?: AbortSignal): Promise<AssetFolderDto> {
        let url_ = this.baseUrl + "/api/v1/assets/folders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateAssetFolder(_response);
        });
    }

    protected processCreateAssetFolder(response: Response): Promise<AssetFolderDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetFolderDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssetFolderDto>(null as any);
    }

    moveAsset(assetId: string, command: MoveAssetCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/{assetId}/move";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAsset(_response);
        });
    }

    protected processMoveAsset(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    moveAssetFolder(assetFolderId: string, command: MoveAssetFolderCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/assets/folders/{assetFolderId}/move";
        if (assetFolderId === undefined || assetFolderId === null)
            throw new Error("The parameter 'assetFolderId' must be defined.");
        url_ = url_.replace("{assetFolderId}", encodeURIComponent("" + assetFolderId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMoveAssetFolder(_response);
        });
    }

    protected processMoveAssetFolder(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AuditClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAuditEvents(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfAuditEventDto> {
        let url_ = this.baseUrl + "/api/v1/audit?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvents(_response);
        });
    }

    protected processGetAuditEvents(response: Response): Promise<PaginatedListOfAuditEventDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfAuditEventDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfAuditEventDto>(null as any);
    }

    getAuditEvent(auditEventId: number, signal?: AbortSignal): Promise<AuditEventDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/audit/{auditEventId}";
        if (auditEventId === undefined || auditEventId === null)
            throw new Error("The parameter 'auditEventId' must be defined.");
        url_ = url_.replace("{auditEventId}", encodeURIComponent("" + auditEventId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAuditEvent(_response);
        });
    }

    protected processGetAuditEvent(response: Response): Promise<AuditEventDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuditEventDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuditEventDetailsDto>(null as any);
    }
}

export class BackupsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenantBackup(signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenantBackup(_response);
        });
    }

    protected processGetTenantBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restoreTenantBackup(file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreTenantBackup(_response);
        });
    }

    protected processRestoreTenantBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectBackup(projectId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProjectBackup(_response);
        });
    }

    protected processGetProjectBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getContainerBackup(containerId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/backups/containers/{containerId}";
        if (containerId === undefined || containerId === null)
            throw new Error("The parameter 'containerId' must be defined.");
        url_ = url_.replace("{containerId}", encodeURIComponent("" + containerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContainerBackup(_response);
        });
    }

    protected processGetContainerBackup(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    restoreProjectBackup(file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreProjectBackup(_response);
        });
    }

    protected processRestoreProjectBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restoreContainerBackup(projectId: string, file?: FileParameter | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/backups/projects/{projectId}/containers";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRestoreContainerBackup(_response);
        });
    }

    protected processRestoreContainerBackup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ContextObjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/context-objects/contents?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getContextObjects(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfContextObjectDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjects(_response);
        });
    }

    protected processGetContextObjects(response: Response): Promise<PaginatedListOfContextObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContextObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContextObjectDto>(null as any);
    }

    createContextObject(command: CreateContextObjectCommand, signal?: AbortSignal): Promise<ContextObjectDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateContextObject(_response);
        });
    }

    protected processCreateContextObject(response: Response): Promise<ContextObjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDto>(null as any);
    }

    getContextObject(contextObjectId: string, signal?: AbortSignal): Promise<ContextObjectDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObject(_response);
        });
    }

    protected processGetContextObject(response: Response): Promise<ContextObjectDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDetailsDto>(null as any);
    }

    updateContextObject(contextObjectId: string, command: UpdateContextObjectCommand, signal?: AbortSignal): Promise<ContextObjectDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateContextObject(_response);
        });
    }

    protected processUpdateContextObject(response: Response): Promise<ContextObjectDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContextObjectDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContextObjectDetailsDto>(null as any);
    }

    hideContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/hide";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideContextObject(_response);
        });
    }

    protected processHideContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/permanent";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContextObject(_response);
        });
    }

    protected processDeleteContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/publish";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishContextObject(_response);
        });
    }

    protected processPublishContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishContextObject(contextObjectId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/unpublish";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishContextObject(_response);
        });
    }

    protected processUnpublishContextObject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getContextObjectHistory(contextObjectId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/history?";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectHistory(_response);
        });
    }

    protected processGetContextObjectHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getContextObjectHistoryDetails(contextObjectId: string, contextObjectVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/history/{contextObjectVersion}";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (contextObjectVersion === undefined || contextObjectVersion === null)
            throw new Error("The parameter 'contextObjectVersion' must be defined.");
        url_ = url_.replace("{contextObjectVersion}", encodeURIComponent("" + contextObjectVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectHistoryDetails(_response);
        });
    }

    protected processGetContextObjectHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }

    getContextObjectInstances(contextObjectId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfContextObjectInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/context-objects/{contextObjectId}/instances?";
        if (contextObjectId === undefined || contextObjectId === null)
            throw new Error("The parameter 'contextObjectId' must be defined.");
        url_ = url_.replace("{contextObjectId}", encodeURIComponent("" + contextObjectId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContextObjectInstances(_response);
        });
    }

    protected processGetContextObjectInstances(response: Response): Promise<PaginatedListOfContextObjectInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfContextObjectInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfContextObjectInstanceDto>(null as any);
    }

    hideContextObjectInstances(contextObjectInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/instances/hide?";
        if (contextObjectInstanceIds === undefined || contextObjectInstanceIds === null)
            throw new Error("The parameter 'contextObjectInstanceIds' must be defined and cannot be null.");
        else
            contextObjectInstanceIds && contextObjectInstanceIds.forEach(item => { url_ += "contextObjectInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideContextObjectInstances(_response);
        });
    }

    protected processHideContextObjectInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteContextObjectInstances(contextObjectInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/context-objects/instances?";
        if (contextObjectInstanceIds === undefined || contextObjectInstanceIds === null)
            throw new Error("The parameter 'contextObjectInstanceIds' must be defined and cannot be null.");
        else
            contextObjectInstanceIds && contextObjectInstanceIds.forEach(item => { url_ += "contextObjectInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteContextObjectInstances(_response);
        });
    }

    protected processDeleteContextObjectInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CurrentUserClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    currentUserExists(signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/current-user/exists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCurrentUserExists(_response);
        });
    }

    protected processCurrentUserExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class DevicesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getDevices(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, ownerIds?: string[] | null | undefined, deviceIdentifiers?: string[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfDeviceDto> {
        let url_ = this.baseUrl + "/api/v1/devices?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (ownerIds !== undefined && ownerIds !== null)
            ownerIds && ownerIds.forEach(item => { url_ += "ownerIds=" + encodeURIComponent("" + item) + "&"; });
        if (deviceIdentifiers !== undefined && deviceIdentifiers !== null)
            deviceIdentifiers && deviceIdentifiers.forEach(item => { url_ += "deviceIdentifiers=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevices(_response);
        });
    }

    protected processGetDevices(response: Response): Promise<PaginatedListOfDeviceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfDeviceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfDeviceDto>(null as any);
    }

    getDevice(deviceId: string, signal?: AbortSignal): Promise<DeviceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/devices/{deviceId}";
        if (deviceId === undefined || deviceId === null)
            throw new Error("The parameter 'deviceId' must be defined.");
        url_ = url_.replace("{deviceId}", encodeURIComponent("" + deviceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDevice(_response);
        });
    }

    protected processGetDevice(response: Response): Promise<DeviceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeviceDetailsDto>(null as any);
    }
}

export class FilesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createFile(file?: FileParameter | undefined, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFile(_response);
        });
    }

    protected processCreateFile(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    createFileFromBase64(command: CreateFileFromBase64Command, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/base64";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFileFromBase64(_response);
        });
    }

    protected processCreateFileFromBase64(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    createFileFromUrl(command: CreateFileFromUrlCommand, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/url";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateFileFromUrl(_response);
        });
    }

    protected processCreateFileFromUrl(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }

    getFile(fileId: string, size?: number | null | undefined, width?: number | null | undefined, height?: number | null | undefined, x?: number | null | undefined, y?: number | null | undefined, webp?: boolean | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/files/{fileId}?";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (size !== undefined && size !== null)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (width !== undefined && width !== null)
            url_ += "w=" + encodeURIComponent("" + width) + "&";
        if (height !== undefined && height !== null)
            url_ += "h=" + encodeURIComponent("" + height) + "&";
        if (x !== undefined && x !== null)
            url_ += "x=" + encodeURIComponent("" + x) + "&";
        if (y !== undefined && y !== null)
            url_ += "y=" + encodeURIComponent("" + y) + "&";
        if (webp !== undefined && webp !== null)
            url_ += "webp=" + encodeURIComponent("" + webp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFile(_response);
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFileDto(fileId: string, signal?: AbortSignal): Promise<FileDto> {
        let url_ = this.baseUrl + "/api/v1/files/{fileId}/dto";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetFileDto(_response);
        });
    }

    protected processGetFileDto(response: Response): Promise<FileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileDto>(null as any);
    }
}

export class LanguagesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLanguages(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfLanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguages(_response);
        });
    }

    protected processGetLanguages(response: Response): Promise<PaginatedListOfLanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLanguageDto>(null as any);
    }

    createLanguage(command: CreateLanguageCommand, signal?: AbortSignal): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLanguage(_response);
        });
    }

    protected processCreateLanguage(response: Response): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto>(null as any);
    }

    getLanguage(languageId: string, signal?: AbortSignal): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLanguage(_response);
        });
    }

    protected processGetLanguage(response: Response): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto>(null as any);
    }

    updateLanguage(languageId: string, command: UpdateLanguageCommand, signal?: AbortSignal): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLanguage(_response);
        });
    }

    protected processUpdateLanguage(response: Response): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto>(null as any);
    }

    deleteLanguage(languageId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/languages/{languageId}";
        if (languageId === undefined || languageId === null)
            throw new Error("The parameter 'languageId' must be defined.");
        url_ = url_.replace("{languageId}", encodeURIComponent("" + languageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLanguage(_response);
        });
    }

    protected processDeleteLanguage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDefaultLanguage(signal?: AbortSignal): Promise<LanguageDto> {
        let url_ = this.baseUrl + "/api/v1/languages/default";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDefaultLanguage(_response);
        });
    }

    protected processGetDefaultLanguage(response: Response): Promise<LanguageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LanguageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LanguageDto>(null as any);
    }

    setDefaultLanguage(command: SetDefaultLanguageCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/languages/default";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSetDefaultLanguage(_response);
        });
    }

    protected processSetDefaultLanguage(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    translate(command: TranslateCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/languages/translate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTranslate(_response);
        });
    }

    protected processTranslate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LicensesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLicenses(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfLicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenses(_response);
        });
    }

    protected processGetLicenses(response: Response): Promise<PaginatedListOfLicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLicenseDto>(null as any);
    }

    createLicense(command: CreateLicenseCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLicense(_response);
        });
    }

    protected processCreateLicense(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getLicense(licenseId: string, signal?: AbortSignal): Promise<LicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicense(_response);
        });
    }

    protected processGetLicense(response: Response): Promise<LicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDto>(null as any);
    }

    updateLicense(licenseId: string, command: UpdateLicenseCommand, signal?: AbortSignal): Promise<LicenseDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLicense(_response);
        });
    }

    protected processUpdateLicense(response: Response): Promise<LicenseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseDto>(null as any);
    }

    deleteLicense(licenseId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLicense(_response);
        });
    }

    protected processDeleteLicense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    hideLicense(licenseId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/hide";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideLicense(_response);
        });
    }

    protected processHideLicense(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportLicenses(format: ExportFileFormatParameter, licenseIds?: string[] | null | undefined, fromValidity?: Date | null | undefined, untilValidity?: Date | null | undefined, includeMetadata?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/licenses/export?";
        if (format === undefined || format === null)
            throw new Error("The parameter 'format' must be defined and cannot be null.");
        else
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (licenseIds !== undefined && licenseIds !== null)
            licenseIds && licenseIds.forEach(item => { url_ += "licenseIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromValidity !== undefined && fromValidity !== null)
            url_ += "fromValidity=" + encodeURIComponent(fromValidity ? "" + fromValidity.toISOString() : "") + "&";
        if (untilValidity !== undefined && untilValidity !== null)
            url_ += "untilValidity=" + encodeURIComponent(untilValidity ? "" + untilValidity.toISOString() : "") + "&";
        if (includeMetadata === null)
            throw new Error("The parameter 'includeMetadata' cannot be null.");
        else if (includeMetadata !== undefined)
            url_ += "includeMetadata=" + encodeURIComponent("" + includeMetadata) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportLicenses(_response);
        });
    }

    protected processExportLicenses(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLicenseInstances(licenseId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfLicenseInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances?";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLicenseInstances(_response);
        });
    }

    protected processGetLicenseInstances(response: Response): Promise<PaginatedListOfLicenseInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfLicenseInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfLicenseInstanceDto>(null as any);
    }

    createLicenseInstances(licenseId: string, command: CreateLicenseInstancesCommand, signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateLicenseInstances(_response);
        });
    }

    protected processCreateLicenseInstances(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    updateLicenseInstance(licenseId: string, licenseInstanceId: string, command: UpdateLicenseInstanceCommand, signal?: AbortSignal): Promise<LicenseInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances/{licenseInstanceId}";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (licenseInstanceId === undefined || licenseInstanceId === null)
            throw new Error("The parameter 'licenseInstanceId' must be defined.");
        url_ = url_.replace("{licenseInstanceId}", encodeURIComponent("" + licenseInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateLicenseInstance(_response);
        });
    }

    protected processUpdateLicenseInstance(response: Response): Promise<LicenseInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicenseInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LicenseInstanceDto>(null as any);
    }

    hideLicenseInstances(licenseInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/instances/hide?";
        if (licenseInstanceIds === undefined || licenseInstanceIds === null)
            throw new Error("The parameter 'licenseInstanceIds' must be defined and cannot be null.");
        else
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideLicenseInstances(_response);
        });
    }

    protected processHideLicenseInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteLicenseInstances(licenseInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/licenses/instances?";
        if (licenseInstanceIds === undefined || licenseInstanceIds === null)
            throw new Error("The parameter 'licenseInstanceIds' must be defined and cannot be null.");
        else
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteLicenseInstances(_response);
        });
    }

    protected processDeleteLicenseInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exportLicenseInstances(licenseId: string, format?: ExportFileFormatParameter | undefined, licenseInstanceIds?: string[] | null | undefined, fromValidity?: Date | null | undefined, untilValidity?: Date | null | undefined, includeActivated?: boolean | undefined, includeRevoked?: boolean | undefined, includeHidden?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/licenses/{licenseId}/instances/export?";
        if (licenseId === undefined || licenseId === null)
            throw new Error("The parameter 'licenseId' must be defined.");
        url_ = url_.replace("{licenseId}", encodeURIComponent("" + licenseId));
        if (format === null)
            throw new Error("The parameter 'format' cannot be null.");
        else if (format !== undefined)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        if (licenseInstanceIds !== undefined && licenseInstanceIds !== null)
            licenseInstanceIds && licenseInstanceIds.forEach(item => { url_ += "licenseInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (fromValidity !== undefined && fromValidity !== null)
            url_ += "fromValidity=" + encodeURIComponent(fromValidity ? "" + fromValidity.toISOString() : "") + "&";
        if (untilValidity !== undefined && untilValidity !== null)
            url_ += "untilValidity=" + encodeURIComponent(untilValidity ? "" + untilValidity.toISOString() : "") + "&";
        if (includeActivated === null)
            throw new Error("The parameter 'includeActivated' cannot be null.");
        else if (includeActivated !== undefined)
            url_ += "includeActivated=" + encodeURIComponent("" + includeActivated) + "&";
        if (includeRevoked === null)
            throw new Error("The parameter 'includeRevoked' cannot be null.");
        else if (includeRevoked !== undefined)
            url_ += "includeRevoked=" + encodeURIComponent("" + includeRevoked) + "&";
        if (includeHidden === null)
            throw new Error("The parameter 'includeHidden' cannot be null.");
        else if (includeHidden !== undefined)
            url_ += "includeHidden=" + encodeURIComponent("" + includeHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportLicenseInstances(_response);
        });
    }

    protected processExportLicenseInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class QuestionnairesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getContents(limit?: number | undefined, search?: string | null | undefined, types?: ElementType[] | null | undefined, excludeTypes?: ElementType[] | null | undefined, projectIds?: string[] | null | undefined, containerIds?: string[] | null | undefined, excludeContainerIds?: string[] | null | undefined, contentIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ContentDto[]> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/contents?";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "types=" + encodeURIComponent("" + item) + "&"; });
        if (excludeTypes !== undefined && excludeTypes !== null)
            excludeTypes && excludeTypes.forEach(item => { url_ += "excludeTypes=" + encodeURIComponent("" + item) + "&"; });
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (containerIds !== undefined && containerIds !== null)
            containerIds && containerIds.forEach(item => { url_ += "containerIds=" + encodeURIComponent("" + item) + "&"; });
        if (excludeContainerIds !== undefined && excludeContainerIds !== null)
            excludeContainerIds && excludeContainerIds.forEach(item => { url_ += "excludeContainerIds=" + encodeURIComponent("" + item) + "&"; });
        if (contentIds !== undefined && contentIds !== null)
            contentIds && contentIds.forEach(item => { url_ += "contentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContents(_response);
        });
    }

    protected processGetContents(response: Response): Promise<ContentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDto[]>(null as any);
    }

    getQuestionnaires(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfQuestionnaireDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaires(_response);
        });
    }

    protected processGetQuestionnaires(response: Response): Promise<PaginatedListOfQuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionnaireDto>(null as any);
    }

    createQuestionnaire(command: CreateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateQuestionnaire(_response);
        });
    }

    protected processCreateQuestionnaire(response: Response): Promise<QuestionnaireDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDto>(null as any);
    }

    getQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaire(_response);
        });
    }

    protected processGetQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    updateQuestionnaire(questionnaireId: string, command: UpdateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateQuestionnaire(_response);
        });
    }

    protected processUpdateQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    deleteQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaire(_response);
        });
    }

    protected processDeleteQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    translateQuestionnaire(questionnaireId: string, command: TranslateQuestionnaireCommand, signal?: AbortSignal): Promise<QuestionnaireDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/translate";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processTranslateQuestionnaire(_response);
        });
    }

    protected processTranslateQuestionnaire(response: Response): Promise<QuestionnaireDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireDetailsDto>(null as any);
    }

    hideQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/hide";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideQuestionnaire(_response);
        });
    }

    protected processHideQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/publish";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishQuestionnaire(_response);
        });
    }

    protected processPublishQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishQuestionnaire(questionnaireId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/unpublish";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishQuestionnaire(_response);
        });
    }

    protected processUnpublishQuestionnaire(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getQuestionnaireHistory(questionnaireId: string, pageNumber?: number | undefined, pageSize?: number | undefined, from?: Date | null | undefined, until?: Date | null | undefined, userIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfHistoricalContentDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/history?";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (userIds !== undefined && userIds !== null)
            userIds && userIds.forEach(item => { url_ += "userIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireHistory(_response);
        });
    }

    protected processGetQuestionnaireHistory(response: Response): Promise<PaginatedListOfHistoricalContentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfHistoricalContentDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfHistoricalContentDto>(null as any);
    }

    getQuestionnaireHistoryDetails(questionnaireId: string, questionnaireVersion: number, signal?: AbortSignal): Promise<HistoricalContentDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/history/{questionnaireVersion}";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionnaireVersion === undefined || questionnaireVersion === null)
            throw new Error("The parameter 'questionnaireVersion' must be defined.");
        url_ = url_.replace("{questionnaireVersion}", encodeURIComponent("" + questionnaireVersion));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireHistoryDetails(_response);
        });
    }

    protected processGetQuestionnaireHistoryDetails(response: Response): Promise<HistoricalContentDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HistoricalContentDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HistoricalContentDetailsDto>(null as any);
    }

    getQuestionnaireInstances(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, projectIds?: string[] | null | undefined, questionnaireIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, states?: QuestionnaireInstanceState[] | null | undefined, showHidden?: boolean | undefined, signal?: AbortSignal): Promise<PaginatedListOfQuestionnaireInstanceDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (showHidden === null)
            throw new Error("The parameter 'showHidden' cannot be null.");
        else if (showHidden !== undefined)
            url_ += "showHidden=" + encodeURIComponent("" + showHidden) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstances(_response);
        });
    }

    protected processGetQuestionnaireInstances(response: Response): Promise<PaginatedListOfQuestionnaireInstanceDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfQuestionnaireInstanceDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfQuestionnaireInstanceDto>(null as any);
    }

    deleteQuestionnaireInstances(questionnaireInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances?";
        if (questionnaireInstanceIds === undefined || questionnaireInstanceIds === null)
            throw new Error("The parameter 'questionnaireInstanceIds' must be defined and cannot be null.");
        else
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteQuestionnaireInstances(_response);
        });
    }

    protected processDeleteQuestionnaireInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getQuestionnaireInstance(questionnaireInstanceId: string, signal?: AbortSignal): Promise<QuestionnaireInstanceDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances/{questionnaireInstanceId}";
        if (questionnaireInstanceId === undefined || questionnaireInstanceId === null)
            throw new Error("The parameter 'questionnaireInstanceId' must be defined.");
        url_ = url_.replace("{questionnaireInstanceId}", encodeURIComponent("" + questionnaireInstanceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstance(_response);
        });
    }

    protected processGetQuestionnaireInstance(response: Response): Promise<QuestionnaireInstanceDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireInstanceDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireInstanceDetailsDto>(null as any);
    }

    exportQuestionnaireInstances(questionnaireId: string, questionnaireInstanceIds?: string[] | null | undefined, states?: QuestionnaireInstanceState[] | null | undefined, from?: Date | null | undefined, until?: Date | null | undefined, includeExecutionInfo?: boolean | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/{questionnaireId}/instances/export?";
        if (questionnaireId === undefined || questionnaireId === null)
            throw new Error("The parameter 'questionnaireId' must be defined.");
        url_ = url_.replace("{questionnaireId}", encodeURIComponent("" + questionnaireId));
        if (questionnaireInstanceIds !== undefined && questionnaireInstanceIds !== null)
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        if (states !== undefined && states !== null)
            states && states.forEach(item => { url_ += "states=" + encodeURIComponent("" + item) + "&"; });
        if (from !== undefined && from !== null)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (until !== undefined && until !== null)
            url_ += "until=" + encodeURIComponent(until ? "" + until.toISOString() : "") + "&";
        if (includeExecutionInfo === null)
            throw new Error("The parameter 'includeExecutionInfo' cannot be null.");
        else if (includeExecutionInfo !== undefined)
            url_ += "includeExecutionInfo=" + encodeURIComponent("" + includeExecutionInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportQuestionnaireInstances(_response);
        });
    }

    protected processExportQuestionnaireInstances(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    hideQuestionnaireInstances(questionnaireInstanceIds: string[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/questionnaires/instances/hide?";
        if (questionnaireInstanceIds === undefined || questionnaireInstanceIds === null)
            throw new Error("The parameter 'questionnaireInstanceIds' must be defined and cannot be null.");
        else
            questionnaireInstanceIds && questionnaireInstanceIds.forEach(item => { url_ += "questionnaireInstanceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processHideQuestionnaireInstances(_response);
        });
    }

    protected processHideQuestionnaireInstances(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SchedulesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getSchedules(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, projectIds?: string[] | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/schedules?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedules(_response);
        });
    }

    protected processGetSchedules(response: Response): Promise<PaginatedListOfScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfScheduleDto>(null as any);
    }

    createSchedule(command: CreateScheduleCommand, signal?: AbortSignal): Promise<ScheduleDto> {
        let url_ = this.baseUrl + "/api/v1/schedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSchedule(_response);
        });
    }

    protected processCreateSchedule(response: Response): Promise<ScheduleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDto>(null as any);
    }

    getSchedule(scheduleId: string, signal?: AbortSignal): Promise<ScheduleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSchedule(_response);
        });
    }

    protected processGetSchedule(response: Response): Promise<ScheduleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDetailsDto>(null as any);
    }

    updateSchedule(scheduleId: string, command: UpdateScheduleCommand, signal?: AbortSignal): Promise<ScheduleDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSchedule(_response);
        });
    }

    protected processUpdateSchedule(response: Response): Promise<ScheduleDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScheduleDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScheduleDetailsDto>(null as any);
    }

    deleteSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteSchedule(_response);
        });
    }

    protected processDeleteSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    activateSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}/activate";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processActivateSchedule(_response);
        });
    }

    protected processActivateSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivateSchedule(scheduleId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/schedules/{scheduleId}/deactivate";
        if (scheduleId === undefined || scheduleId === null)
            throw new Error("The parameter 'scheduleId' must be defined.");
        url_ = url_.replace("{scheduleId}", encodeURIComponent("" + scheduleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeactivateSchedule(_response);
        });
    }

    protected processDeactivateSchedule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class StatisticsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStudyStatistics(projectIds?: string[] | null | undefined, signal?: AbortSignal): Promise<StudyStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/studies?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudyStatistics(_response);
        });
    }

    protected processGetStudyStatistics(response: Response): Promise<StudyStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyStatisticsDto>(null as any);
    }

    getQuestionnaireStatistics(projectIds?: string[] | null | undefined, questionnaireIds?: string[] | null | undefined, signal?: AbortSignal): Promise<QuestionnaireStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questionnaires?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (questionnaireIds !== undefined && questionnaireIds !== null)
            questionnaireIds && questionnaireIds.forEach(item => { url_ += "questionnaireIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireStatistics(_response);
        });
    }

    protected processGetQuestionnaireStatistics(response: Response): Promise<QuestionnaireStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireStatisticsDto>(null as any);
    }

    getParticipantStatistics(projectIds?: string[] | null | undefined, participantIds?: string[] | null | undefined, signal?: AbortSignal): Promise<ParticipantStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/participants?";
        if (projectIds !== undefined && projectIds !== null)
            projectIds && projectIds.forEach(item => { url_ += "projectIds=" + encodeURIComponent("" + item) + "&"; });
        if (participantIds !== undefined && participantIds !== null)
            participantIds && participantIds.forEach(item => { url_ += "participantIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipantStatistics(_response);
        });
    }

    protected processGetParticipantStatistics(response: Response): Promise<ParticipantStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParticipantStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ParticipantStatisticsDto>(null as any);
    }

    getQuestionnaireInstanceStatistics(query: GetQuestionnaireInstanceStatisticsQuery, signal?: AbortSignal): Promise<QuestionnaireInstanceStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questionnaire-instances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionnaireInstanceStatistics(_response);
        });
    }

    protected processGetQuestionnaireInstanceStatistics(response: Response): Promise<QuestionnaireInstanceStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionnaireInstanceStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionnaireInstanceStatisticsDto>(null as any);
    }

    getQuestionStatistics(query: GetQuestionStatisticsQuery, signal?: AbortSignal): Promise<QuestionStatisticsDto> {
        let url_ = this.baseUrl + "/api/v1/statistics/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetQuestionStatistics(_response);
        });
    }

    protected processGetQuestionStatistics(response: Response): Promise<QuestionStatisticsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QuestionStatisticsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionStatisticsDto>(null as any);
    }
}

export class StudiesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStudies(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfStudyDto> {
        let url_ = this.baseUrl + "/api/v1/studies?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudies(_response);
        });
    }

    protected processGetStudies(response: Response): Promise<PaginatedListOfStudyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfStudyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfStudyDto>(null as any);
    }

    createStudy(command: CreateStudyCommand, signal?: AbortSignal): Promise<StudyDto> {
        let url_ = this.baseUrl + "/api/v1/studies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateStudy(_response);
        });
    }

    protected processCreateStudy(response: Response): Promise<StudyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDto>(null as any);
    }

    getStudy(studyId: string, signal?: AbortSignal): Promise<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetStudy(_response);
        });
    }

    protected processGetStudy(response: Response): Promise<StudyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDetailsDto>(null as any);
    }

    updateStudy(studyId: string, command: UpdateStudyCommand, signal?: AbortSignal): Promise<StudyDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateStudy(_response);
        });
    }

    protected processUpdateStudy(response: Response): Promise<StudyDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StudyDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StudyDetailsDto>(null as any);
    }

    deleteStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteStudy(_response);
        });
    }

    protected processDeleteStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    publishStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/publish";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPublishStudy(_response);
        });
    }

    protected processPublishStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    unpublishStudy(studyId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/unpublish";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUnpublishStudy(_response);
        });
    }

    protected processUnpublishStudy(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    generateJoinParticipantGroupQrCode(studyId: string, participantGroupId: string, appId: string, signal?: AbortSignal): Promise<QrCodeDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/use-join-group-qr-code?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (participantGroupId === undefined || participantGroupId === null)
            throw new Error("The parameter 'participantGroupId' must be defined and cannot be null.");
        else
            url_ += "participantGroupId=" + encodeURIComponent("" + participantGroupId) + "&";
        if (appId === undefined || appId === null)
            throw new Error("The parameter 'appId' must be defined and cannot be null.");
        else
            url_ += "appId=" + encodeURIComponent("" + appId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerateJoinParticipantGroupQrCode(_response);
        });
    }

    protected processGenerateJoinParticipantGroupQrCode(response: Response): Promise<QrCodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QrCodeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QrCodeDto>(null as any);
    }

    getParticipants(studyId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfProjectParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<PaginatedListOfProjectParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectParticipantDto>(null as any);
    }

    exportParticipants(studyId: string, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/export";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExportParticipants(_response);
        });
    }

    protected processExportParticipants(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<ProjectParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipant(_response);
        });
    }

    protected processGetParticipant(response: Response): Promise<ProjectParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectParticipantDto>(null as any);
    }

    addParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddParticipant(_response);
        });
    }

    protected processAddParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    withdrawParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}/withdraw";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithdrawParticipant(_response);
        });
    }

    protected processWithdrawParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteParticipant(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/participants/{userId}/purge";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteParticipant(_response);
        });
    }

    protected processDeleteParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAdministrators(studyId: string, pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfProjectAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators?";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrators(_response);
        });
    }

    protected processGetAdministrators(response: Response): Promise<PaginatedListOfProjectAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfProjectAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfProjectAdministratorDto>(null as any);
    }

    getAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<ProjectAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrator(_response);
        });
    }

    protected processGetAdministrator(response: Response): Promise<ProjectAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectAdministratorDto>(null as any);
    }

    addAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAdministrator(_response);
        });
    }

    protected processAddAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAdministrator(studyId: string, userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAdministrator(_response);
        });
    }

    protected processDeleteAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateAdministratorPermissions(studyId: string, userId: string, permissions: Permission[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/studies/{studyId}/administrators/{userId}/permissions";
        if (studyId === undefined || studyId === null)
            throw new Error("The parameter 'studyId' must be defined.");
        url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAdministratorPermissions(_response);
        });
    }

    protected processUpdateAdministratorPermissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TenantClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTenant(signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenant";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetTenant(_response);
        });
    }

    protected processGetTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    updateTenant(command: UpdateTenantCommand, signal?: AbortSignal): Promise<TenantDetailsDto> {
        let url_ = this.baseUrl + "/api/v1/tenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateTenant(_response);
        });
    }

    protected processUpdateTenant(response: Response): Promise<TenantDetailsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantDetailsDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantDetailsDto>(null as any);
    }

    getDeploymentInformation(signal?: AbortSignal): Promise<DeploymentInformation> {
        let url_ = this.baseUrl + "/api/v1/tenant/information";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetDeploymentInformation(_response);
        });
    }

    protected processGetDeploymentInformation(response: Response): Promise<DeploymentInformation> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeploymentInformation.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeploymentInformation>(null as any);
    }

    getAdministrators(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrators(_response);
        });
    }

    protected processGetAdministrators(response: Response): Promise<PaginatedListOfTenantAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantAdministratorDto>(null as any);
    }

    getAdministrator(userId: string, signal?: AbortSignal): Promise<TenantAdministratorDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAdministrator(_response);
        });
    }

    protected processGetAdministrator(response: Response): Promise<TenantAdministratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantAdministratorDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantAdministratorDto>(null as any);
    }

    addAdministrator(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAdministrator(_response);
        });
    }

    protected processAddAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAdministrator(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAdministrator(_response);
        });
    }

    protected processDeleteAdministrator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateAdministratorPermissions(userId: string, permissions: Permission[], signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/administrators/{userId}/permissions";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(permissions);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAdministratorPermissions(_response);
        });
    }

    protected processUpdateAdministratorPermissions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getParticipants(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfTenantParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipants(_response);
        });
    }

    protected processGetParticipants(response: Response): Promise<PaginatedListOfTenantParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfTenantParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfTenantParticipantDto>(null as any);
    }

    getParticipant(userId: string, signal?: AbortSignal): Promise<TenantParticipantDto> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetParticipant(_response);
        });
    }

    protected processGetParticipant(response: Response): Promise<TenantParticipantDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantParticipantDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TenantParticipantDto>(null as any);
    }

    addParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddParticipant(_response);
        });
    }

    protected processAddParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteParticipant(_response);
        });
    }

    protected processDeleteParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    withdrawParticipant(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/tenant/participants/{userId}/withdraw";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processWithdrawParticipant(_response);
        });
    }

    protected processWithdrawParticipant(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getLinkConfiguration(platform: Platform, tenantId?: string | null | undefined, signal?: AbortSignal): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/tenant/link-configuration?";
        if (platform === undefined || platform === null)
            throw new Error("The parameter 'platform' must be defined and cannot be null.");
        else
            url_ += "platform=" + encodeURIComponent("" + platform) + "&";
        if (tenantId !== undefined && tenantId !== null)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLinkConfiguration(_response);
        });
    }

    protected processGetLinkConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class UsersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getUsers(pageNumber?: number | undefined, pageSize?: number | undefined, sorting?: SortingParameter[] | null | undefined, search?: string | null | undefined, signal?: AbortSignal): Promise<PaginatedListOfUserDto> {
        let url_ = this.baseUrl + "/api/v1/users?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sorting !== undefined && sorting !== null)
            sorting && sorting.forEach((item, index) => {
                for (const attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "sorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: Response): Promise<PaginatedListOfUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaginatedListOfUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedListOfUserDto>(null as any);
    }

    createUser(command: CreateUserCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    getUser(userId: string, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    updateUser(userId: string, command: UpdateUserCommand, signal?: AbortSignal): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: Response): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserDto>(null as any);
    }

    addUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddUser(_response);
        });
    }

    protected processAddUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteUser(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    exists(userId: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/exists";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processExists(_response);
        });
    }

    protected processExists(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    sendRegistrationMail(userId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/registrationmail";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendRegistrationMail(_response);
        });
    }

    protected processSendRegistrationMail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sendNotification(userId: string, command: SendNotificationCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{userId}/notification";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendNotification(_response);
        });
    }

    protected processSendNotification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export abstract class ContentDto implements IContentDto {
    id!: string;
    name!: string;
    elementType!: ElementType;
    condition?: ContentCondition | undefined;

    protected _discriminator: string;

    constructor(data?: IContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "ContentDto";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.elementType = _data["elementType"];
            this.condition = _data["condition"] ? ContentCondition.fromJS(_data["condition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContentDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ContentGroupDto") {
            let result = new ContentGroupDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContentPageDto") {
            let result = new ContentPageDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DisplayDto") {
            throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
        }
        if (data["$type"] === "ImageDisplayDto") {
            let result = new ImageDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextDisplayDto") {
            let result = new TextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "RichTextDisplayDto") {
            let result = new RichTextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionnaireReferenceDisplayDto") {
            let result = new QuestionnaireReferenceDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "PropertyDto") {
            throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
        }
        if (data["$type"] === "TextPropertyDto") {
            let result = new TextPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyDto") {
            let result = new NumberPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyDto") {
            let result = new DatePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyDto") {
            let result = new ChoicePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionDto") {
            throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
        }
        if (data["$type"] === "LikertQuestionDto") {
            let result = new LikertQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionDto") {
            let result = new MatrixQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionDto") {
            let result = new ChoiceQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionDto") {
            let result = new ContainerQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionDto") {
            let result = new BoolQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionDto") {
            let result = new TextQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionDto") {
            let result = new NumberQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionDto") {
            let result = new DateQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionDto") {
            let result = new TimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionDto") {
            let result = new DateTimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionDto") {
            let result = new SliderQuestionDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ContentDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["id"] = this.id;
        data["name"] = this.name;
        data["elementType"] = this.elementType;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        return data;
    }

    clone(): ContentDto {
        throw new Error("The abstract class 'ContentDto' cannot be instantiated.");
    }
}

export interface IContentDto {
    id: string;
    name: string;
    elementType: ElementType;
    condition?: ContentCondition | undefined;
}

export enum ElementType {
    None = "none",
    ContentGroup = "contentGroup",
    ContentPage = "contentPage",
    ChoiceQuestion = "choiceQuestion",
    DateQuestion = "dateQuestion",
    DateTimeQuestion = "dateTimeQuestion",
    LikertQuestion = "likertQuestion",
    MatrixQuestion = "matrixQuestion",
    NumberQuestion = "numberQuestion",
    SliderQuestion = "sliderQuestion",
    TextQuestion = "textQuestion",
    TimeQuestion = "timeQuestion",
    BoolQuestion = "boolQuestion",
    RichTextDisplay = "richTextDisplay",
    ImageDisplay = "imageDisplay",
    TextDisplay = "textDisplay",
    QuestionnaireReferenceDisplay = "questionnaireReferenceDisplay",
    DateProperty = "dateProperty",
    NumberProperty = "numberProperty",
    TextProperty = "textProperty",
    ChoiceProperty = "choiceProperty",
    ContainerQuestion = "containerQuestion",
}

export abstract class Condition implements ICondition {
    expression!: string;

    constructor(data?: ICondition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.expression = _data["expression"];
        }
    }

    static fromJS(data: any): Condition {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Condition' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["expression"] = this.expression;
        return data;
    }

    clone(): Condition {
        throw new Error("The abstract class 'Condition' cannot be instantiated.");
    }
}

export interface ICondition {
    expression: string;
}

export class ContentCondition extends Condition implements IContentCondition {

    constructor(data?: IContentCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContentCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ContentCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContentCondition {
        const json = this.toJSON();
        let result = new ContentCondition();
        result.init(json);
        return result;
    }
}

export interface IContentCondition extends ICondition {
}

export class ContentGroupDto extends ContentDto implements IContentGroupDto {
    contents!: ContentDto[];

    constructor(data?: IContentGroupDto) {
        super(data);
        if (!data) {
            this.contents = [];
        }
        this._discriminator = "ContentGroupDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentGroupDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContentGroupDto {
        const json = this.toJSON();
        let result = new ContentGroupDto();
        result.init(json);
        return result;
    }
}

export interface IContentGroupDto extends IContentDto {
    contents: ContentDto[];
}

export class ContentPageDto extends ContentDto implements IContentPageDto {
    title!: InternationalizedString;
    pageRandomizationMode!: PageRandomizationMode;
    contents!: ContentDto[];

    constructor(data?: IContentPageDto) {
        super(data);
        if (!data) {
            this.title = new InternationalizedString();
            this.contents = [];
        }
        this._discriminator = "ContentPageDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.pageRandomizationMode = _data["pageRandomizationMode"];
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContentPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentPageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["pageRandomizationMode"] = this.pageRandomizationMode;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContentPageDto {
        const json = this.toJSON();
        let result = new ContentPageDto();
        result.init(json);
        return result;
    }
}

export interface IContentPageDto extends IContentDto {
    title: InternationalizedString;
    pageRandomizationMode: PageRandomizationMode;
    contents: ContentDto[];
}

export class InternationalizedString implements IInternationalizedString {
    translations!: { [key: string]: string; };

    constructor(data?: IInternationalizedString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = (<any>this.translations)[key];
            }
        }
        return data;
    }

    clone(): InternationalizedString {
        const json = this.toJSON();
        let result = new InternationalizedString();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedString {
    translations: { [key: string]: string; };
}

export enum PageRandomizationMode {
    None = "none",
    RandomizeContents = "randomizeContents",
    RandomizeOrder = "randomizeOrder",
    RandomizeContentsAndOrder = "randomizeContentsAndOrder",
}

export abstract class DisplayDto extends ContentDto implements IDisplayDto {

    constructor(data?: IDisplayDto) {
        super(data);
        this._discriminator = "DisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): DisplayDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ImageDisplayDto") {
            let result = new ImageDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextDisplayDto") {
            let result = new TextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "RichTextDisplayDto") {
            let result = new RichTextDisplayDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "QuestionnaireReferenceDisplayDto") {
            let result = new QuestionnaireReferenceDisplayDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): DisplayDto {
        throw new Error("The abstract class 'DisplayDto' cannot be instantiated.");
    }
}

export interface IDisplayDto extends IContentDto {
}

export class ImageDisplayDto extends DisplayDto implements IImageDisplayDto {
    asset?: AssetDto | undefined;
    description!: InternationalizedString;
    accessibleDescription!: InternationalizedString;

    constructor(data?: IImageDisplayDto) {
        super(data);
        if (!data) {
            this.description = new InternationalizedString();
            this.accessibleDescription = new InternationalizedString();
        }
        this._discriminator = "ImageDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.description = _data["description"] ? InternationalizedString.fromJS(_data["description"]) : new InternationalizedString();
            this.accessibleDescription = _data["accessibleDescription"] ? InternationalizedString.fromJS(_data["accessibleDescription"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): ImageDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["accessibleDescription"] = this.accessibleDescription ? this.accessibleDescription.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ImageDisplayDto {
        const json = this.toJSON();
        let result = new ImageDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IImageDisplayDto extends IDisplayDto {
    asset?: AssetDto | undefined;
    description: InternationalizedString;
    accessibleDescription: InternationalizedString;
}

export class TenantEntityDto implements ITenantEntityDto {
    id!: string;
    tenantId!: string;

    constructor(data?: ITenantEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): TenantEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tenantId"] = this.tenantId;
        return data;
    }

    clone(): TenantEntityDto {
        const json = this.toJSON();
        let result = new TenantEntityDto();
        result.init(json);
        return result;
    }
}

export interface ITenantEntityDto {
    id: string;
    tenantId: string;
}

export class AssetDto extends TenantEntityDto implements IAssetDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name!: string;
    /** A brief description of the asset. */
    description?: string | undefined;
    /** Width of the asset file in pixels. */
    width?: number | undefined;
    /** Height of the asset file in pixels. */
    height?: number | undefined;
    /** X coordinate of the asset file image detail in pixels. */
    x?: number | undefined;
    /** Y coordinate of the asset file image detail in pixels. */
    y?: number | undefined;
    /** The content type of the asset file. */
    contentType!: string;
    /** Tags associated with the asset, useful for categorization or search. */
    tags?: string[] | undefined;
    /** The URL where the asset was originally sourced from. */
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    /** Restrictions associated with the asset's license. */
    licenseRestriction?: LicenseRestriction[] | undefined;
    /** URL of the license under which the asset is distributed. */
    licenseUrl?: string | undefined;
    /** Copyright information for the asset. */
    copyright?: string | undefined;
    /** Attribution details for the asset, if required. */
    attribution?: string | undefined;
    /** Metadata read from the asset file. */
    metadata?: AssetMetadataDto | undefined;

    constructor(data?: IAssetDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.file = _data["file"] ? FileDto.fromJS(_data["file"]) : <any>undefined;
            this.url = _data["url"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.contentType = _data["contentType"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.sourceUrl = _data["sourceUrl"];
            this.licenseType = _data["licenseType"];
            if (Array.isArray(_data["licenseRestriction"])) {
                this.licenseRestriction = [] as any;
                for (let item of _data["licenseRestriction"])
                    this.licenseRestriction!.push(item);
            }
            this.licenseUrl = _data["licenseUrl"];
            this.copyright = _data["copyright"];
            this.attribution = _data["attribution"];
            this.metadata = _data["metadata"] ? AssetMetadataDto.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["file"] = this.file ? this.file.toJSON() : <any>undefined;
        data["url"] = this.url;
        data["name"] = this.name;
        data["description"] = this.description;
        data["width"] = this.width;
        data["height"] = this.height;
        data["x"] = this.x;
        data["y"] = this.y;
        data["contentType"] = this.contentType;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sourceUrl"] = this.sourceUrl;
        data["licenseType"] = this.licenseType;
        if (Array.isArray(this.licenseRestriction)) {
            data["licenseRestriction"] = [];
            for (let item of this.licenseRestriction)
                data["licenseRestriction"].push(item);
        }
        data["licenseUrl"] = this.licenseUrl;
        data["copyright"] = this.copyright;
        data["attribution"] = this.attribution;
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): AssetDto {
        const json = this.toJSON();
        let result = new AssetDto();
        result.init(json);
        return result;
    }
}

export interface IAssetDto extends ITenantEntityDto {
    file?: FileDto | undefined;
    url?: string | undefined;
    name: string;
    /** A brief description of the asset. */
    description?: string | undefined;
    /** Width of the asset file in pixels. */
    width?: number | undefined;
    /** Height of the asset file in pixels. */
    height?: number | undefined;
    /** X coordinate of the asset file image detail in pixels. */
    x?: number | undefined;
    /** Y coordinate of the asset file image detail in pixels. */
    y?: number | undefined;
    /** The content type of the asset file. */
    contentType: string;
    /** Tags associated with the asset, useful for categorization or search. */
    tags?: string[] | undefined;
    /** The URL where the asset was originally sourced from. */
    sourceUrl?: string | undefined;
    licenseType?: LicenseType | undefined;
    /** Restrictions associated with the asset's license. */
    licenseRestriction?: LicenseRestriction[] | undefined;
    /** URL of the license under which the asset is distributed. */
    licenseUrl?: string | undefined;
    /** Copyright information for the asset. */
    copyright?: string | undefined;
    /** Attribution details for the asset, if required. */
    attribution?: string | undefined;
    /** Metadata read from the asset file. */
    metadata?: AssetMetadataDto | undefined;
}

export class FileDto implements IFileDto {
    url?: string | undefined;
    id!: string;
    name!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): FileDto {
        const json = this.toJSON();
        let result = new FileDto();
        result.init(json);
        return result;
    }
}

export interface IFileDto {
    url?: string | undefined;
    id: string;
    name: string;
}

/** Represents different types of licenses for a piece of content or intellectual property. */
export enum LicenseType {
    Unknown = "unknown",
    PublicDomain = "publicDomain",
    CreativeCommons = "creativeCommons",
    Commercial = "commercial",
    CommercialRoyaltyFree = "commercialRoyaltyFree",
    CommercialRightsManaged = "commercialRightsManaged",
    CommercialExtended = "commercialExtended",
}

/** Represents restrictions or limitations associated with a license. */
export enum LicenseRestriction {
    Attribution = "attribution",
    NoDerivatives = "noDerivatives",
    ShareAlike = "shareAlike",
    NonCommercial = "nonCommercial",
    EditorialUseOnly = "editorialUseOnly",
    ViewerRestriction = "viewerRestriction",
    NoMobileAppUse = "noMobileAppUse",
    NoDesktopAppUse = "noDesktopAppUse",
    NoWebUse = "noWebUse",
    NoPrintUse = "noPrintUse",
    NoBroadcastUse = "noBroadcastUse",
    NoAdvertisingUse = "noAdvertisingUse",
    NoSaaSUse = "noSaaSUse",
}

export class AssetMetadataDto implements IAssetMetadataDto {
    /** Comment set in the metadata. */
    comment?: string | undefined;
    /** Title of the asset. */
    title?: string | undefined;
    /** A brief description of the asset from the metadata. */
    description?: string | undefined;
    /** The original source or creator of the asset. */
    source?: string | undefined;
    /** The orientation of the image. */
    orientation?: ImageOrientation | undefined;
    /** Whether the flash was fired when the asset was taken. */
    flashFired?: boolean | undefined;
    /** The lens model used to take the asset. */
    lensModel?: string | undefined;
    /** The focal length of the camera in millimeters. */
    focalLength?: number | undefined;
    /** Exposure time in seconds. */
    exposureTime?: number | undefined;
    /** The f-number (aperture) of the camera. */
    fNumber?: number | undefined;
    /** ISO speed of the camera. */
    isoSpeedRatings?: number | undefined;
    /** The camera model used to take the asset. */
    cameraModel?: string | undefined;
    /** Latitude where the asset was taken (EXIF data). */
    latitude?: number | undefined;
    /** Longitude where the asset was taken (EXIF data). */
    longitude?: number | undefined;
    /** Altitude where the asset was taken (EXIF data) in meters. */
    altitude?: number | undefined;
    /** Manufacturer of the camera or recording equipment. */
    make?: string | undefined;
    /** Model name of the camera or recording equipment. */
    model?: string | undefined;
    /** Name of the software that created or modified the asset. */
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    /** The duration of the asset, typically for video or audio files, in seconds. */
    duration?: string | undefined;
    /** List of codecs used for encoding the asset. */
    codecs?: string[] | undefined;
    /** The frame rate of the asset, typically for video files, in frames per second. */
    frameRate?: number | undefined;
    /** The bitrate of the asset, typically for video or audio files, in kilobits per second (kbps). */
    bitrate?: number | undefined;
    /** The total number of pages in the asset, applicable to documents. */
    pageCount?: number | undefined;

    constructor(data?: IAssetMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.source = _data["source"];
            this.orientation = _data["orientation"];
            this.flashFired = _data["flashFired"];
            this.lensModel = _data["lensModel"];
            this.focalLength = _data["focalLength"];
            this.exposureTime = _data["exposureTime"];
            this.fNumber = _data["fNumber"];
            this.isoSpeedRatings = _data["isoSpeedRatings"];
            this.cameraModel = _data["cameraModel"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.altitude = _data["altitude"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.software = _data["software"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.duration = _data["duration"];
            if (Array.isArray(_data["codecs"])) {
                this.codecs = [] as any;
                for (let item of _data["codecs"])
                    this.codecs!.push(item);
            }
            this.frameRate = _data["frameRate"];
            this.bitrate = _data["bitrate"];
            this.pageCount = _data["pageCount"];
        }
    }

    static fromJS(data: any): AssetMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        data["title"] = this.title;
        data["description"] = this.description;
        data["source"] = this.source;
        data["orientation"] = this.orientation;
        data["flashFired"] = this.flashFired;
        data["lensModel"] = this.lensModel;
        data["focalLength"] = this.focalLength;
        data["exposureTime"] = this.exposureTime;
        data["fNumber"] = this.fNumber;
        data["isoSpeedRatings"] = this.isoSpeedRatings;
        data["cameraModel"] = this.cameraModel;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["altitude"] = this.altitude;
        data["make"] = this.make;
        data["model"] = this.model;
        data["software"] = this.software;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["duration"] = this.duration;
        if (Array.isArray(this.codecs)) {
            data["codecs"] = [];
            for (let item of this.codecs)
                data["codecs"].push(item);
        }
        data["frameRate"] = this.frameRate;
        data["bitrate"] = this.bitrate;
        data["pageCount"] = this.pageCount;
        return data;
    }

    clone(): AssetMetadataDto {
        const json = this.toJSON();
        let result = new AssetMetadataDto();
        result.init(json);
        return result;
    }
}

export interface IAssetMetadataDto {
    /** Comment set in the metadata. */
    comment?: string | undefined;
    /** Title of the asset. */
    title?: string | undefined;
    /** A brief description of the asset from the metadata. */
    description?: string | undefined;
    /** The original source or creator of the asset. */
    source?: string | undefined;
    /** The orientation of the image. */
    orientation?: ImageOrientation | undefined;
    /** Whether the flash was fired when the asset was taken. */
    flashFired?: boolean | undefined;
    /** The lens model used to take the asset. */
    lensModel?: string | undefined;
    /** The focal length of the camera in millimeters. */
    focalLength?: number | undefined;
    /** Exposure time in seconds. */
    exposureTime?: number | undefined;
    /** The f-number (aperture) of the camera. */
    fNumber?: number | undefined;
    /** ISO speed of the camera. */
    isoSpeedRatings?: number | undefined;
    /** The camera model used to take the asset. */
    cameraModel?: string | undefined;
    /** Latitude where the asset was taken (EXIF data). */
    latitude?: number | undefined;
    /** Longitude where the asset was taken (EXIF data). */
    longitude?: number | undefined;
    /** Altitude where the asset was taken (EXIF data) in meters. */
    altitude?: number | undefined;
    /** Manufacturer of the camera or recording equipment. */
    make?: string | undefined;
    /** Model name of the camera or recording equipment. */
    model?: string | undefined;
    /** Name of the software that created or modified the asset. */
    software?: string | undefined;
    createdDate?: Date | undefined;
    createdBy?: string | undefined;
    /** The duration of the asset, typically for video or audio files, in seconds. */
    duration?: string | undefined;
    /** List of codecs used for encoding the asset. */
    codecs?: string[] | undefined;
    /** The frame rate of the asset, typically for video files, in frames per second. */
    frameRate?: number | undefined;
    /** The bitrate of the asset, typically for video or audio files, in kilobits per second (kbps). */
    bitrate?: number | undefined;
    /** The total number of pages in the asset, applicable to documents. */
    pageCount?: number | undefined;
}

export enum ImageOrientation {
    None = "none",
    TopLeft = "topLeft",
    TopRight = "topRight",
    BottomRight = "bottomRight",
    BottomLeft = "bottomLeft",
    LeftTop = "leftTop",
    RightTop = "rightTop",
    RightBottom = "rightBottom",
    LeftBottom = "leftBottom",
}

export class TextDisplayDto extends DisplayDto implements ITextDisplayDto {
    value!: InternationalizedString;

    constructor(data?: ITextDisplayDto) {
        super(data);
        if (!data) {
            this.value = new InternationalizedString();
        }
        this._discriminator = "TextDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? InternationalizedString.fromJS(_data["value"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): TextDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TextDisplayDto {
        const json = this.toJSON();
        let result = new TextDisplayDto();
        result.init(json);
        return result;
    }
}

export interface ITextDisplayDto extends IDisplayDto {
    value: InternationalizedString;
}

export class RichTextDisplayDto extends DisplayDto implements IRichTextDisplayDto {
    value!: InternationalizedDocument;

    constructor(data?: IRichTextDisplayDto) {
        super(data);
        if (!data) {
            this.value = new InternationalizedDocument();
        }
        this._discriminator = "RichTextDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? InternationalizedDocument.fromJS(_data["value"]) : new InternationalizedDocument();
        }
    }

    static override fromJS(data: any): RichTextDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new RichTextDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): RichTextDisplayDto {
        const json = this.toJSON();
        let result = new RichTextDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IRichTextDisplayDto extends IDisplayDto {
    value: InternationalizedDocument;
}

export class InternationalizedDocument implements IInternationalizedDocument {
    translations!: { [key: string]: Node; };

    constructor(data?: IInternationalizedDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.translations = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key] ? Node.fromJS(_data["translations"][key]) : new Node();
                }
            }
        }
    }

    static fromJS(data: any): InternationalizedDocument {
        data = typeof data === 'object' ? data : {};
        let result = new InternationalizedDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = this.translations[key] ? this.translations[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }

    clone(): InternationalizedDocument {
        const json = this.toJSON();
        let result = new InternationalizedDocument();
        result.init(json);
        return result;
    }
}

export interface IInternationalizedDocument {
    translations: { [key: string]: Node; };
}

export class Node implements INode {
    type!: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;

    constructor(data?: INode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? NodeAttribute.fromJS(_data["attrs"]) : <any>undefined;
            if (Array.isArray(_data["content"])) {
                this.content = [] as any;
                for (let item of _data["content"])
                    this.content!.push(Node.fromJS(item));
            }
            if (Array.isArray(_data["marks"])) {
                this.marks = [] as any;
                for (let item of _data["marks"])
                    this.marks!.push(Mark.fromJS(item));
            }
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Node {
        data = typeof data === 'object' ? data : {};
        let result = new Node();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : <any>undefined;
        if (Array.isArray(this.content)) {
            data["content"] = [];
            for (let item of this.content)
                data["content"].push(item.toJSON());
        }
        if (Array.isArray(this.marks)) {
            data["marks"] = [];
            for (let item of this.marks)
                data["marks"].push(item.toJSON());
        }
        data["text"] = this.text;
        return data;
    }

    clone(): Node {
        const json = this.toJSON();
        let result = new Node();
        result.init(json);
        return result;
    }
}

export interface INode {
    type: NodeType;
    attrs?: NodeAttribute | undefined;
    content?: Node[] | undefined;
    marks?: Mark[] | undefined;
    text?: string | undefined;
}

export enum NodeType {
    Blockquote = "blockquote",
    BulletList = "bulletList",
    Doc = "doc",
    HardBreak = "hardBreak",
    Heading = "heading",
    HorizontalRule = "horizontalRule",
    ListItem = "listItem",
    OrderedList = "orderedList",
    Paragraph = "paragraph",
    Table = "table",
    TableRow = "tableRow",
    TableHeader = "tableHeader",
    TableCell = "tableCell",
    Text = "text",
    Video = "video",
    Audio = "audio",
    Image = "image",
    Html = "html",
    Details = "details",
    DetailsSummary = "detailsSummary",
    DetailsContent = "detailsContent",
    Figure = "figure",
    Figcaption = "figcaption",
    Panel = "panel",
}

export class NodeAttribute implements INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;

    constructor(data?: INodeAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.display = _data["display"];
            this.level = _data["level"];
            this.textAlign = _data["textAlign"];
            this.colspan = _data["colspan"];
            this.rowspan = _data["rowspan"];
            this.colwidth = _data["colwidth"];
            this.start = _data["start"];
            this.assetId = _data["assetId"];
            this.src = _data["src"];
            this.alt = _data["alt"];
            this.title = _data["title"];
            this.caption = _data["caption"];
            this.html = _data["html"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): NodeAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new NodeAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["display"] = this.display;
        data["level"] = this.level;
        data["textAlign"] = this.textAlign;
        data["colspan"] = this.colspan;
        data["rowspan"] = this.rowspan;
        data["colwidth"] = this.colwidth;
        data["start"] = this.start;
        data["assetId"] = this.assetId;
        data["src"] = this.src;
        data["alt"] = this.alt;
        data["title"] = this.title;
        data["caption"] = this.caption;
        data["html"] = this.html;
        data["type"] = this.type;
        return data;
    }

    clone(): NodeAttribute {
        const json = this.toJSON();
        let result = new NodeAttribute();
        result.init(json);
        return result;
    }
}

export interface INodeAttribute {
    display?: string | undefined;
    level?: number | undefined;
    textAlign?: string | undefined;
    colspan?: number | undefined;
    rowspan?: number | undefined;
    colwidth?: number | undefined;
    start?: number | undefined;
    assetId?: string | undefined;
    src?: string | undefined;
    alt?: string | undefined;
    title?: string | undefined;
    caption?: string | undefined;
    html?: string | undefined;
    type?: string | undefined;
}

export class Mark implements IMark {
    type!: MarkType;
    attrs?: MarkAttribute | undefined;

    constructor(data?: IMark) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.attrs = _data["attrs"] ? MarkAttribute.fromJS(_data["attrs"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Mark {
        data = typeof data === 'object' ? data : {};
        let result = new Mark();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["attrs"] = this.attrs ? this.attrs.toJSON() : <any>undefined;
        return data;
    }

    clone(): Mark {
        const json = this.toJSON();
        let result = new Mark();
        result.init(json);
        return result;
    }
}

export interface IMark {
    type: MarkType;
    attrs?: MarkAttribute | undefined;
}

export enum MarkType {
    Bold = "bold",
    Italic = "italic",
    Link = "link",
    Strike = "strike",
    Subscript = "subscript",
    Superscript = "superscript",
    Underline = "underline",
    Reference = "reference",
}

export class MarkAttribute implements IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;

    constructor(data?: IMarkAttribute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.target = _data["target"];
            this.title = _data["title"];
            this.class = _data["class"];
            this.rel = _data["rel"];
            this.href = _data["href"];
            this.fileId = _data["fileId"];
            this.referenceId = _data["referenceId"];
            this.referenceType = _data["referenceType"];
        }
    }

    static fromJS(data: any): MarkAttribute {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAttribute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["title"] = this.title;
        data["class"] = this.class;
        data["rel"] = this.rel;
        data["href"] = this.href;
        data["fileId"] = this.fileId;
        data["referenceId"] = this.referenceId;
        data["referenceType"] = this.referenceType;
        return data;
    }

    clone(): MarkAttribute {
        const json = this.toJSON();
        let result = new MarkAttribute();
        result.init(json);
        return result;
    }
}

export interface IMarkAttribute {
    target?: string | undefined;
    title?: string | undefined;
    class?: string | undefined;
    rel?: string | undefined;
    href?: string | undefined;
    fileId?: string | undefined;
    referenceId?: string | undefined;
    referenceType?: ReferenceType | undefined;
}

export enum ReferenceType {
    Asset = "asset",
    Page = "page",
}

export class QuestionnaireReferenceDisplayDto extends DisplayDto implements IQuestionnaireReferenceDisplayDto {
    questionnaireId?: string | undefined;

    constructor(data?: IQuestionnaireReferenceDisplayDto) {
        super(data);
        this._discriminator = "QuestionnaireReferenceDisplayDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static override fromJS(data: any): QuestionnaireReferenceDisplayDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireReferenceDisplayDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireReferenceDisplayDto {
        const json = this.toJSON();
        let result = new QuestionnaireReferenceDisplayDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireReferenceDisplayDto extends IDisplayDto {
    questionnaireId?: string | undefined;
}

export abstract class PropertyDto extends ContentDto implements IPropertyDto {
    text!: InternationalizedString;

    constructor(data?: IPropertyDto) {
        super(data);
        if (!data) {
            this.text = new InternationalizedString();
        }
        this._discriminator = "PropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] ? InternationalizedString.fromJS(_data["text"]) : new InternationalizedString();
        }
    }

    static override fromJS(data: any): PropertyDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TextPropertyDto") {
            let result = new TextPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyDto") {
            let result = new NumberPropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyDto") {
            let result = new DatePropertyDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyDto") {
            let result = new ChoicePropertyDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): PropertyDto {
        throw new Error("The abstract class 'PropertyDto' cannot be instantiated.");
    }
}

export interface IPropertyDto extends IContentDto {
    text: InternationalizedString;
}

export class TextPropertyDto extends PropertyDto implements ITextPropertyDto {
    validation!: TextPropertyValidation;
    multiline!: boolean;

    constructor(data?: ITextPropertyDto) {
        super(data);
        if (!data) {
            this.validation = new TextPropertyValidation();
        }
        this._discriminator = "TextPropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? TextPropertyValidation.fromJS(_data["validation"]) : new TextPropertyValidation();
            this.multiline = _data["multiline"];
        }
    }

    static override fromJS(data: any): TextPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextPropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiline"] = this.multiline;
        super.toJSON(data);
        return data;
    }

    clone(): TextPropertyDto {
        const json = this.toJSON();
        let result = new TextPropertyDto();
        result.init(json);
        return result;
    }
}

export interface ITextPropertyDto extends IPropertyDto {
    validation: TextPropertyValidation;
    multiline: boolean;
}

export abstract class PropertyValidation implements IPropertyValidation {
    required!: boolean;

    protected _discriminator: string;

    constructor(data?: IPropertyValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "PropertyValidation";
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): PropertyValidation {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "TextPropertyValidation") {
            let result = new TextPropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DatePropertyValidation") {
            let result = new DatePropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberPropertyValidation") {
            let result = new NumberPropertyValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoicePropertyValidation") {
            let result = new ChoicePropertyValidation();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'PropertyValidation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["required"] = this.required;
        return data;
    }

    clone(): PropertyValidation {
        throw new Error("The abstract class 'PropertyValidation' cannot be instantiated.");
    }
}

export interface IPropertyValidation {
    required: boolean;
}

export class TextPropertyValidation extends PropertyValidation implements ITextPropertyValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;

    constructor(data?: ITextPropertyValidation) {
        super(data);
        this._discriminator = "TextPropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.pattern = _data["pattern"];
        }
    }

    static override fromJS(data: any): TextPropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TextPropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["pattern"] = this.pattern;
        super.toJSON(data);
        return data;
    }

    clone(): TextPropertyValidation {
        const json = this.toJSON();
        let result = new TextPropertyValidation();
        result.init(json);
        return result;
    }
}

export interface ITextPropertyValidation extends IPropertyValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;
}

export class DatePropertyValidation extends PropertyValidation implements IDatePropertyValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDatePropertyValidation) {
        super(data);
        this._discriminator = "DatePropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): DatePropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DatePropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : <any>undefined;
        data["max"] = this.max ? formatDate(this.max) : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DatePropertyValidation {
        const json = this.toJSON();
        let result = new DatePropertyValidation();
        result.init(json);
        return result;
    }
}

export interface IDatePropertyValidation extends IPropertyValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class NumberPropertyValidation extends PropertyValidation implements INumberPropertyValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction!: boolean;

    constructor(data?: INumberPropertyValidation) {
        super(data);
        this._discriminator = "NumberPropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.fraction = _data["fraction"];
        }
    }

    static override fromJS(data: any): NumberPropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new NumberPropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["fraction"] = this.fraction;
        super.toJSON(data);
        return data;
    }

    clone(): NumberPropertyValidation {
        const json = this.toJSON();
        let result = new NumberPropertyValidation();
        result.init(json);
        return result;
    }
}

export interface INumberPropertyValidation extends IPropertyValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction: boolean;
}

export class ChoicePropertyValidation extends PropertyValidation implements IChoicePropertyValidation {

    constructor(data?: IChoicePropertyValidation) {
        super(data);
        this._discriminator = "ChoicePropertyValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChoicePropertyValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ChoicePropertyValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ChoicePropertyValidation {
        const json = this.toJSON();
        let result = new ChoicePropertyValidation();
        result.init(json);
        return result;
    }
}

export interface IChoicePropertyValidation extends IPropertyValidation {
}

export class NumberPropertyDto extends PropertyDto implements INumberPropertyDto {
    validation!: NumberPropertyValidation;

    constructor(data?: INumberPropertyDto) {
        super(data);
        if (!data) {
            this.validation = new NumberPropertyValidation();
        }
        this._discriminator = "NumberPropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? NumberPropertyValidation.fromJS(_data["validation"]) : new NumberPropertyValidation();
        }
    }

    static override fromJS(data: any): NumberPropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberPropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NumberPropertyDto {
        const json = this.toJSON();
        let result = new NumberPropertyDto();
        result.init(json);
        return result;
    }
}

export interface INumberPropertyDto extends IPropertyDto {
    validation: NumberPropertyValidation;
}

export class DatePropertyDto extends PropertyDto implements IDatePropertyDto {
    validation!: DatePropertyValidation;

    constructor(data?: IDatePropertyDto) {
        super(data);
        if (!data) {
            this.validation = new DatePropertyValidation();
        }
        this._discriminator = "DatePropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? DatePropertyValidation.fromJS(_data["validation"]) : new DatePropertyValidation();
        }
    }

    static override fromJS(data: any): DatePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new DatePropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DatePropertyDto {
        const json = this.toJSON();
        let result = new DatePropertyDto();
        result.init(json);
        return result;
    }
}

export interface IDatePropertyDto extends IPropertyDto {
    validation: DatePropertyValidation;
}

export class ChoicePropertyDto extends PropertyDto implements IChoicePropertyDto {
    validation!: ChoicePropertyValidation;
    multiSelection!: boolean;
    choices!: SelectionItem[];

    constructor(data?: IChoicePropertyDto) {
        super(data);
        if (!data) {
            this.validation = new ChoicePropertyValidation();
            this.choices = [];
        }
        this._discriminator = "ChoicePropertyDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ChoicePropertyValidation.fromJS(_data["validation"]) : new ChoicePropertyValidation();
            this.multiSelection = _data["multiSelection"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SelectionItem.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ChoicePropertyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoicePropertyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiSelection"] = this.multiSelection;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChoicePropertyDto {
        const json = this.toJSON();
        let result = new ChoicePropertyDto();
        result.init(json);
        return result;
    }
}

export interface IChoicePropertyDto extends IPropertyDto {
    validation: ChoicePropertyValidation;
    multiSelection: boolean;
    choices: SelectionItem[];
}

export class SelectionItem implements ISelectionItem {
    id!: string;
    value!: string;
    label!: InternationalizedString;

    constructor(data?: ISelectionItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
        }
    }

    static fromJS(data: any): SelectionItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelectionItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label ? this.label.toJSON() : <any>undefined;
        return data;
    }

    clone(): SelectionItem {
        const json = this.toJSON();
        let result = new SelectionItem();
        result.init(json);
        return result;
    }
}

export interface ISelectionItem {
    id: string;
    value: string;
    label: InternationalizedString;
}

export abstract class QuestionDto extends ContentDto implements IQuestionDto {
    text!: InternationalizedString;
    hint?: InternationalizedDocument | undefined;

    constructor(data?: IQuestionDto) {
        super(data);
        if (!data) {
            this.text = new InternationalizedString();
        }
        this._discriminator = "QuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.text = _data["text"] ? InternationalizedString.fromJS(_data["text"]) : new InternationalizedString();
            this.hint = _data["hint"] ? InternationalizedDocument.fromJS(_data["hint"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): QuestionDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertQuestionDto") {
            let result = new LikertQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionDto") {
            let result = new MatrixQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionDto") {
            let result = new ChoiceQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionDto") {
            let result = new ContainerQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionDto") {
            let result = new BoolQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionDto") {
            let result = new TextQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionDto") {
            let result = new NumberQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionDto") {
            let result = new DateQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionDto") {
            let result = new TimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionDto") {
            let result = new DateTimeQuestionDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionDto") {
            let result = new SliderQuestionDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text ? this.text.toJSON() : <any>undefined;
        data["hint"] = this.hint ? this.hint.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionDto {
        throw new Error("The abstract class 'QuestionDto' cannot be instantiated.");
    }
}

export interface IQuestionDto extends IContentDto {
    text: InternationalizedString;
    hint?: InternationalizedDocument | undefined;
}

export class LikertQuestionDto extends QuestionDto implements ILikertQuestionDto {
    validation!: LikertQuestionValidation;
    scale!: LikertScaleItem[];
    answer?: LikertAnswerDto | undefined;

    constructor(data?: ILikertQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new LikertQuestionValidation();
            this.scale = [];
        }
        this._discriminator = "LikertQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? LikertQuestionValidation.fromJS(_data["validation"]) : new LikertQuestionValidation();
            if (Array.isArray(_data["scale"])) {
                this.scale = [] as any;
                for (let item of _data["scale"])
                    this.scale!.push(LikertScaleItem.fromJS(item));
            }
            this.answer = _data["answer"] ? LikertAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): LikertQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        if (Array.isArray(this.scale)) {
            data["scale"] = [];
            for (let item of this.scale)
                data["scale"].push(item.toJSON());
        }
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): LikertQuestionDto {
        const json = this.toJSON();
        let result = new LikertQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ILikertQuestionDto extends IQuestionDto {
    validation: LikertQuestionValidation;
    scale: LikertScaleItem[];
    answer?: LikertAnswerDto | undefined;
}

export abstract class QuestionValidation implements IQuestionValidation {
    required!: boolean;

    protected _discriminator: string;

    constructor(data?: IQuestionValidation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "QuestionValidation";
    }

    init(_data?: any) {
        if (_data) {
            this.required = _data["required"];
        }
    }

    static fromJS(data: any): QuestionValidation {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertQuestionValidation") {
            let result = new LikertQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceQuestionValidation") {
            let result = new ChoiceQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateQuestionValidation") {
            let result = new DateQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeQuestionValidation") {
            let result = new DateTimeQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixQuestionValidation") {
            let result = new MatrixQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberQuestionValidation") {
            let result = new NumberQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderQuestionValidation") {
            let result = new SliderQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextQuestionValidation") {
            let result = new TextQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeQuestionValidation") {
            let result = new TimeQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolQuestionValidation") {
            let result = new BoolQuestionValidation();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerQuestionValidation") {
            let result = new ContainerQuestionValidation();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QuestionValidation' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["required"] = this.required;
        return data;
    }

    clone(): QuestionValidation {
        throw new Error("The abstract class 'QuestionValidation' cannot be instantiated.");
    }
}

export interface IQuestionValidation {
    required: boolean;
}

export class LikertQuestionValidation extends QuestionValidation implements ILikertQuestionValidation {

    constructor(data?: ILikertQuestionValidation) {
        super(data);
        this._discriminator = "LikertQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LikertQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new LikertQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): LikertQuestionValidation {
        const json = this.toJSON();
        let result = new LikertQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ILikertQuestionValidation extends IQuestionValidation {
}

export class ChoiceQuestionValidation extends QuestionValidation implements IChoiceQuestionValidation {

    constructor(data?: IChoiceQuestionValidation) {
        super(data);
        this._discriminator = "ChoiceQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ChoiceQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceQuestionValidation {
        const json = this.toJSON();
        let result = new ChoiceQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IChoiceQuestionValidation extends IQuestionValidation {
}

export class DateQuestionValidation extends QuestionValidation implements IDateQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDateQuestionValidation) {
        super(data);
        this._discriminator = "DateQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): DateQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DateQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : <any>undefined;
        data["max"] = this.max ? formatDate(this.max) : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DateQuestionValidation {
        const json = this.toJSON();
        let result = new DateQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IDateQuestionValidation extends IQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class DateTimeQuestionValidation extends QuestionValidation implements IDateTimeQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;

    constructor(data?: IDateTimeQuestionValidation) {
        super(data);
        this._discriminator = "DateTimeQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): DateTimeQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? this.min.toISOString() : <any>undefined;
        data["max"] = this.max ? this.max.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeQuestionValidation {
        const json = this.toJSON();
        let result = new DateTimeQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IDateTimeQuestionValidation extends IQuestionValidation {
    min?: Date | undefined;
    max?: Date | undefined;
}

export class MatrixQuestionValidation extends QuestionValidation implements IMatrixQuestionValidation {

    constructor(data?: IMatrixQuestionValidation) {
        super(data);
        this._discriminator = "MatrixQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MatrixQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): MatrixQuestionValidation {
        const json = this.toJSON();
        let result = new MatrixQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IMatrixQuestionValidation extends IQuestionValidation {
}

export class NumberQuestionValidation extends QuestionValidation implements INumberQuestionValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction!: boolean;

    constructor(data?: INumberQuestionValidation) {
        super(data);
        this._discriminator = "NumberQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.fraction = _data["fraction"];
        }
    }

    static override fromJS(data: any): NumberQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new NumberQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["fraction"] = this.fraction;
        super.toJSON(data);
        return data;
    }

    clone(): NumberQuestionValidation {
        const json = this.toJSON();
        let result = new NumberQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface INumberQuestionValidation extends IQuestionValidation {
    min?: number | undefined;
    max?: number | undefined;
    fraction: boolean;
}

export class SliderQuestionValidation extends QuestionValidation implements ISliderQuestionValidation {
    min!: number;
    max!: number;

    constructor(data?: ISliderQuestionValidation) {
        super(data);
        this._discriminator = "SliderQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static override fromJS(data: any): SliderQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new SliderQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        super.toJSON(data);
        return data;
    }

    clone(): SliderQuestionValidation {
        const json = this.toJSON();
        let result = new SliderQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ISliderQuestionValidation extends IQuestionValidation {
    min: number;
    max: number;
}

export class TextQuestionValidation extends QuestionValidation implements ITextQuestionValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;

    constructor(data?: ITextQuestionValidation) {
        super(data);
        this._discriminator = "TextQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLength = _data["minLength"];
            this.maxLength = _data["maxLength"];
            this.pattern = _data["pattern"];
        }
    }

    static override fromJS(data: any): TextQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLength"] = this.minLength;
        data["maxLength"] = this.maxLength;
        data["pattern"] = this.pattern;
        super.toJSON(data);
        return data;
    }

    clone(): TextQuestionValidation {
        const json = this.toJSON();
        let result = new TextQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ITextQuestionValidation extends IQuestionValidation {
    minLength?: number | undefined;
    maxLength?: number | undefined;
    pattern?: string | undefined;
}

export class TimeQuestionValidation extends QuestionValidation implements ITimeQuestionValidation {
    min?: string | undefined;
    max?: string | undefined;

    constructor(data?: ITimeQuestionValidation) {
        super(data);
        this._discriminator = "TimeQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
        }
    }

    static override fromJS(data: any): TimeQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new TimeQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        super.toJSON(data);
        return data;
    }

    clone(): TimeQuestionValidation {
        const json = this.toJSON();
        let result = new TimeQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface ITimeQuestionValidation extends IQuestionValidation {
    min?: string | undefined;
    max?: string | undefined;
}

export class BoolQuestionValidation extends QuestionValidation implements IBoolQuestionValidation {

    constructor(data?: IBoolQuestionValidation) {
        super(data);
        this._discriminator = "BoolQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): BoolQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new BoolQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): BoolQuestionValidation {
        const json = this.toJSON();
        let result = new BoolQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IBoolQuestionValidation extends IQuestionValidation {
}

export class ContainerQuestionValidation extends QuestionValidation implements IContainerQuestionValidation {

    constructor(data?: IContainerQuestionValidation) {
        super(data);
        this._discriminator = "ContainerQuestionValidation";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContainerQuestionValidation {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerQuestionValidation();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContainerQuestionValidation {
        const json = this.toJSON();
        let result = new ContainerQuestionValidation();
        result.init(json);
        return result;
    }
}

export interface IContainerQuestionValidation extends IQuestionValidation {
}

export class LikertScaleItem implements ILikertScaleItem {
    id!: string;
    value!: string;
    label!: InternationalizedString;

    constructor(data?: ILikertScaleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
        }
    }

    static fromJS(data: any): LikertScaleItem {
        data = typeof data === 'object' ? data : {};
        let result = new LikertScaleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["label"] = this.label ? this.label.toJSON() : <any>undefined;
        return data;
    }

    clone(): LikertScaleItem {
        const json = this.toJSON();
        let result = new LikertScaleItem();
        result.init(json);
        return result;
    }
}

export interface ILikertScaleItem {
    id: string;
    value: string;
    label: InternationalizedString;
}

export abstract class AnswerDto implements IAnswerDto {
    questionId!: string;
    answered?: Date | undefined;

    protected _discriminator: string;

    constructor(data?: IAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerDto";
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answered = _data["answered"] ? new Date(_data["answered"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AnswerDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "LikertAnswerDto") {
            let result = new LikertAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ChoiceAnswerDto") {
            let result = new ChoiceAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateAnswerDto") {
            let result = new DateAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeAnswerDto") {
            let result = new DateTimeAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "MatrixAnswerDto") {
            let result = new MatrixAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberAnswerDto") {
            let result = new NumberAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderAnswerDto") {
            let result = new SliderAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextAnswerDto") {
            let result = new TextAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeAnswerDto") {
            let result = new TimeAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerAnswerDto") {
            let result = new ContainerAnswerDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolAnswerDto") {
            let result = new BoolAnswerDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["questionId"] = this.questionId;
        data["answered"] = this.answered ? this.answered.toISOString() : <any>undefined;
        return data;
    }

    clone(): AnswerDto {
        throw new Error("The abstract class 'AnswerDto' cannot be instantiated.");
    }
}

export interface IAnswerDto {
    questionId: string;
    answered?: Date | undefined;
}

export class LikertAnswerDto extends AnswerDto implements ILikertAnswerDto {
    value?: string | undefined;

    constructor(data?: ILikertAnswerDto) {
        super(data);
        this._discriminator = "LikertAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): LikertAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): LikertAnswerDto {
        const json = this.toJSON();
        let result = new LikertAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ILikertAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class ChoiceAnswerDto extends AnswerDto implements IChoiceAnswerDto {
    values?: string[] | undefined;

    constructor(data?: IChoiceAnswerDto) {
        super(data);
        this._discriminator = "ChoiceAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ChoiceAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceAnswerDto {
        const json = this.toJSON();
        let result = new ChoiceAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceAnswerDto extends IAnswerDto {
    values?: string[] | undefined;
}

export class DateAnswerDto extends AnswerDto implements IDateAnswerDto {
    values?: Date[] | undefined;

    constructor(data?: IDateAnswerDto) {
        super(data);
        this._discriminator = "DateAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(new Date(item));
            }
        }
    }

    static override fromJS(data: any): DateAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(formatDate(item));
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateAnswerDto {
        const json = this.toJSON();
        let result = new DateAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IDateAnswerDto extends IAnswerDto {
    values?: Date[] | undefined;
}

export class DateTimeAnswerDto extends AnswerDto implements IDateTimeAnswerDto {
    value?: Date | undefined;

    constructor(data?: IDateTimeAnswerDto) {
        super(data);
        this._discriminator = "DateTimeAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] ? new Date(_data["value"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): DateTimeAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeAnswerDto {
        const json = this.toJSON();
        let result = new DateTimeAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeAnswerDto extends IAnswerDto {
    value?: Date | undefined;
}

export class MatrixAnswerDto extends AnswerDto implements IMatrixAnswerDto {
    values?: { [key: string]: string; } | undefined;

    constructor(data?: IMatrixAnswerDto) {
        super(data);
        this._discriminator = "MatrixAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["values"]) {
                this.values = {} as any;
                for (let key in _data["values"]) {
                    if (_data["values"].hasOwnProperty(key))
                        (<any>this.values)![key] = _data["values"][key];
                }
            }
        }
    }

    static override fromJS(data: any): MatrixAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.values) {
            data["values"] = {};
            for (let key in this.values) {
                if (this.values.hasOwnProperty(key))
                    (<any>data["values"])[key] = (<any>this.values)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): MatrixAnswerDto {
        const json = this.toJSON();
        let result = new MatrixAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IMatrixAnswerDto extends IAnswerDto {
    values?: { [key: string]: string; } | undefined;
}

export class NumberAnswerDto extends AnswerDto implements INumberAnswerDto {
    value?: number | undefined;

    constructor(data?: INumberAnswerDto) {
        super(data);
        this._discriminator = "NumberAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): NumberAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): NumberAnswerDto {
        const json = this.toJSON();
        let result = new NumberAnswerDto();
        result.init(json);
        return result;
    }
}

export interface INumberAnswerDto extends IAnswerDto {
    value?: number | undefined;
}

export class SliderAnswerDto extends AnswerDto implements ISliderAnswerDto {
    value?: number | undefined;

    constructor(data?: ISliderAnswerDto) {
        super(data);
        this._discriminator = "SliderAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): SliderAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): SliderAnswerDto {
        const json = this.toJSON();
        let result = new SliderAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ISliderAnswerDto extends IAnswerDto {
    value?: number | undefined;
}

export class TextAnswerDto extends AnswerDto implements ITextAnswerDto {
    value?: string | undefined;

    constructor(data?: ITextAnswerDto) {
        super(data);
        this._discriminator = "TextAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TextAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): TextAnswerDto {
        const json = this.toJSON();
        let result = new TextAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITextAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class TimeAnswerDto extends AnswerDto implements ITimeAnswerDto {
    value?: string | undefined;

    constructor(data?: ITimeAnswerDto) {
        super(data);
        this._discriminator = "TimeAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): TimeAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): TimeAnswerDto {
        const json = this.toJSON();
        let result = new TimeAnswerDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAnswerDto extends IAnswerDto {
    value?: string | undefined;
}

export class ContainerAnswerDto extends AnswerDto implements IContainerAnswerDto {
    values?: string[] | undefined;

    constructor(data?: IContainerAnswerDto) {
        super(data);
        this._discriminator = "ContainerAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static override fromJS(data: any): ContainerAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerAnswerDto {
        const json = this.toJSON();
        let result = new ContainerAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IContainerAnswerDto extends IAnswerDto {
    values?: string[] | undefined;
}

export class BoolAnswerDto extends AnswerDto implements IBoolAnswerDto {
    value?: boolean | undefined;

    constructor(data?: IBoolAnswerDto) {
        super(data);
        this._discriminator = "BoolAnswerDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static override fromJS(data: any): BoolAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolAnswerDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }

    clone(): BoolAnswerDto {
        const json = this.toJSON();
        let result = new BoolAnswerDto();
        result.init(json);
        return result;
    }
}

export interface IBoolAnswerDto extends IAnswerDto {
    value?: boolean | undefined;
}

export class MatrixQuestionDto extends QuestionDto implements IMatrixQuestionDto {
    validation!: MatrixQuestionValidation;
    xScale!: SelectionItem[];
    yScale!: SelectionItem[];
    answer?: MatrixAnswerDto | undefined;

    constructor(data?: IMatrixQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new MatrixQuestionValidation();
            this.xScale = [];
            this.yScale = [];
        }
        this._discriminator = "MatrixQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? MatrixQuestionValidation.fromJS(_data["validation"]) : new MatrixQuestionValidation();
            if (Array.isArray(_data["xScale"])) {
                this.xScale = [] as any;
                for (let item of _data["xScale"])
                    this.xScale!.push(SelectionItem.fromJS(item));
            }
            if (Array.isArray(_data["yScale"])) {
                this.yScale = [] as any;
                for (let item of _data["yScale"])
                    this.yScale!.push(SelectionItem.fromJS(item));
            }
            this.answer = _data["answer"] ? MatrixAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): MatrixQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MatrixQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        if (Array.isArray(this.xScale)) {
            data["xScale"] = [];
            for (let item of this.xScale)
                data["xScale"].push(item.toJSON());
        }
        if (Array.isArray(this.yScale)) {
            data["yScale"] = [];
            for (let item of this.yScale)
                data["yScale"].push(item.toJSON());
        }
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): MatrixQuestionDto {
        const json = this.toJSON();
        let result = new MatrixQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IMatrixQuestionDto extends IQuestionDto {
    validation: MatrixQuestionValidation;
    xScale: SelectionItem[];
    yScale: SelectionItem[];
    answer?: MatrixAnswerDto | undefined;
}

export class ChoiceQuestionDto extends QuestionDto implements IChoiceQuestionDto {
    validation!: ChoiceQuestionValidation;
    multiSelection!: boolean;
    choices!: SelectionItem[];
    answer?: ChoiceAnswerDto | undefined;

    constructor(data?: IChoiceQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new ChoiceQuestionValidation();
            this.choices = [];
        }
        this._discriminator = "ChoiceQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ChoiceQuestionValidation.fromJS(_data["validation"]) : new ChoiceQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            if (Array.isArray(_data["choices"])) {
                this.choices = [] as any;
                for (let item of _data["choices"])
                    this.choices!.push(SelectionItem.fromJS(item));
            }
            this.answer = _data["answer"] ? ChoiceAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ChoiceQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiSelection"] = this.multiSelection;
        if (Array.isArray(this.choices)) {
            data["choices"] = [];
            for (let item of this.choices)
                data["choices"].push(item.toJSON());
        }
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceQuestionDto {
        const json = this.toJSON();
        let result = new ChoiceQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceQuestionDto extends IQuestionDto {
    validation: ChoiceQuestionValidation;
    multiSelection: boolean;
    choices: SelectionItem[];
    answer?: ChoiceAnswerDto | undefined;
}

export class ContainerQuestionDto extends QuestionDto implements IContainerQuestionDto {
    validation!: ContainerQuestionValidation;
    multiSelection!: boolean;
    containerType!: ContainerType;
    containerId!: string;
    answer?: ContainerAnswerDto | undefined;

    constructor(data?: IContainerQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new ContainerQuestionValidation();
        }
        this._discriminator = "ContainerQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? ContainerQuestionValidation.fromJS(_data["validation"]) : new ContainerQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            this.containerType = _data["containerType"];
            this.containerId = _data["containerId"];
            this.answer = _data["answer"] ? ContainerAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ContainerQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiSelection"] = this.multiSelection;
        data["containerType"] = this.containerType;
        data["containerId"] = this.containerId;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ContainerQuestionDto {
        const json = this.toJSON();
        let result = new ContainerQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IContainerQuestionDto extends IQuestionDto {
    validation: ContainerQuestionValidation;
    multiSelection: boolean;
    containerType: ContainerType;
    containerId: string;
    answer?: ContainerAnswerDto | undefined;
}

export enum ContainerType {
    Questionnaire = "questionnaire",
    ContextObject = "contextObject",
    AppPage = "appPage",
}

export class BoolQuestionDto extends QuestionDto implements IBoolQuestionDto {
    validation!: BoolQuestionValidation;
    trueLabel!: InternationalizedString;
    falseLabel!: InternationalizedString;
    answer?: BoolAnswerDto | undefined;

    constructor(data?: IBoolQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new BoolQuestionValidation();
            this.trueLabel = new InternationalizedString();
            this.falseLabel = new InternationalizedString();
        }
        this._discriminator = "BoolQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? BoolQuestionValidation.fromJS(_data["validation"]) : new BoolQuestionValidation();
            this.trueLabel = _data["trueLabel"] ? InternationalizedString.fromJS(_data["trueLabel"]) : new InternationalizedString();
            this.falseLabel = _data["falseLabel"] ? InternationalizedString.fromJS(_data["falseLabel"]) : new InternationalizedString();
            this.answer = _data["answer"] ? BoolAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): BoolQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["trueLabel"] = this.trueLabel ? this.trueLabel.toJSON() : <any>undefined;
        data["falseLabel"] = this.falseLabel ? this.falseLabel.toJSON() : <any>undefined;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): BoolQuestionDto {
        const json = this.toJSON();
        let result = new BoolQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IBoolQuestionDto extends IQuestionDto {
    validation: BoolQuestionValidation;
    trueLabel: InternationalizedString;
    falseLabel: InternationalizedString;
    answer?: BoolAnswerDto | undefined;
}

export class TextQuestionDto extends QuestionDto implements ITextQuestionDto {
    validation!: TextQuestionValidation;
    multiline!: boolean;
    answer?: TextAnswerDto | undefined;

    constructor(data?: ITextQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new TextQuestionValidation();
        }
        this._discriminator = "TextQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? TextQuestionValidation.fromJS(_data["validation"]) : new TextQuestionValidation();
            this.multiline = _data["multiline"];
            this.answer = _data["answer"] ? TextAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TextQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiline"] = this.multiline;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TextQuestionDto {
        const json = this.toJSON();
        let result = new TextQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ITextQuestionDto extends IQuestionDto {
    validation: TextQuestionValidation;
    multiline: boolean;
    answer?: TextAnswerDto | undefined;
}

export class NumberQuestionDto extends QuestionDto implements INumberQuestionDto {
    validation!: NumberQuestionValidation;
    answer?: NumberAnswerDto | undefined;

    constructor(data?: INumberQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new NumberQuestionValidation();
        }
        this._discriminator = "NumberQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? NumberQuestionValidation.fromJS(_data["validation"]) : new NumberQuestionValidation();
            this.answer = _data["answer"] ? NumberAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): NumberQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): NumberQuestionDto {
        const json = this.toJSON();
        let result = new NumberQuestionDto();
        result.init(json);
        return result;
    }
}

export interface INumberQuestionDto extends IQuestionDto {
    validation: NumberQuestionValidation;
    answer?: NumberAnswerDto | undefined;
}

export class DateQuestionDto extends QuestionDto implements IDateQuestionDto {
    validation!: DateQuestionValidation;
    multiSelection!: boolean;
    answer?: DateAnswerDto | undefined;

    constructor(data?: IDateQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new DateQuestionValidation();
        }
        this._discriminator = "DateQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.validation = _data["validation"] ? DateQuestionValidation.fromJS(_data["validation"]) : new DateQuestionValidation();
            this.multiSelection = _data["multiSelection"];
            this.answer = _data["answer"] ? DateAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DateQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["multiSelection"] = this.multiSelection;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DateQuestionDto {
        const json = this.toJSON();
        let result = new DateQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IDateQuestionDto extends IQuestionDto {
    validation: DateQuestionValidation;
    multiSelection: boolean;
    answer?: DateAnswerDto | undefined;
}

export class TimeQuestionDto extends QuestionDto implements ITimeQuestionDto {
    minuteIncrements?: number | undefined;
    validation!: TimeQuestionValidation;
    answer?: TimeAnswerDto | undefined;

    constructor(data?: ITimeQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new TimeQuestionValidation();
        }
        this._discriminator = "TimeQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minuteIncrements = _data["minuteIncrements"];
            this.validation = _data["validation"] ? TimeQuestionValidation.fromJS(_data["validation"]) : new TimeQuestionValidation();
            this.answer = _data["answer"] ? TimeAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): TimeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minuteIncrements"] = this.minuteIncrements;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): TimeQuestionDto {
        const json = this.toJSON();
        let result = new TimeQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ITimeQuestionDto extends IQuestionDto {
    minuteIncrements?: number | undefined;
    validation: TimeQuestionValidation;
    answer?: TimeAnswerDto | undefined;
}

export class DateTimeQuestionDto extends QuestionDto implements IDateTimeQuestionDto {
    minuteIncrements?: number | undefined;
    validation!: DateTimeQuestionValidation;
    answer?: DateTimeAnswerDto | undefined;

    constructor(data?: IDateTimeQuestionDto) {
        super(data);
        if (!data) {
            this.validation = new DateTimeQuestionValidation();
        }
        this._discriminator = "DateTimeQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minuteIncrements = _data["minuteIncrements"];
            this.validation = _data["validation"] ? DateTimeQuestionValidation.fromJS(_data["validation"]) : new DateTimeQuestionValidation();
            this.answer = _data["answer"] ? DateTimeAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): DateTimeQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minuteIncrements"] = this.minuteIncrements;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeQuestionDto {
        const json = this.toJSON();
        let result = new DateTimeQuestionDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeQuestionDto extends IQuestionDto {
    minuteIncrements?: number | undefined;
    validation: DateTimeQuestionValidation;
    answer?: DateTimeAnswerDto | undefined;
}

export class SliderQuestionDto extends QuestionDto implements ISliderQuestionDto {
    minLabel!: InternationalizedString;
    maxLabel!: InternationalizedString;
    range!: boolean;
    vertical!: boolean;
    steps?: number | undefined;
    validation!: SliderQuestionValidation;
    answer?: SliderAnswerDto | undefined;

    constructor(data?: ISliderQuestionDto) {
        super(data);
        if (!data) {
            this.minLabel = new InternationalizedString();
            this.maxLabel = new InternationalizedString();
            this.validation = new SliderQuestionValidation();
        }
        this._discriminator = "SliderQuestionDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minLabel = _data["minLabel"] ? InternationalizedString.fromJS(_data["minLabel"]) : new InternationalizedString();
            this.maxLabel = _data["maxLabel"] ? InternationalizedString.fromJS(_data["maxLabel"]) : new InternationalizedString();
            this.range = _data["range"];
            this.vertical = _data["vertical"];
            this.steps = _data["steps"];
            this.validation = _data["validation"] ? SliderQuestionValidation.fromJS(_data["validation"]) : new SliderQuestionValidation();
            this.answer = _data["answer"] ? SliderAnswerDto.fromJS(_data["answer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): SliderQuestionDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderQuestionDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minLabel"] = this.minLabel ? this.minLabel.toJSON() : <any>undefined;
        data["maxLabel"] = this.maxLabel ? this.maxLabel.toJSON() : <any>undefined;
        data["range"] = this.range;
        data["vertical"] = this.vertical;
        data["steps"] = this.steps;
        data["validation"] = this.validation ? this.validation.toJSON() : <any>undefined;
        data["answer"] = this.answer ? this.answer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): SliderQuestionDto {
        const json = this.toJSON();
        let result = new SliderQuestionDto();
        result.init(json);
        return result;
    }
}

export interface ISliderQuestionDto extends IQuestionDto {
    minLabel: InternationalizedString;
    maxLabel: InternationalizedString;
    range: boolean;
    vertical: boolean;
    steps?: number | undefined;
    validation: SliderQuestionValidation;
    answer?: SliderAnswerDto | undefined;
}

export class PaginatedListOfAppPageListItemDto implements IPaginatedListOfAppPageListItemDto {
    items!: AppPageListItemDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAppPageListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppPageListItemDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAppPageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAppPageListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAppPageListItemDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAppPageListItemDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAppPageListItemDto {
    items: AppPageListItemDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ContainerDto implements IContainerDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    version!: number;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created!: Date;
    lastModified!: Date;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.version = _data["version"];
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["version"] = this.version;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        data["published"] = this.published ? this.published.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        return data;
    }

    clone(): ContainerDto {
        throw new Error("The abstract class 'ContainerDto' cannot be instantiated.");
    }
}

export interface IContainerDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    version: number;
    hidden?: Date | undefined;
    published?: Date | undefined;
    created: Date;
    lastModified: Date;
}

export class AppPageListItemDto extends ContainerDto implements IAppPageListItemDto {
    parentId?: string | undefined;
    order!: number;
    asset?: AssetDto | undefined;
    tags!: string[];
    breadcrumb!: AppPageBreadcrumbItemDto[];
    createdBy?: UserDto | undefined;
    lastModifiedBy?: UserDto | undefined;

    constructor(data?: IAppPageListItemDto) {
        super(data);
        if (!data) {
            this.tags = [];
            this.breadcrumb = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            if (Array.isArray(_data["breadcrumb"])) {
                this.breadcrumb = [] as any;
                for (let item of _data["breadcrumb"])
                    this.breadcrumb!.push(AppPageBreadcrumbItemDto.fromJS(item));
            }
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): AppPageListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageListItemDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        if (Array.isArray(this.breadcrumb)) {
            data["breadcrumb"] = [];
            for (let item of this.breadcrumb)
                data["breadcrumb"].push(item.toJSON());
        }
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageListItemDto {
        const json = this.toJSON();
        let result = new AppPageListItemDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageListItemDto extends IContainerDto {
    parentId?: string | undefined;
    order: number;
    asset?: AssetDto | undefined;
    tags: string[];
    breadcrumb: AppPageBreadcrumbItemDto[];
    createdBy?: UserDto | undefined;
    lastModifiedBy?: UserDto | undefined;
}

export class AppPageBreadcrumbItemDto implements IAppPageBreadcrumbItemDto {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IAppPageBreadcrumbItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AppPageBreadcrumbItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageBreadcrumbItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }

    clone(): AppPageBreadcrumbItemDto {
        const json = this.toJSON();
        let result = new AppPageBreadcrumbItemDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageBreadcrumbItemDto {
    id?: string | undefined;
    name?: string | undefined;
}

export class UserDto implements IUserDto {
    id!: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.givenName = _data["givenName"];
            this.familyName = _data["familyName"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["givenName"] = this.givenName;
        data["familyName"] = this.familyName;
        return data;
    }

    clone(): UserDto {
        const json = this.toJSON();
        let result = new UserDto();
        result.init(json);
        return result;
    }
}

export interface IUserDto {
    id: string;
    userName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    givenName?: string | undefined;
    familyName?: string | undefined;
}

export class SortingParameter implements ISortingParameter {
    property!: string;
    direction!: SortDirection;

    constructor(data?: ISortingParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.direction = _data["direction"];
        }
    }

    static fromJS(data: any): SortingParameter {
        data = typeof data === 'object' ? data : {};
        let result = new SortingParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["direction"] = this.direction;
        return data;
    }

    clone(): SortingParameter {
        const json = this.toJSON();
        let result = new SortingParameter();
        result.init(json);
        return result;
    }
}

export interface ISortingParameter {
    property: string;
    direction: SortDirection;
}

export enum SortDirection {
    Ascending = "ascending",
    Descending = "descending",
}

export enum PublicationState {
    Published = "published",
    NotPublished = "notPublished",
}

export class AppPageDto extends ContainerDto implements IAppPageDto {
    parentId?: string | undefined;
    order!: number;
    children!: AppPageDto[];
    asset?: AssetDto | undefined;
    tags!: string[];
    visibility!: ContainerVisibility;

    constructor(data?: IAppPageDto) {
        super(data);
        if (!data) {
            this.children = [];
            this.tags = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.parentId = _data["parentId"];
            this.order = _data["order"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AppPageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
        }
    }

    static override fromJS(data: any): AppPageDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["order"] = this.order;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageDto {
        const json = this.toJSON();
        let result = new AppPageDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageDto extends IContainerDto {
    parentId?: string | undefined;
    order: number;
    children: AppPageDto[];
    asset?: AssetDto | undefined;
    tags: string[];
    visibility: ContainerVisibility;
}

export enum ContainerVisibility {
    Private = "private",
    Internal = "internal",
    Public = "public",
}

export abstract class ContainerDetailsDto implements IContainerDetailsDto {
    id!: string;
    projectId?: string | undefined;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    version!: number;
    created!: Date;
    lastModified!: Date;
    published?: Date | undefined;
    defaultLanguage!: LanguageDto;
    languages!: LanguageDto[];
    condition?: ContainerCondition | undefined;
    assetFolder?: AssetFolderDto | undefined;
    sharingOptions!: ContainerSharingOption[];

    constructor(data?: IContainerDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new LanguageDto();
            this.languages = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.version = _data["version"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : <any>undefined;
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageDto.fromJS(_data["defaultLanguage"]) : new LanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : <any>undefined;
            this.assetFolder = _data["assetFolder"] ? AssetFolderDto.fromJS(_data["assetFolder"]) : <any>undefined;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContainerDetailsDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ContainerDetailsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["version"] = this.version;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["published"] = this.published ? this.published.toISOString() : <any>undefined;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        data["assetFolder"] = this.assetFolder ? this.assetFolder.toJSON() : <any>undefined;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ContainerDetailsDto {
        throw new Error("The abstract class 'ContainerDetailsDto' cannot be instantiated.");
    }
}

export interface IContainerDetailsDto {
    id: string;
    projectId?: string | undefined;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    version: number;
    created: Date;
    lastModified: Date;
    published?: Date | undefined;
    defaultLanguage: LanguageDto;
    languages: LanguageDto[];
    condition?: ContainerCondition | undefined;
    assetFolder?: AssetFolderDto | undefined;
    sharingOptions: ContainerSharingOption[];
}

export class AppPageDetailsDto extends ContainerDetailsDto implements IAppPageDetailsDto {
    asset?: AssetDto | undefined;
    contents!: ContentDto[];
    tags!: string[];
    visibility!: ContainerVisibility;

    constructor(data?: IAppPageDetailsDto) {
        super(data);
        if (!data) {
            this.contents = [];
            this.tags = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
        }
    }

    static override fromJS(data: any): AppPageDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppPageDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        super.toJSON(data);
        return data;
    }

    clone(): AppPageDetailsDto {
        const json = this.toJSON();
        let result = new AppPageDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAppPageDetailsDto extends IContainerDetailsDto {
    asset?: AssetDto | undefined;
    contents: ContentDto[];
    tags: string[];
    visibility: ContainerVisibility;
}

export class LanguageDto extends TenantEntityDto implements ILanguageDto {
    name!: string;
    code!: string;
    icon?: AssetDto | undefined;
    fallbackLanguages!: LanguageDto[];

    constructor(data?: ILanguageDto) {
        super(data);
        if (!data) {
            this.fallbackLanguages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.icon = _data["icon"] ? AssetDto.fromJS(_data["icon"]) : <any>undefined;
            if (Array.isArray(_data["fallbackLanguages"])) {
                this.fallbackLanguages = [] as any;
                for (let item of _data["fallbackLanguages"])
                    this.fallbackLanguages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): LanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["icon"] = this.icon ? this.icon.toJSON() : <any>undefined;
        if (Array.isArray(this.fallbackLanguages)) {
            data["fallbackLanguages"] = [];
            for (let item of this.fallbackLanguages)
                data["fallbackLanguages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): LanguageDto {
        const json = this.toJSON();
        let result = new LanguageDto();
        result.init(json);
        return result;
    }
}

export interface ILanguageDto extends ITenantEntityDto {
    name: string;
    code: string;
    icon?: AssetDto | undefined;
    fallbackLanguages: LanguageDto[];
}

export class ContainerCondition extends Condition implements IContainerCondition {

    constructor(data?: IContainerCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContainerCondition {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContainerCondition {
        const json = this.toJSON();
        let result = new ContainerCondition();
        result.init(json);
        return result;
    }
}

export interface IContainerCondition extends ICondition {
}

export class AssetFolderDto implements IAssetFolderDto {
    id!: string;
    name!: string;
    parentId?: string | undefined;

    constructor(data?: IAssetFolderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): AssetFolderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFolderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): AssetFolderDto {
        const json = this.toJSON();
        let result = new AssetFolderDto();
        result.init(json);
        return result;
    }
}

export interface IAssetFolderDto {
    id: string;
    name: string;
    parentId?: string | undefined;
}

export abstract class SharingOption implements ISharingOption {
    id!: string;
    name!: string;
    label!: InternationalizedString;
    condition?: SharingCondition | undefined;

    constructor(data?: ISharingOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.label = new InternationalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.label = _data["label"] ? InternationalizedString.fromJS(_data["label"]) : new InternationalizedString();
            this.condition = _data["condition"] ? SharingCondition.fromJS(_data["condition"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SharingOption {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SharingOption' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["label"] = this.label ? this.label.toJSON() : <any>undefined;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        return data;
    }

    clone(): SharingOption {
        throw new Error("The abstract class 'SharingOption' cannot be instantiated.");
    }
}

export interface ISharingOption {
    id: string;
    name: string;
    label: InternationalizedString;
    condition?: SharingCondition | undefined;
}

export class ContainerSharingOption extends SharingOption implements IContainerSharingOption {
    type!: ContainerSharingType;

    constructor(data?: IContainerSharingOption) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
        }
    }

    static override fromJS(data: any): ContainerSharingOption {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerSharingOption();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        super.toJSON(data);
        return data;
    }

    clone(): ContainerSharingOption {
        const json = this.toJSON();
        let result = new ContainerSharingOption();
        result.init(json);
        return result;
    }
}

export interface IContainerSharingOption extends ISharingOption {
    type: ContainerSharingType;
}

export enum ContainerSharingType {
    IndividualInstances = "individualInstances",
    EntireContainer = "entireContainer",
    Automatic = "automatic",
}

export class SharingCondition extends Condition implements ISharingCondition {

    constructor(data?: ISharingCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): SharingCondition {
        data = typeof data === 'object' ? data : {};
        let result = new SharingCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SharingCondition {
        const json = this.toJSON();
        let result = new SharingCondition();
        result.init(json);
        return result;
    }
}

export interface ISharingCondition extends ICondition {
}

export class CreateAppPageCommand implements ICreateAppPageCommand {
    name!: string;
    projectId?: string | undefined;
    parentPageId?: string | undefined;
    index!: number;

    constructor(data?: ICreateAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
            this.parentPageId = _data["parentPageId"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): CreateAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        data["parentPageId"] = this.parentPageId;
        data["index"] = this.index;
        return data;
    }

    clone(): CreateAppPageCommand {
        const json = this.toJSON();
        let result = new CreateAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAppPageCommand {
    name: string;
    projectId?: string | undefined;
    parentPageId?: string | undefined;
    index: number;
}

export class UpdateAppPageCommand implements IUpdateAppPageCommand {
    appPageId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    contents!: ContentDto[];
    condition?: ContainerCondition | undefined;
    tags!: string[];
    visibility!: ContainerVisibility;
    assetId?: string | undefined;

    constructor(data?: IUpdateAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.contents = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appPageId = _data["appPageId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.visibility = _data["visibility"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPageId"] = this.appPageId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["visibility"] = this.visibility;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateAppPageCommand {
        const json = this.toJSON();
        let result = new UpdateAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppPageCommand {
    appPageId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    contents: ContentDto[];
    condition?: ContainerCondition | undefined;
    tags: string[];
    visibility: ContainerVisibility;
    assetId?: string | undefined;
}

export class MoveAppPageCommand implements IMoveAppPageCommand {
    appPageId!: string;
    parentPageId?: string | undefined;
    index!: number;

    constructor(data?: IMoveAppPageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appPageId = _data["appPageId"];
            this.parentPageId = _data["parentPageId"];
            this.index = _data["index"];
        }
    }

    static fromJS(data: any): MoveAppPageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAppPageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appPageId"] = this.appPageId;
        data["parentPageId"] = this.parentPageId;
        data["index"] = this.index;
        return data;
    }

    clone(): MoveAppPageCommand {
        const json = this.toJSON();
        let result = new MoveAppPageCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAppPageCommand {
    appPageId: string;
    parentPageId?: string | undefined;
    index: number;
}

export class PaginatedListOfHistoricalContentDto implements IPaginatedListOfHistoricalContentDto {
    items!: HistoricalContentDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfHistoricalContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(HistoricalContentDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfHistoricalContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfHistoricalContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfHistoricalContentDto {
        const json = this.toJSON();
        let result = new PaginatedListOfHistoricalContentDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfHistoricalContentDto {
    items: HistoricalContentDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class HistoricalContentDto implements IHistoricalContentDto {
    timestamp!: Date;
    version!: number;
    lastModifiedBy?: UserDto | undefined;

    constructor(data?: IHistoricalContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HistoricalContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        return data;
    }

    clone(): HistoricalContentDto {
        const json = this.toJSON();
        let result = new HistoricalContentDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalContentDto {
    timestamp: Date;
    version: number;
    lastModifiedBy?: UserDto | undefined;
}

export class HistoricalContentDetailsDto implements IHistoricalContentDetailsDto {
    timestamp!: Date;
    version!: number;
    lastModifiedBy?: UserDto | undefined;
    contents!: ContentDto[];

    constructor(data?: IHistoricalContentDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contents = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : <any>undefined;
            this.version = _data["version"];
            this.lastModifiedBy = _data["lastModifiedBy"] ? UserDto.fromJS(_data["lastModifiedBy"]) : <any>undefined;
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HistoricalContentDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalContentDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["version"] = this.version;
        data["lastModifiedBy"] = this.lastModifiedBy ? this.lastModifiedBy.toJSON() : <any>undefined;
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        return data;
    }

    clone(): HistoricalContentDetailsDto {
        const json = this.toJSON();
        let result = new HistoricalContentDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IHistoricalContentDetailsDto {
    timestamp: Date;
    version: number;
    lastModifiedBy?: UserDto | undefined;
    contents: ContentDto[];
}

export class PaginatedListOfAppDto implements IPaginatedListOfAppDto {
    items!: AppDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAppDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AppDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAppDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAppDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAppDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAppDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAppDto {
    items: AppDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ClientDto extends TenantEntityDto implements IClientDto {
    name!: string;

    protected _discriminator: string;

    constructor(data?: IClientDto) {
        super(data);
        this._discriminator = "ClientDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): ClientDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AppDto") {
            let result = new AppDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ClientDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }

    clone(): ClientDto {
        throw new Error("The abstract class 'ClientDto' cannot be instantiated.");
    }
}

export interface IClientDto extends ITenantEntityDto {
    name: string;
}

export class AppDto extends ClientDto implements IAppDto {

    constructor(data?: IAppDto) {
        super(data);
        this._discriminator = "AppDto";
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AppDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): AppDto {
        const json = this.toJSON();
        let result = new AppDto();
        result.init(json);
        return result;
    }
}

export interface IAppDto extends IClientDto {
}

export abstract class ClientDetailsDto extends TenantEntityDto implements IClientDetailsDto {
    name!: string;
    identifiers!: ClientIdentifierDto[];

    protected _discriminator: string;

    constructor(data?: IClientDetailsDto) {
        super(data);
        if (!data) {
            this.identifiers = [];
        }
        this._discriminator = "ClientDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(ClientIdentifierDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ClientDetailsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "AppDetailsDto") {
            let result = new AppDetailsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'ClientDetailsDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ClientDetailsDto {
        throw new Error("The abstract class 'ClientDetailsDto' cannot be instantiated.");
    }
}

export interface IClientDetailsDto extends ITenantEntityDto {
    name: string;
    identifiers: ClientIdentifierDto[];
}

export class AppDetailsDto extends ClientDetailsDto implements IAppDetailsDto {
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    isLicenseRequired!: boolean;
    licenses!: LicenseDto[];

    constructor(data?: IAppDetailsDto) {
        super(data);
        if (!data) {
            this.licenses = [];
        }
        this._discriminator = "AppDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.qrUrl = _data["qrUrl"];
            this.firebaseConfiguration = _data["firebaseConfiguration"];
            this.isLicenseRequired = _data["isLicenseRequired"];
            if (Array.isArray(_data["licenses"])) {
                this.licenses = [] as any;
                for (let item of _data["licenses"])
                    this.licenses!.push(LicenseDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): AppDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrUrl"] = this.qrUrl;
        data["firebaseConfiguration"] = this.firebaseConfiguration;
        data["isLicenseRequired"] = this.isLicenseRequired;
        if (Array.isArray(this.licenses)) {
            data["licenses"] = [];
            for (let item of this.licenses)
                data["licenses"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): AppDetailsDto {
        const json = this.toJSON();
        let result = new AppDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAppDetailsDto extends IClientDetailsDto {
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    isLicenseRequired: boolean;
    licenses: LicenseDto[];
}

export class LicenseDto implements ILicenseDto {
    id!: string;
    name!: string;
    apps!: AppDto[];
    activationServiceType!: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    tags!: string[];
    metadata!: LicenseMetadataDto;
    licenseConfig?: LicenseConfigDto | undefined;
    instancesCount!: number;
    activatedInstancesCount!: number;

    constructor(data?: ILicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.apps = [];
            this.tags = [];
            this.metadata = new LicenseMetadataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["apps"])) {
                this.apps = [] as any;
                for (let item of _data["apps"])
                    this.apps!.push(AppDto.fromJS(item));
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : <any>undefined;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadataDto.fromJS(_data["metadata"]) : new LicenseMetadataDto();
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfigDto.fromJS(_data["licenseConfig"]) : <any>undefined;
            this.instancesCount = _data["instancesCount"];
            this.activatedInstancesCount = _data["activatedInstancesCount"];
        }
    }

    static fromJS(data: any): LicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.apps)) {
            data["apps"] = [];
            for (let item of this.apps)
                data["apps"].push(item.toJSON());
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : <any>undefined;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : <any>undefined;
        data["instancesCount"] = this.instancesCount;
        data["activatedInstancesCount"] = this.activatedInstancesCount;
        return data;
    }

    clone(): LicenseDto {
        const json = this.toJSON();
        let result = new LicenseDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseDto {
    id: string;
    name: string;
    apps: AppDto[];
    activationServiceType: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    tags: string[];
    metadata: LicenseMetadataDto;
    licenseConfig?: LicenseConfigDto | undefined;
    instancesCount: number;
    activatedInstancesCount: number;
}

export enum LicenseActivationServiceType {
    OnlineKeyServer = "onlineKeyServer",
}

export class LicenseMetadataDto implements ILicenseMetadataDto {
    poNumber?: string | undefined;
    distributorName?: string | undefined;

    constructor(data?: ILicenseMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"];
            this.distributorName = _data["distributorName"];
        }
    }

    static fromJS(data: any): LicenseMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber;
        data["distributorName"] = this.distributorName;
        return data;
    }

    clone(): LicenseMetadataDto {
        const json = this.toJSON();
        let result = new LicenseMetadataDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseMetadataDto {
    poNumber?: string | undefined;
    distributorName?: string | undefined;
}

export class LicenseConfigDto implements ILicenseConfigDto {
    maxDevices?: number | undefined;

    constructor(data?: ILicenseConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxDevices = _data["maxDevices"];
        }
    }

    static fromJS(data: any): LicenseConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxDevices"] = this.maxDevices;
        return data;
    }

    clone(): LicenseConfigDto {
        const json = this.toJSON();
        let result = new LicenseConfigDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseConfigDto {
    maxDevices?: number | undefined;
}

export class ClientIdentifierDto implements IClientIdentifierDto {
    identifier!: string;
    platform!: Platform;
    environment!: Environment;
    storeLink?: string | undefined;

    constructor(data?: IClientIdentifierDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.identifier = _data["identifier"];
            this.platform = _data["platform"];
            this.environment = _data["environment"];
            this.storeLink = _data["storeLink"];
        }
    }

    static fromJS(data: any): ClientIdentifierDto {
        data = typeof data === 'object' ? data : {};
        let result = new ClientIdentifierDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identifier"] = this.identifier;
        data["platform"] = this.platform;
        data["environment"] = this.environment;
        data["storeLink"] = this.storeLink;
        return data;
    }

    clone(): ClientIdentifierDto {
        const json = this.toJSON();
        let result = new ClientIdentifierDto();
        result.init(json);
        return result;
    }
}

export interface IClientIdentifierDto {
    identifier: string;
    platform: Platform;
    environment: Environment;
    storeLink?: string | undefined;
}

export enum Platform {
    Android = "android",
    Ios = "ios",
}

export enum Environment {
    Development = "development",
    Production = "production",
}

export class CreateAppCommand implements ICreateAppCommand {
    name!: string;

    constructor(data?: ICreateAppCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAppCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAppCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateAppCommand {
        const json = this.toJSON();
        let result = new CreateAppCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAppCommand {
    name: string;
}

export class UpdateAppCommand implements IUpdateAppCommand {
    appId!: string;
    name!: string;
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    identifiers!: ClientIdentifierDto[];
    isLicenseRequired?: boolean | undefined;

    constructor(data?: IUpdateAppCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.identifiers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.name = _data["name"];
            this.qrUrl = _data["qrUrl"];
            this.firebaseConfiguration = _data["firebaseConfiguration"];
            if (Array.isArray(_data["identifiers"])) {
                this.identifiers = [] as any;
                for (let item of _data["identifiers"])
                    this.identifiers!.push(ClientIdentifierDto.fromJS(item));
            }
            this.isLicenseRequired = _data["isLicenseRequired"];
        }
    }

    static fromJS(data: any): UpdateAppCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAppCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["name"] = this.name;
        data["qrUrl"] = this.qrUrl;
        data["firebaseConfiguration"] = this.firebaseConfiguration;
        if (Array.isArray(this.identifiers)) {
            data["identifiers"] = [];
            for (let item of this.identifiers)
                data["identifiers"].push(item.toJSON());
        }
        data["isLicenseRequired"] = this.isLicenseRequired;
        return data;
    }

    clone(): UpdateAppCommand {
        const json = this.toJSON();
        let result = new UpdateAppCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAppCommand {
    appId: string;
    name: string;
    qrUrl?: string | undefined;
    firebaseConfiguration?: string | undefined;
    identifiers: ClientIdentifierDto[];
    isLicenseRequired?: boolean | undefined;
}

export class PaginatedListOfAssetDto implements IPaginatedListOfAssetDto {
    items!: AssetDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AssetDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAssetDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAssetDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAssetDto {
    items: AssetDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AssetFolderDetailsDto implements IAssetFolderDetailsDto {
    id!: string;
    name!: string;
    description?: string | undefined;
    assets!: AssetDto[];
    parentId?: string | undefined;
    rootLine!: AssetFolderDto[];
    children!: AssetFolderDto[];

    constructor(data?: IAssetFolderDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.assets = [];
            this.rootLine = [];
            this.children = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetDto.fromJS(item));
            }
            this.parentId = _data["parentId"];
            if (Array.isArray(_data["rootLine"])) {
                this.rootLine = [] as any;
                for (let item of _data["rootLine"])
                    this.rootLine!.push(AssetFolderDto.fromJS(item));
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssetFolderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetFolderDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFolderDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        data["parentId"] = this.parentId;
        if (Array.isArray(this.rootLine)) {
            data["rootLine"] = [];
            for (let item of this.rootLine)
                data["rootLine"].push(item.toJSON());
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }

    clone(): AssetFolderDetailsDto {
        const json = this.toJSON();
        let result = new AssetFolderDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAssetFolderDetailsDto {
    id: string;
    name: string;
    description?: string | undefined;
    assets: AssetDto[];
    parentId?: string | undefined;
    rootLine: AssetFolderDto[];
    children: AssetFolderDto[];
}

export class CreateAssetCommand implements ICreateAssetCommand {
    assetFolderId!: string;
    name!: string;
    fileId!: string;

    constructor(data?: ICreateAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.name = _data["name"];
            this.fileId = _data["fileId"];
        }
    }

    static fromJS(data: any): CreateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["name"] = this.name;
        data["fileId"] = this.fileId;
        return data;
    }

    clone(): CreateAssetCommand {
        const json = this.toJSON();
        let result = new CreateAssetCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetCommand {
    assetFolderId: string;
    name: string;
    fileId: string;
}

export class CreateAssetFolderCommand implements ICreateAssetFolderCommand {
    parentId?: string | undefined;
    name!: string;

    constructor(data?: ICreateAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["name"] = this.name;
        return data;
    }

    clone(): CreateAssetFolderCommand {
        const json = this.toJSON();
        let result = new CreateAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateAssetFolderCommand {
    parentId?: string | undefined;
    name: string;
}

export class UpdateAssetCommand implements IUpdateAssetCommand {
    assetId!: string;
    fileId!: string;
    name!: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;

    constructor(data?: IUpdateAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.fileId = _data["fileId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.x = _data["x"];
            this.y = _data["y"];
        }
    }

    static fromJS(data: any): UpdateAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["fileId"] = this.fileId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["width"] = this.width;
        data["height"] = this.height;
        data["x"] = this.x;
        data["y"] = this.y;
        return data;
    }

    clone(): UpdateAssetCommand {
        const json = this.toJSON();
        let result = new UpdateAssetCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetCommand {
    assetId: string;
    fileId: string;
    name: string;
    description?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    x?: number | undefined;
    y?: number | undefined;
}

export class UpdateAssetFolderCommand implements IUpdateAssetFolderCommand {
    assetFolderId!: string;
    name!: string;
    description?: string | undefined;

    constructor(data?: IUpdateAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.name = _data["name"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): UpdateAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["name"] = this.name;
        data["description"] = this.description;
        return data;
    }

    clone(): UpdateAssetFolderCommand {
        const json = this.toJSON();
        let result = new UpdateAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateAssetFolderCommand {
    assetFolderId: string;
    name: string;
    description?: string | undefined;
}

export class MoveAssetCommand implements IMoveAssetCommand {
    assetId!: string;
    assetFolderId!: string;

    constructor(data?: IMoveAssetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"];
            this.assetFolderId = _data["assetFolderId"];
        }
    }

    static fromJS(data: any): MoveAssetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAssetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId;
        data["assetFolderId"] = this.assetFolderId;
        return data;
    }

    clone(): MoveAssetCommand {
        const json = this.toJSON();
        let result = new MoveAssetCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAssetCommand {
    assetId: string;
    assetFolderId: string;
}

export class MoveAssetFolderCommand implements IMoveAssetFolderCommand {
    assetFolderId!: string;
    parentId!: string;

    constructor(data?: IMoveAssetFolderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetFolderId = _data["assetFolderId"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): MoveAssetFolderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new MoveAssetFolderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetFolderId"] = this.assetFolderId;
        data["parentId"] = this.parentId;
        return data;
    }

    clone(): MoveAssetFolderCommand {
        const json = this.toJSON();
        let result = new MoveAssetFolderCommand();
        result.init(json);
        return result;
    }
}

export interface IMoveAssetFolderCommand {
    assetFolderId: string;
    parentId: string;
}

export class PaginatedListOfAuditEventDto implements IPaginatedListOfAuditEventDto {
    items!: AuditEventDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditEventDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfAuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfAuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfAuditEventDto {
        const json = this.toJSON();
        let result = new PaginatedListOfAuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfAuditEventDto {
    items: AuditEventDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class AuditEventDto implements IAuditEventDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    userId?: string | undefined;
    userName?: string | undefined;

    constructor(data?: IAuditEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): AuditEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        return data;
    }

    clone(): AuditEventDto {
        const json = this.toJSON();
        let result = new AuditEventDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    userId?: string | undefined;
    userName?: string | undefined;
}

export class AuditEventDetailsDto implements IAuditEventDetailsDto {
    id!: number;
    created!: Date;
    lastModified!: Date;
    type!: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data!: AuditEventDataDto;

    constructor(data?: IAuditEventDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.data = new AuditEventDataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.data = _data["data"] ? AuditEventDataDto.fromJS(_data["data"]) : new AuditEventDataDto();
        }
    }

    static fromJS(data: any): AuditEventDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data;
    }

    clone(): AuditEventDetailsDto {
        const json = this.toJSON();
        let result = new AuditEventDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDetailsDto {
    id: number;
    created: Date;
    lastModified: Date;
    type: string;
    userId?: string | undefined;
    userName?: string | undefined;
    data: AuditEventDataDto;
}

export class AuditEventDataDto implements IAuditEventDataDto {
    action!: AuditEventActionDto;
    userId?: string | undefined;
    endDate!: Date;
    duration!: number;
    eventType!: string;
    startDate!: Date;
    environment!: AuditEventEnvironmentDto;

    constructor(data?: IAuditEventDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.action = new AuditEventActionDto();
            this.environment = new AuditEventEnvironmentDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] ? AuditEventActionDto.fromJS(_data["action"]) : new AuditEventActionDto();
            this.userId = _data["userId"];
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.duration = _data["duration"];
            this.eventType = _data["eventType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.environment = _data["environment"] ? AuditEventEnvironmentDto.fromJS(_data["environment"]) : new AuditEventEnvironmentDto();
        }
    }

    static fromJS(data: any): AuditEventDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action ? this.action.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["duration"] = this.duration;
        data["eventType"] = this.eventType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["environment"] = this.environment ? this.environment.toJSON() : <any>undefined;
        return data;
    }

    clone(): AuditEventDataDto {
        const json = this.toJSON();
        let result = new AuditEventDataDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventDataDto {
    action: AuditEventActionDto;
    userId?: string | undefined;
    endDate: Date;
    duration: number;
    eventType: string;
    startDate: Date;
    environment: AuditEventEnvironmentDto;
}

export class AuditEventActionDto implements IAuditEventActionDto {
    traceId!: string;
    userName?: string | undefined;
    ipAddress!: string;
    actionName!: string;
    httpMethod!: string;
    requestUrl!: string;
    controllerName!: string;
    responseStatus!: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;

    constructor(data?: IAuditEventActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.traceId = _data["traceId"];
            this.userName = _data["userName"];
            this.ipAddress = _data["ipAddress"];
            this.actionName = _data["actionName"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.controllerName = _data["controllerName"];
            this.responseStatus = _data["responseStatus"];
            this.actionParameters = _data["actionParameters"];
            this.responseStatusCode = _data["responseStatusCode"];
            this.formVariables = _data["formVariables"];
            this.exception = _data["exception"];
        }
    }

    static fromJS(data: any): AuditEventActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["traceId"] = this.traceId;
        data["userName"] = this.userName;
        data["ipAddress"] = this.ipAddress;
        data["actionName"] = this.actionName;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["controllerName"] = this.controllerName;
        data["responseStatus"] = this.responseStatus;
        data["actionParameters"] = this.actionParameters;
        data["responseStatusCode"] = this.responseStatusCode;
        data["formVariables"] = this.formVariables;
        data["exception"] = this.exception;
        return data;
    }

    clone(): AuditEventActionDto {
        const json = this.toJSON();
        let result = new AuditEventActionDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventActionDto {
    traceId: string;
    userName?: string | undefined;
    ipAddress: string;
    actionName: string;
    httpMethod: string;
    requestUrl: string;
    controllerName: string;
    responseStatus: string;
    actionParameters?: any | undefined;
    responseStatusCode?: number | undefined;
    formVariables?: any | undefined;
    exception?: string | undefined;
}

export class AuditEventEnvironmentDto implements IAuditEventEnvironmentDto {
    culture!: string;
    userName?: string | undefined;
    domainName!: string;
    machineName!: string;
    assemblyName!: string;
    callingMethodName!: string;

    constructor(data?: IAuditEventEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.culture = _data["culture"];
            this.userName = _data["userName"];
            this.domainName = _data["domainName"];
            this.machineName = _data["machineName"];
            this.assemblyName = _data["assemblyName"];
            this.callingMethodName = _data["callingMethodName"];
        }
    }

    static fromJS(data: any): AuditEventEnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditEventEnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["culture"] = this.culture;
        data["userName"] = this.userName;
        data["domainName"] = this.domainName;
        data["machineName"] = this.machineName;
        data["assemblyName"] = this.assemblyName;
        data["callingMethodName"] = this.callingMethodName;
        return data;
    }

    clone(): AuditEventEnvironmentDto {
        const json = this.toJSON();
        let result = new AuditEventEnvironmentDto();
        result.init(json);
        return result;
    }
}

export interface IAuditEventEnvironmentDto {
    culture: string;
    userName?: string | undefined;
    domainName: string;
    machineName: string;
    assemblyName: string;
    callingMethodName: string;
}

export class PaginatedListOfContextObjectDto implements IPaginatedListOfContextObjectDto {
    items!: ContextObjectDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContextObjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContextObjectDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContextObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContextObjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContextObjectDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContextObjectDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContextObjectDto {
    items: ContextObjectDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContextObjectDto extends ContainerDto implements IContextObjectDto {

    constructor(data?: IContextObjectDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ContextObjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectDto {
        const json = this.toJSON();
        let result = new ContextObjectDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectDto extends IContainerDto {
}

export class ContextObjectDetailsDto extends ContainerDetailsDto implements IContextObjectDetailsDto {
    contents!: ContentDto[];

    constructor(data?: IContextObjectDetailsDto) {
        super(data);
        if (!data) {
            this.contents = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ContextObjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectDetailsDto {
        const json = this.toJSON();
        let result = new ContextObjectDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectDetailsDto extends IContainerDetailsDto {
    contents: ContentDto[];
}

export class CreateContextObjectCommand implements ICreateContextObjectCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateContextObjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateContextObjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateContextObjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateContextObjectCommand {
        const json = this.toJSON();
        let result = new CreateContextObjectCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateContextObjectCommand {
    name: string;
    projectId: string;
}

export class UpdateContextObjectCommand implements IUpdateContextObjectCommand {
    contextObjectId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    contents!: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOption[];

    constructor(data?: IUpdateContextObjectCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.contents = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contextObjectId = _data["contextObjectId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["contents"])) {
                this.contents = [] as any;
                for (let item of _data["contents"])
                    this.contents!.push(ContentDto.fromJS(item));
            }
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : <any>undefined;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateContextObjectCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContextObjectCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contextObjectId"] = this.contextObjectId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.contents)) {
            data["contents"] = [];
            for (let item of this.contents)
                data["contents"].push(item.toJSON());
        }
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateContextObjectCommand {
        const json = this.toJSON();
        let result = new UpdateContextObjectCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateContextObjectCommand {
    contextObjectId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    contents: ContentDto[];
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOption[];
}

export class PaginatedListOfContextObjectInstanceDto implements IPaginatedListOfContextObjectInstanceDto {
    items!: ContextObjectInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfContextObjectInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ContextObjectInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfContextObjectInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfContextObjectInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfContextObjectInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfContextObjectInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfContextObjectInstanceDto {
    items: ContextObjectInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ContextObjectInstanceDto extends TenantEntityDto implements IContextObjectInstanceDto {
    name!: string;
    contextObjectId!: string;
    contextObjectName!: string;
    created!: Date;
    lastModified!: Date;
    hidden?: Date | undefined;
    owner?: ProjectParticipantDto | undefined;
    sharingState!: SharingState;

    constructor(data?: IContextObjectInstanceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.contextObjectId = _data["contextObjectId"];
            this.contextObjectName = _data["contextObjectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : <any>undefined;
            this.sharingState = _data["sharingState"];
        }
    }

    static override fromJS(data: any): ContextObjectInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContextObjectInstanceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["contextObjectId"] = this.contextObjectId;
        data["contextObjectName"] = this.contextObjectName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["sharingState"] = this.sharingState;
        super.toJSON(data);
        return data;
    }

    clone(): ContextObjectInstanceDto {
        const json = this.toJSON();
        let result = new ContextObjectInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IContextObjectInstanceDto extends ITenantEntityDto {
    name: string;
    contextObjectId: string;
    contextObjectName: string;
    created: Date;
    lastModified: Date;
    hidden?: Date | undefined;
    owner?: ProjectParticipantDto | undefined;
    sharingState: SharingState;
}

export class ProjectParticipantDto implements IProjectParticipantDto {
    user!: UserDto;
    chiffre!: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status!: ProjectParticipantStatus;

    constructor(data?: IProjectParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.chiffre = _data["chiffre"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.invited = _data["invited"] ? new Date(_data["invited"].toString()) : <any>undefined;
            this.enrolled = _data["enrolled"] ? new Date(_data["enrolled"].toString()) : <any>undefined;
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ProjectParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["chiffre"] = this.chiffre;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["invited"] = this.invited ? this.invited.toISOString() : <any>undefined;
        data["enrolled"] = this.enrolled ? this.enrolled.toISOString() : <any>undefined;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): ProjectParticipantDto {
        const json = this.toJSON();
        let result = new ProjectParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IProjectParticipantDto {
    user: UserDto;
    chiffre: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status: ProjectParticipantStatus;
}

export enum ProjectParticipantStatus {
    Created = "created",
    Invited = "invited",
    Enrolled = "enrolled",
    Withdrawn = "withdrawn",
}

export enum SharingState {
    NotShared = "notShared",
    SharedByMe = "sharedByMe",
    SharedWithMe = "sharedWithMe",
}

export class PaginatedListOfDeviceDto implements IPaginatedListOfDeviceDto {
    items!: DeviceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeviceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfDeviceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfDeviceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfDeviceDto {
    items: DeviceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class DeviceDto extends TenantEntityDto implements IDeviceDto {
    name!: string;
    identifier!: string;
    owner!: UserDto;

    protected _discriminator: string;

    constructor(data?: IDeviceDto) {
        super(data);
        if (!data) {
            this.owner = new UserDto();
        }
        this._discriminator = "DeviceDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.owner = _data["owner"] ? UserDto.fromJS(_data["owner"]) : new UserDto();
        }
    }

    static override fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MobilePhoneDto") {
            let result = new MobilePhoneDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DeviceDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceDto {
        throw new Error("The abstract class 'DeviceDto' cannot be instantiated.");
    }
}

export interface IDeviceDto extends ITenantEntityDto {
    name: string;
    identifier: string;
    owner: UserDto;
}

export class MobilePhoneDto extends DeviceDto implements IMobilePhoneDto {
    model!: string;

    constructor(data?: IMobilePhoneDto) {
        super(data);
        this._discriminator = "MobilePhoneDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.model = _data["model"];
        }
    }

    static override fromJS(data: any): MobilePhoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilePhoneDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["model"] = this.model;
        super.toJSON(data);
        return data;
    }

    clone(): MobilePhoneDto {
        const json = this.toJSON();
        let result = new MobilePhoneDto();
        result.init(json);
        return result;
    }
}

export interface IMobilePhoneDto extends IDeviceDto {
    model: string;
}

export abstract class DeviceDetailsDto extends TenantEntityDto implements IDeviceDetailsDto {
    name!: string;
    identifier!: string;

    protected _discriminator: string;

    constructor(data?: IDeviceDetailsDto) {
        super(data);
        this._discriminator = "DeviceDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
        }
    }

    static override fromJS(data: any): DeviceDetailsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "MobilePhoneDetailsDto") {
            let result = new MobilePhoneDetailsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DeviceDetailsDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        super.toJSON(data);
        return data;
    }

    clone(): DeviceDetailsDto {
        throw new Error("The abstract class 'DeviceDetailsDto' cannot be instantiated.");
    }
}

export interface IDeviceDetailsDto extends ITenantEntityDto {
    name: string;
    identifier: string;
}

export class MobilePhoneDetailsDto extends DeviceDetailsDto implements IMobilePhoneDetailsDto {
    manufacturer!: string;
    model!: string;
    osVersion!: string;
    language!: string;
    timezone!: string;

    constructor(data?: IMobilePhoneDetailsDto) {
        super(data);
        this._discriminator = "MobilePhoneDetailsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.manufacturer = _data["manufacturer"];
            this.model = _data["model"];
            this.osVersion = _data["osVersion"];
            this.language = _data["language"];
            this.timezone = _data["timezone"];
        }
    }

    static override fromJS(data: any): MobilePhoneDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MobilePhoneDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["manufacturer"] = this.manufacturer;
        data["model"] = this.model;
        data["osVersion"] = this.osVersion;
        data["language"] = this.language;
        data["timezone"] = this.timezone;
        super.toJSON(data);
        return data;
    }

    clone(): MobilePhoneDetailsDto {
        const json = this.toJSON();
        let result = new MobilePhoneDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IMobilePhoneDetailsDto extends IDeviceDetailsDto {
    manufacturer: string;
    model: string;
    osVersion: string;
    language: string;
    timezone: string;
}

export class CreateFileFromBase64Command implements ICreateFileFromBase64Command {
    base64String!: string;

    constructor(data?: ICreateFileFromBase64Command) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64String = _data["base64String"];
        }
    }

    static fromJS(data: any): CreateFileFromBase64Command {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFromBase64Command();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64String"] = this.base64String;
        return data;
    }

    clone(): CreateFileFromBase64Command {
        const json = this.toJSON();
        let result = new CreateFileFromBase64Command();
        result.init(json);
        return result;
    }
}

export interface ICreateFileFromBase64Command {
    base64String: string;
}

export class CreateFileFromUrlCommand implements ICreateFileFromUrlCommand {
    url!: string;

    constructor(data?: ICreateFileFromUrlCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): CreateFileFromUrlCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFileFromUrlCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    }

    clone(): CreateFileFromUrlCommand {
        const json = this.toJSON();
        let result = new CreateFileFromUrlCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateFileFromUrlCommand {
    url: string;
}

export class PaginatedListOfLanguageDto implements IPaginatedListOfLanguageDto {
    items!: LanguageDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLanguageDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLanguageDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLanguageDto {
    items: LanguageDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateLanguageCommand implements ICreateLanguageCommand {
    name!: string;
    code!: string;
    iconId?: string | undefined;

    constructor(data?: ICreateLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.iconId = _data["iconId"];
        }
    }

    static fromJS(data: any): CreateLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["iconId"] = this.iconId;
        return data;
    }

    clone(): CreateLanguageCommand {
        const json = this.toJSON();
        let result = new CreateLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLanguageCommand {
    name: string;
    code: string;
    iconId?: string | undefined;
}

export class UpdateLanguageCommand implements IUpdateLanguageCommand {
    languageId!: string;
    name!: string;
    code!: string;
    iconId?: string | undefined;
    fallbackLanguageIds!: string[];

    constructor(data?: IUpdateLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fallbackLanguageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.iconId = _data["iconId"];
            if (Array.isArray(_data["fallbackLanguageIds"])) {
                this.fallbackLanguageIds = [] as any;
                for (let item of _data["fallbackLanguageIds"])
                    this.fallbackLanguageIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["iconId"] = this.iconId;
        if (Array.isArray(this.fallbackLanguageIds)) {
            data["fallbackLanguageIds"] = [];
            for (let item of this.fallbackLanguageIds)
                data["fallbackLanguageIds"].push(item);
        }
        return data;
    }

    clone(): UpdateLanguageCommand {
        const json = this.toJSON();
        let result = new UpdateLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLanguageCommand {
    languageId: string;
    name: string;
    code: string;
    iconId?: string | undefined;
    fallbackLanguageIds: string[];
}

export class SetDefaultLanguageCommand implements ISetDefaultLanguageCommand {
    languageId!: string;

    constructor(data?: ISetDefaultLanguageCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageId = _data["languageId"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageId"] = this.languageId;
        return data;
    }

    clone(): SetDefaultLanguageCommand {
        const json = this.toJSON();
        let result = new SetDefaultLanguageCommand();
        result.init(json);
        return result;
    }
}

export interface ISetDefaultLanguageCommand {
    languageId: string;
}

export class TranslateCommand implements ITranslateCommand {
    text!: string;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode!: string;

    constructor(data?: ITranslateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.sourceLanguageCode = _data["sourceLanguageCode"];
            this.targetLanguageCode = _data["targetLanguageCode"];
        }
    }

    static fromJS(data: any): TranslateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["sourceLanguageCode"] = this.sourceLanguageCode;
        data["targetLanguageCode"] = this.targetLanguageCode;
        return data;
    }

    clone(): TranslateCommand {
        const json = this.toJSON();
        let result = new TranslateCommand();
        result.init(json);
        return result;
    }
}

export interface ITranslateCommand {
    text: string;
    sourceLanguageCode?: string | undefined;
    targetLanguageCode: string;
}

export class PaginatedListOfLicenseDto implements IPaginatedListOfLicenseDto {
    items!: LicenseDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLicenseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLicenseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLicenseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLicenseDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLicenseDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLicenseDto {
    items: LicenseDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateLicenseCommand implements ICreateLicenseCommand {
    name!: string;
    appIds!: string[];
    activationServiceType!: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: ICreateLicenseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.appIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["appIds"])) {
                this.appIds = [] as any;
                for (let item of _data["appIds"])
                    this.appIds!.push(item);
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : <any>undefined;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfig.fromJS(_data["licenseConfig"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.appIds)) {
            data["appIds"] = [];
            for (let item of this.appIds)
                data["appIds"].push(item);
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : <any>undefined;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }

    clone(): CreateLicenseCommand {
        const json = this.toJSON();
        let result = new CreateLicenseCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLicenseCommand {
    name: string;
    appIds: string[];
    activationServiceType: LicenseActivationServiceType;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export class LicenseConfig implements ILicenseConfig {
    countries?: Country[] | undefined;
    maxDevices?: number | undefined;

    constructor(data?: ILicenseConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(Country.fromJS(item));
            }
            this.maxDevices = _data["maxDevices"];
        }
    }

    static fromJS(data: any): LicenseConfig {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        data["maxDevices"] = this.maxDevices;
        return data;
    }

    clone(): LicenseConfig {
        const json = this.toJSON();
        let result = new LicenseConfig();
        result.init(json);
        return result;
    }
}

export interface ILicenseConfig {
    countries?: Country[] | undefined;
    maxDevices?: number | undefined;
}

export class Country implements ICountry {
    name!: string;
    isoCode!: string;

    constructor(data?: ICountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isoCode = _data["isoCode"];
        }
    }

    static fromJS(data: any): Country {
        data = typeof data === 'object' ? data : {};
        let result = new Country();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isoCode"] = this.isoCode;
        return data;
    }

    clone(): Country {
        const json = this.toJSON();
        let result = new Country();
        result.init(json);
        return result;
    }
}

export interface ICountry {
    name: string;
    isoCode: string;
}

export class LicenseMetadata implements ILicenseMetadata {
    poNumber?: string | undefined;
    distributorName?: string | undefined;

    constructor(data?: ILicenseMetadata) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.poNumber = _data["poNumber"];
            this.distributorName = _data["distributorName"];
        }
    }

    static fromJS(data: any): LicenseMetadata {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseMetadata();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["poNumber"] = this.poNumber;
        data["distributorName"] = this.distributorName;
        return data;
    }

    clone(): LicenseMetadata {
        const json = this.toJSON();
        let result = new LicenseMetadata();
        result.init(json);
        return result;
    }
}

export interface ILicenseMetadata {
    poNumber?: string | undefined;
    distributorName?: string | undefined;
}

export class UpdateLicenseCommand implements IUpdateLicenseCommand {
    licenseId!: string;
    name?: string | undefined;
    appIds?: string[] | undefined;
    activationServiceType?: LicenseActivationServiceType | undefined;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: IUpdateLicenseCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.name = _data["name"];
            if (Array.isArray(_data["appIds"])) {
                this.appIds = [] as any;
                for (let item of _data["appIds"])
                    this.appIds!.push(item);
            }
            this.activationServiceType = _data["activationServiceType"];
            this.validFromDate = _data["validFromDate"] ? new Date(_data["validFromDate"].toString()) : <any>undefined;
            this.validityInterval = _data["validityInterval"];
            this.instanceValidityInterval = _data["instanceValidityInterval"];
            this.licenseConfig = _data["licenseConfig"] ? LicenseConfig.fromJS(_data["licenseConfig"]) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateLicenseCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["name"] = this.name;
        if (Array.isArray(this.appIds)) {
            data["appIds"] = [];
            for (let item of this.appIds)
                data["appIds"].push(item);
        }
        data["activationServiceType"] = this.activationServiceType;
        data["validFromDate"] = this.validFromDate ? this.validFromDate.toISOString() : <any>undefined;
        data["validityInterval"] = this.validityInterval;
        data["instanceValidityInterval"] = this.instanceValidityInterval;
        data["licenseConfig"] = this.licenseConfig ? this.licenseConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateLicenseCommand {
        const json = this.toJSON();
        let result = new UpdateLicenseCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLicenseCommand {
    licenseId: string;
    name?: string | undefined;
    appIds?: string[] | undefined;
    activationServiceType?: LicenseActivationServiceType | undefined;
    validFromDate?: Date | undefined;
    validityInterval?: string | undefined;
    instanceValidityInterval?: string | undefined;
    licenseConfig?: LicenseConfig | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export enum ExportFileFormatParameter {
    Xlsx = "xlsx",
    Csv = "csv",
}

export class PaginatedListOfLicenseInstanceDto implements IPaginatedListOfLicenseInstanceDto {
    items!: LicenseInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfLicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LicenseInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfLicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfLicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfLicenseInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfLicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfLicenseInstanceDto {
    items: LicenseInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class LicenseInstanceDto implements ILicenseInstanceDto {
    id!: string;
    licenseId!: string;
    licenseKey?: string | undefined;
    expirationDate?: Date | undefined;
    activated?: Date | undefined;
    revoked?: Date | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    lastActivated?: Date | undefined;
    activatedBy?: UserDto | undefined;
    installationsCount!: number;
    tags!: string[];
    metadata!: LicenseMetadataDto;

    constructor(data?: ILicenseInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tags = [];
            this.metadata = new LicenseMetadataDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licenseId = _data["licenseId"];
            this.licenseKey = _data["licenseKey"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : <any>undefined;
            this.revoked = _data["revoked"] ? new Date(_data["revoked"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            this.lastActivated = _data["lastActivated"] ? new Date(_data["lastActivated"].toString()) : <any>undefined;
            this.activatedBy = _data["activatedBy"] ? UserDto.fromJS(_data["activatedBy"]) : <any>undefined;
            this.installationsCount = _data["installationsCount"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadataDto.fromJS(_data["metadata"]) : new LicenseMetadataDto();
        }
    }

    static fromJS(data: any): LicenseInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licenseId"] = this.licenseId;
        data["licenseKey"] = this.licenseKey;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["activated"] = this.activated ? this.activated.toISOString() : <any>undefined;
        data["revoked"] = this.revoked ? this.revoked.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        data["lastActivated"] = this.lastActivated ? this.lastActivated.toISOString() : <any>undefined;
        data["activatedBy"] = this.activatedBy ? this.activatedBy.toJSON() : <any>undefined;
        data["installationsCount"] = this.installationsCount;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }

    clone(): LicenseInstanceDto {
        const json = this.toJSON();
        let result = new LicenseInstanceDto();
        result.init(json);
        return result;
    }
}

export interface ILicenseInstanceDto {
    id: string;
    licenseId: string;
    licenseKey?: string | undefined;
    expirationDate?: Date | undefined;
    activated?: Date | undefined;
    revoked?: Date | undefined;
    created?: Date | undefined;
    createdBy?: UserDto | undefined;
    lastModified?: Date | undefined;
    hidden?: Date | undefined;
    lastActivated?: Date | undefined;
    activatedBy?: UserDto | undefined;
    installationsCount: number;
    tags: string[];
    metadata: LicenseMetadataDto;
}

export class CreateLicenseInstancesCommand implements ICreateLicenseInstancesCommand {
    licenseId!: string;
    count!: number;

    constructor(data?: ICreateLicenseInstancesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseId = _data["licenseId"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): CreateLicenseInstancesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLicenseInstancesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseId"] = this.licenseId;
        data["count"] = this.count;
        return data;
    }

    clone(): CreateLicenseInstancesCommand {
        const json = this.toJSON();
        let result = new CreateLicenseInstancesCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateLicenseInstancesCommand {
    licenseId: string;
    count: number;
}

export class UpdateLicenseInstanceCommand implements IUpdateLicenseInstanceCommand {
    licenseInstanceId!: string;
    expirationDate?: Date | undefined;
    revocationDate?: Date | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;

    constructor(data?: IUpdateLicenseInstanceCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licenseInstanceId = _data["licenseInstanceId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.revocationDate = _data["revocationDate"] ? new Date(_data["revocationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.metadata = _data["metadata"] ? LicenseMetadata.fromJS(_data["metadata"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateLicenseInstanceCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLicenseInstanceCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licenseInstanceId"] = this.licenseInstanceId;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        data["revocationDate"] = this.revocationDate ? this.revocationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
        return data;
    }

    clone(): UpdateLicenseInstanceCommand {
        const json = this.toJSON();
        let result = new UpdateLicenseInstanceCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateLicenseInstanceCommand {
    licenseInstanceId: string;
    expirationDate?: Date | undefined;
    revocationDate?: Date | undefined;
    tags?: string[] | undefined;
    metadata?: LicenseMetadata | undefined;
}

export class PaginatedListOfQuestionnaireDto implements IPaginatedListOfQuestionnaireDto {
    items!: QuestionnaireDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfQuestionnaireDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionnaireDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionnaireDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfQuestionnaireDto {
        const json = this.toJSON();
        let result = new PaginatedListOfQuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfQuestionnaireDto {
    items: QuestionnaireDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class QuestionnaireDto extends ContainerDto implements IQuestionnaireDto {
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireDto {
        const json = this.toJSON();
        let result = new QuestionnaireDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireDto extends IContainerDto {
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export enum QuestionnaireInstantiationMode {
    None = "none",
    Manual = "manual",
    Auto = "auto",
    Both = "both",
}

export enum QuestionnaireEditingMode {
    Anytime = "anytime",
    UntilCompleted = "untilCompleted",
}

export class QuestionnaireDetailsDto extends ContainerDetailsDto implements IQuestionnaireDetailsDto {
    pages!: ContentPageDto[];
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;

    constructor(data?: IQuestionnaireDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
        }
    }

    static override fromJS(data: any): QuestionnaireDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireDetailsDto {
        const json = this.toJSON();
        let result = new QuestionnaireDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireDetailsDto extends IContainerDetailsDto {
    pages: ContentPageDto[];
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
}

export class CreateQuestionnaireCommand implements ICreateQuestionnaireCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new CreateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateQuestionnaireCommand {
    name: string;
    projectId: string;
}

export class UpdateQuestionnaireCommand implements IUpdateQuestionnaireCommand {
    questionnaireId!: string;
    name!: string;
    uniqueLabel!: string;
    title!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    pages!: ContentPageDto[];
    instantiationMode!: QuestionnaireInstantiationMode;
    editingMode!: QuestionnaireEditingMode;
    condition?: ContainerCondition | undefined;
    sharingOptions!: ContainerSharingOption[];

    constructor(data?: IUpdateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
            this.pages = [];
            this.sharingOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionnaireId = _data["questionnaireId"];
            this.name = _data["name"];
            this.uniqueLabel = _data["uniqueLabel"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            this.instantiationMode = _data["instantiationMode"];
            this.editingMode = _data["editingMode"];
            this.condition = _data["condition"] ? ContainerCondition.fromJS(_data["condition"]) : <any>undefined;
            if (Array.isArray(_data["sharingOptions"])) {
                this.sharingOptions = [] as any;
                for (let item of _data["sharingOptions"])
                    this.sharingOptions!.push(ContainerSharingOption.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionnaireId"] = this.questionnaireId;
        data["name"] = this.name;
        data["uniqueLabel"] = this.uniqueLabel;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        data["instantiationMode"] = this.instantiationMode;
        data["editingMode"] = this.editingMode;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        if (Array.isArray(this.sharingOptions)) {
            data["sharingOptions"] = [];
            for (let item of this.sharingOptions)
                data["sharingOptions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new UpdateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateQuestionnaireCommand {
    questionnaireId: string;
    name: string;
    uniqueLabel: string;
    title: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    pages: ContentPageDto[];
    instantiationMode: QuestionnaireInstantiationMode;
    editingMode: QuestionnaireEditingMode;
    condition?: ContainerCondition | undefined;
    sharingOptions: ContainerSharingOption[];
}

export class TranslateQuestionnaireCommand implements ITranslateQuestionnaireCommand {
    containerId!: string;
    fromLanguageId?: string | undefined;
    toLanguageId?: string | undefined;

    constructor(data?: ITranslateQuestionnaireCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.containerId = _data["containerId"];
            this.fromLanguageId = _data["fromLanguageId"];
            this.toLanguageId = _data["toLanguageId"];
        }
    }

    static fromJS(data: any): TranslateQuestionnaireCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TranslateQuestionnaireCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["containerId"] = this.containerId;
        data["fromLanguageId"] = this.fromLanguageId;
        data["toLanguageId"] = this.toLanguageId;
        return data;
    }

    clone(): TranslateQuestionnaireCommand {
        const json = this.toJSON();
        let result = new TranslateQuestionnaireCommand();
        result.init(json);
        return result;
    }
}

export interface ITranslateQuestionnaireCommand {
    containerId: string;
    fromLanguageId?: string | undefined;
    toLanguageId?: string | undefined;
}

export class PaginatedListOfQuestionnaireInstanceDto implements IPaginatedListOfQuestionnaireInstanceDto {
    items!: QuestionnaireInstanceDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfQuestionnaireInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(QuestionnaireInstanceDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfQuestionnaireInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfQuestionnaireInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfQuestionnaireInstanceDto {
        const json = this.toJSON();
        let result = new PaginatedListOfQuestionnaireInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfQuestionnaireInstanceDto {
    items: QuestionnaireInstanceDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class QuestionnaireInstanceDto extends TenantEntityDto implements IQuestionnaireInstanceDto {
    name!: string;
    questionnaireId!: string;
    questionnaireName!: string;
    questionnaireVersion!: number;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: QuestionnaireInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;

    constructor(data?: IQuestionnaireInstanceDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.questionnaireId = _data["questionnaireId"];
            this.questionnaireName = _data["questionnaireName"];
            this.questionnaireVersion = _data["questionnaireVersion"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>undefined;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : <any>undefined;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
        }
    }

    static override fromJS(data: any): QuestionnaireInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaireName"] = this.questionnaireName;
        data["questionnaireVersion"] = this.questionnaireVersion;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>undefined;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        data["state"] = this.state;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireInstanceDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceDto extends ITenantEntityDto {
    name: string;
    questionnaireId: string;
    questionnaireName: string;
    questionnaireVersion: number;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: QuestionnaireInstanceState;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
}

export enum QuestionnaireInstanceState {
    NotStarted = "notStarted",
    InProgress = "inProgress",
    Completed = "completed",
}

export class QuestionnaireInstanceDetailsDto extends TenantEntityDto implements IQuestionnaireInstanceDetailsDto {
    name!: string;
    questionnaireId!: string;
    questionnaireName!: string;
    questionnaireVersion!: number;
    projectId!: string;
    projectName!: string;
    created!: Date;
    lastModified!: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state!: QuestionnaireInstanceState;
    pages!: ContentPageDto[];
    languages!: LanguageDto[];
    defaultLanguage!: LanguageDto;
    executionLanguage?: LanguageDto | undefined;
    executionInfo?: QuestionnaireInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions!: number;
    amountAnswers!: number;

    constructor(data?: IQuestionnaireInstanceDetailsDto) {
        super(data);
        if (!data) {
            this.pages = [];
            this.languages = [];
            this.defaultLanguage = new LanguageDto();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.questionnaireId = _data["questionnaireId"];
            this.questionnaireName = _data["questionnaireName"];
            this.questionnaireVersion = _data["questionnaireVersion"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.started = _data["started"] ? new Date(_data["started"].toString()) : <any>undefined;
            this.completed = _data["completed"] ? new Date(_data["completed"].toString()) : <any>undefined;
            this.hidden = _data["hidden"] ? new Date(_data["hidden"].toString()) : <any>undefined;
            this.state = _data["state"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(ContentPageDto.fromJS(item));
            }
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageDto.fromJS(_data["defaultLanguage"]) : new LanguageDto();
            this.executionLanguage = _data["executionLanguage"] ? LanguageDto.fromJS(_data["executionLanguage"]) : <any>undefined;
            this.executionInfo = _data["executionInfo"] ? QuestionnaireInstanceExecutionInfoDto.fromJS(_data["executionInfo"]) : <any>undefined;
            this.owner = _data["owner"] ? ProjectParticipantDto.fromJS(_data["owner"]) : <any>undefined;
            this.amountQuestions = _data["amountQuestions"];
            this.amountAnswers = _data["amountAnswers"];
        }
    }

    static override fromJS(data: any): QuestionnaireInstanceDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaireName"] = this.questionnaireName;
        data["questionnaireVersion"] = this.questionnaireVersion;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["started"] = this.started ? this.started.toISOString() : <any>undefined;
        data["completed"] = this.completed ? this.completed.toISOString() : <any>undefined;
        data["hidden"] = this.hidden ? this.hidden.toISOString() : <any>undefined;
        data["state"] = this.state;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        data["executionLanguage"] = this.executionLanguage ? this.executionLanguage.toJSON() : <any>undefined;
        data["executionInfo"] = this.executionInfo ? this.executionInfo.toJSON() : <any>undefined;
        data["owner"] = this.owner ? this.owner.toJSON() : <any>undefined;
        data["amountQuestions"] = this.amountQuestions;
        data["amountAnswers"] = this.amountAnswers;
        super.toJSON(data);
        return data;
    }

    clone(): QuestionnaireInstanceDetailsDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceDetailsDto extends ITenantEntityDto {
    name: string;
    questionnaireId: string;
    questionnaireName: string;
    questionnaireVersion: number;
    projectId: string;
    projectName: string;
    created: Date;
    lastModified: Date;
    started?: Date | undefined;
    completed?: Date | undefined;
    hidden?: Date | undefined;
    state: QuestionnaireInstanceState;
    pages: ContentPageDto[];
    languages: LanguageDto[];
    defaultLanguage: LanguageDto;
    executionLanguage?: LanguageDto | undefined;
    executionInfo?: QuestionnaireInstanceExecutionInfoDto | undefined;
    owner?: ProjectParticipantDto | undefined;
    amountQuestions: number;
    amountAnswers: number;
}

export class QuestionnaireInstanceExecutionInfoDto implements IQuestionnaireInstanceExecutionInfoDto {
    appId!: string;
    appIdentifier!: string;
    appVersion!: string;
    appBuild!: string;
    deviceId!: string;
    deviceManufacturer!: string;
    deviceModel!: string;
    deviceOsVersion!: string;
    deviceLanguage!: string;
    deviceTimezone!: string;

    constructor(data?: IQuestionnaireInstanceExecutionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appIdentifier = _data["appIdentifier"];
            this.appVersion = _data["appVersion"];
            this.appBuild = _data["appBuild"];
            this.deviceId = _data["deviceId"];
            this.deviceManufacturer = _data["deviceManufacturer"];
            this.deviceModel = _data["deviceModel"];
            this.deviceOsVersion = _data["deviceOsVersion"];
            this.deviceLanguage = _data["deviceLanguage"];
            this.deviceTimezone = _data["deviceTimezone"];
        }
    }

    static fromJS(data: any): QuestionnaireInstanceExecutionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceExecutionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appIdentifier"] = this.appIdentifier;
        data["appVersion"] = this.appVersion;
        data["appBuild"] = this.appBuild;
        data["deviceId"] = this.deviceId;
        data["deviceManufacturer"] = this.deviceManufacturer;
        data["deviceModel"] = this.deviceModel;
        data["deviceOsVersion"] = this.deviceOsVersion;
        data["deviceLanguage"] = this.deviceLanguage;
        data["deviceTimezone"] = this.deviceTimezone;
        return data;
    }

    clone(): QuestionnaireInstanceExecutionInfoDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceExecutionInfoDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceExecutionInfoDto {
    appId: string;
    appIdentifier: string;
    appVersion: string;
    appBuild: string;
    deviceId: string;
    deviceManufacturer: string;
    deviceModel: string;
    deviceOsVersion: string;
    deviceLanguage: string;
    deviceTimezone: string;
}

export class PaginatedListOfScheduleDto implements IPaginatedListOfScheduleDto {
    items!: ScheduleDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScheduleDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfScheduleDto {
        const json = this.toJSON();
        let result = new PaginatedListOfScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfScheduleDto {
    items: ScheduleDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ScheduleDto implements IScheduleDto {
    id!: string;
    name!: string;
    activated?: Date | undefined;

    constructor(data?: IScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activated"] = this.activated ? this.activated.toISOString() : <any>undefined;
        return data;
    }

    clone(): ScheduleDto {
        const json = this.toJSON();
        let result = new ScheduleDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleDto {
    id: string;
    name: string;
    activated?: Date | undefined;
}

export class ScheduleDetailsDto implements IScheduleDetailsDto {
    id!: string;
    name!: string;
    activated?: Date | undefined;
    processModel!: ProcessModelDto;

    constructor(data?: IScheduleDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.processModel = new ProcessModelDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.activated = _data["activated"] ? new Date(_data["activated"].toString()) : <any>undefined;
            this.processModel = _data["processModel"] ? ProcessModelDto.fromJS(_data["processModel"]) : new ProcessModelDto();
        }
    }

    static fromJS(data: any): ScheduleDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["activated"] = this.activated ? this.activated.toISOString() : <any>undefined;
        data["processModel"] = this.processModel ? this.processModel.toJSON() : <any>undefined;
        return data;
    }

    clone(): ScheduleDetailsDto {
        const json = this.toJSON();
        let result = new ScheduleDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IScheduleDetailsDto {
    id: string;
    name: string;
    activated?: Date | undefined;
    processModel: ProcessModelDto;
}

export class ProcessModelDto implements IProcessModelDto {
    steps!: StepDto[];
    transitions!: TransitionDto[];

    constructor(data?: IProcessModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.transitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepDto.fromJS(item));
            }
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(TransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProcessModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProcessModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        return data;
    }

    clone(): ProcessModelDto {
        const json = this.toJSON();
        let result = new ProcessModelDto();
        result.init(json);
        return result;
    }
}

export interface IProcessModelDto {
    steps: StepDto[];
    transitions: TransitionDto[];
}

export class StepDto implements IStepDto {
    name!: string;
    identifier!: string;
    action!: StepAction;
    rRule?: string | undefined;
    condition?: StepCondition | undefined;
    questionnaireId?: string | undefined;

    constructor(data?: IStepDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.identifier = _data["identifier"];
            this.action = _data["action"];
            this.rRule = _data["rRule"];
            this.condition = _data["condition"] ? StepCondition.fromJS(_data["condition"]) : <any>undefined;
            this.questionnaireId = _data["questionnaireId"];
        }
    }

    static fromJS(data: any): StepDto {
        data = typeof data === 'object' ? data : {};
        let result = new StepDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["identifier"] = this.identifier;
        data["action"] = this.action;
        data["rRule"] = this.rRule;
        data["condition"] = this.condition ? this.condition.toJSON() : <any>undefined;
        data["questionnaireId"] = this.questionnaireId;
        return data;
    }

    clone(): StepDto {
        const json = this.toJSON();
        let result = new StepDto();
        result.init(json);
        return result;
    }
}

export interface IStepDto {
    name: string;
    identifier: string;
    action: StepAction;
    rRule?: string | undefined;
    condition?: StepCondition | undefined;
    questionnaireId?: string | undefined;
}

export enum StepAction {
    None = "none",
    InstantiateQuestionnaire = "instantiateQuestionnaire",
}

export class StepCondition extends Condition implements IStepCondition {

    constructor(data?: IStepCondition) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StepCondition {
        data = typeof data === 'object' ? data : {};
        let result = new StepCondition();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StepCondition {
        const json = this.toJSON();
        let result = new StepCondition();
        result.init(json);
        return result;
    }
}

export interface IStepCondition extends ICondition {
}

export class TransitionDto implements ITransitionDto {
    sourceIdentifier!: string;
    targetIdentifier!: string;
    delay?: string | undefined;

    constructor(data?: ITransitionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceIdentifier = _data["sourceIdentifier"];
            this.targetIdentifier = _data["targetIdentifier"];
            this.delay = _data["delay"];
        }
    }

    static fromJS(data: any): TransitionDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransitionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceIdentifier"] = this.sourceIdentifier;
        data["targetIdentifier"] = this.targetIdentifier;
        data["delay"] = this.delay;
        return data;
    }

    clone(): TransitionDto {
        const json = this.toJSON();
        let result = new TransitionDto();
        result.init(json);
        return result;
    }
}

export interface ITransitionDto {
    sourceIdentifier: string;
    targetIdentifier: string;
    delay?: string | undefined;
}

export class CreateScheduleCommand implements ICreateScheduleCommand {
    name!: string;
    projectId!: string;

    constructor(data?: ICreateScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): CreateScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectId"] = this.projectId;
        return data;
    }

    clone(): CreateScheduleCommand {
        const json = this.toJSON();
        let result = new CreateScheduleCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateScheduleCommand {
    name: string;
    projectId: string;
}

export class UpdateScheduleCommand implements IUpdateScheduleCommand {
    scheduleId!: string;
    name!: string;
    steps!: StepDto[];
    transitions!: TransitionDto[];

    constructor(data?: IUpdateScheduleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.steps = [];
            this.transitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scheduleId = _data["scheduleId"];
            this.name = _data["name"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [] as any;
                for (let item of _data["steps"])
                    this.steps!.push(StepDto.fromJS(item));
            }
            if (Array.isArray(_data["transitions"])) {
                this.transitions = [] as any;
                for (let item of _data["transitions"])
                    this.transitions!.push(TransitionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateScheduleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scheduleId"] = this.scheduleId;
        data["name"] = this.name;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.transitions)) {
            data["transitions"] = [];
            for (let item of this.transitions)
                data["transitions"].push(item.toJSON());
        }
        return data;
    }

    clone(): UpdateScheduleCommand {
        const json = this.toJSON();
        let result = new UpdateScheduleCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateScheduleCommand {
    scheduleId: string;
    name: string;
    steps: StepDto[];
    transitions: TransitionDto[];
}

export class StudyStatisticsDto implements IStudyStatisticsDto {
    amount!: number;

    constructor(data?: IStudyStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): StudyStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        return data;
    }

    clone(): StudyStatisticsDto {
        const json = this.toJSON();
        let result = new StudyStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IStudyStatisticsDto {
    amount: number;
}

export class QuestionnaireStatisticsDto implements IQuestionnaireStatisticsDto {
    amount!: number;
    averageAmountInstances!: number;
    averageAmountCompletedInstances!: number;

    constructor(data?: IQuestionnaireStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.averageAmountInstances = _data["averageAmountInstances"];
            this.averageAmountCompletedInstances = _data["averageAmountCompletedInstances"];
        }
    }

    static fromJS(data: any): QuestionnaireStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["averageAmountInstances"] = this.averageAmountInstances;
        data["averageAmountCompletedInstances"] = this.averageAmountCompletedInstances;
        return data;
    }

    clone(): QuestionnaireStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionnaireStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireStatisticsDto {
    amount: number;
    averageAmountInstances: number;
    averageAmountCompletedInstances: number;
}

export class ParticipantStatisticsDto implements IParticipantStatisticsDto {
    amount!: number;
    averageAmountStudies!: number;
    averageAmountQuestionnaireInstances!: number;
    averageAmountCompletedQuestionnaireInstances!: number;
    averageAmountAnsweredAnswers!: number;

    constructor(data?: IParticipantStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.averageAmountStudies = _data["averageAmountStudies"];
            this.averageAmountQuestionnaireInstances = _data["averageAmountQuestionnaireInstances"];
            this.averageAmountCompletedQuestionnaireInstances = _data["averageAmountCompletedQuestionnaireInstances"];
            this.averageAmountAnsweredAnswers = _data["averageAmountAnsweredAnswers"];
        }
    }

    static fromJS(data: any): ParticipantStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParticipantStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["averageAmountStudies"] = this.averageAmountStudies;
        data["averageAmountQuestionnaireInstances"] = this.averageAmountQuestionnaireInstances;
        data["averageAmountCompletedQuestionnaireInstances"] = this.averageAmountCompletedQuestionnaireInstances;
        data["averageAmountAnsweredAnswers"] = this.averageAmountAnsweredAnswers;
        return data;
    }

    clone(): ParticipantStatisticsDto {
        const json = this.toJSON();
        let result = new ParticipantStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IParticipantStatisticsDto {
    amount: number;
    averageAmountStudies: number;
    averageAmountQuestionnaireInstances: number;
    averageAmountCompletedQuestionnaireInstances: number;
    averageAmountAnsweredAnswers: number;
}

export class QuestionnaireInstanceStatisticsDto implements IQuestionnaireInstanceStatisticsDto {
    amountTotal!: number;
    amountCompleted!: number;
    interval!: string;
    averageAmountCompletedPerInterval!: number;
    questionnaireInstancesPerInterval!: QuestionnaireInstancesPerIntervalDto[];

    constructor(data?: IQuestionnaireInstanceStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.questionnaireInstancesPerInterval = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountTotal = _data["amountTotal"];
            this.amountCompleted = _data["amountCompleted"];
            this.interval = _data["interval"];
            this.averageAmountCompletedPerInterval = _data["averageAmountCompletedPerInterval"];
            if (Array.isArray(_data["questionnaireInstancesPerInterval"])) {
                this.questionnaireInstancesPerInterval = [] as any;
                for (let item of _data["questionnaireInstancesPerInterval"])
                    this.questionnaireInstancesPerInterval!.push(QuestionnaireInstancesPerIntervalDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QuestionnaireInstanceStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstanceStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountTotal"] = this.amountTotal;
        data["amountCompleted"] = this.amountCompleted;
        data["interval"] = this.interval;
        data["averageAmountCompletedPerInterval"] = this.averageAmountCompletedPerInterval;
        if (Array.isArray(this.questionnaireInstancesPerInterval)) {
            data["questionnaireInstancesPerInterval"] = [];
            for (let item of this.questionnaireInstancesPerInterval)
                data["questionnaireInstancesPerInterval"].push(item.toJSON());
        }
        return data;
    }

    clone(): QuestionnaireInstanceStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstanceStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstanceStatisticsDto {
    amountTotal: number;
    amountCompleted: number;
    interval: string;
    averageAmountCompletedPerInterval: number;
    questionnaireInstancesPerInterval: QuestionnaireInstancesPerIntervalDto[];
}

export class QuestionnaireInstancesPerIntervalDto implements IQuestionnaireInstancesPerIntervalDto {
    dateTime!: Date;
    amountTotal!: number;
    amountCompleted!: number;

    constructor(data?: IQuestionnaireInstancesPerIntervalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>undefined;
            this.amountTotal = _data["amountTotal"];
            this.amountCompleted = _data["amountCompleted"];
        }
    }

    static fromJS(data: any): QuestionnaireInstancesPerIntervalDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionnaireInstancesPerIntervalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        data["amountTotal"] = this.amountTotal;
        data["amountCompleted"] = this.amountCompleted;
        return data;
    }

    clone(): QuestionnaireInstancesPerIntervalDto {
        const json = this.toJSON();
        let result = new QuestionnaireInstancesPerIntervalDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionnaireInstancesPerIntervalDto {
    dateTime: Date;
    amountTotal: number;
    amountCompleted: number;
}

export class GetQuestionnaireInstanceStatisticsQuery implements IGetQuestionnaireInstanceStatisticsQuery {
    projectIds?: string[] | undefined;
    questionnaireIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    groupInterval?: string | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;

    constructor(data?: IGetQuestionnaireInstanceStatisticsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["questionnaireIds"])) {
                this.questionnaireIds = [] as any;
                for (let item of _data["questionnaireIds"])
                    this.questionnaireIds!.push(item);
            }
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            this.groupInterval = _data["groupInterval"];
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
            if (Array.isArray(_data["anyOfFilterParameters"])) {
                this.anyOfFilterParameters = [] as any;
                for (let item of _data["anyOfFilterParameters"])
                    this.anyOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
            if (Array.isArray(_data["allOfFilterParameters"])) {
                this.allOfFilterParameters = [] as any;
                for (let item of _data["allOfFilterParameters"])
                    this.allOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionnaireInstanceStatisticsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionnaireInstanceStatisticsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.questionnaireIds)) {
            data["questionnaireIds"] = [];
            for (let item of this.questionnaireIds)
                data["questionnaireIds"].push(item);
        }
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        data["groupInterval"] = this.groupInterval;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        if (Array.isArray(this.anyOfFilterParameters)) {
            data["anyOfFilterParameters"] = [];
            for (let item of this.anyOfFilterParameters)
                data["anyOfFilterParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.allOfFilterParameters)) {
            data["allOfFilterParameters"] = [];
            for (let item of this.allOfFilterParameters)
                data["allOfFilterParameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetQuestionnaireInstanceStatisticsQuery {
        const json = this.toJSON();
        let result = new GetQuestionnaireInstanceStatisticsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetQuestionnaireInstanceStatisticsQuery {
    projectIds?: string[] | undefined;
    questionnaireIds?: string[] | undefined;
    participantIds?: string[] | undefined;
    groupInterval?: string | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;
}

export class QuestionFilterParameter implements IQuestionFilterParameter {
    property!: string;
    comparator!: FilterComparator;
    value!: string;

    constructor(data?: IQuestionFilterParameter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.property = _data["property"];
            this.comparator = _data["comparator"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): QuestionFilterParameter {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionFilterParameter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["property"] = this.property;
        data["comparator"] = this.comparator;
        data["value"] = this.value;
        return data;
    }

    clone(): QuestionFilterParameter {
        const json = this.toJSON();
        let result = new QuestionFilterParameter();
        result.init(json);
        return result;
    }
}

export interface IQuestionFilterParameter {
    property: string;
    comparator: FilterComparator;
    value: string;
}

export enum FilterComparator {
    Equals = "equals",
    NotEquals = "notEquals",
    GreaterThan = "greaterThan",
    LessThan = "lessThan",
    GreaterThanOrEqual = "greaterThanOrEqual",
    LessThanOrEqual = "lessThanOrEqual",
    Like = "like",
}

export class QuestionStatisticsDto implements IQuestionStatisticsDto {
    questionId!: string;
    countTotal!: number;
    statistics?: AnswerStatisticsDto | undefined;

    constructor(data?: IQuestionStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.countTotal = _data["countTotal"];
            this.statistics = _data["statistics"] ? AnswerStatisticsDto.fromJS(_data["statistics"]) : <any>undefined;
        }
    }

    static fromJS(data: any): QuestionStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionStatisticsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["countTotal"] = this.countTotal;
        data["statistics"] = this.statistics ? this.statistics.toJSON() : <any>undefined;
        return data;
    }

    clone(): QuestionStatisticsDto {
        const json = this.toJSON();
        let result = new QuestionStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IQuestionStatisticsDto {
    questionId: string;
    countTotal: number;
    statistics?: AnswerStatisticsDto | undefined;
}

export abstract class AnswerStatisticsDto implements IAnswerStatisticsDto {

    protected _discriminator: string;

    constructor(data?: IAnswerStatisticsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "AnswerStatisticsDto";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        if (data["$type"] === "ChoiceAnswerStatisticsDto") {
            let result = new ChoiceAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "SliderAnswerStatisticsDto") {
            let result = new SliderAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TextAnswerStatisticsDto") {
            let result = new TextAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "NumberAnswerStatisticsDto") {
            let result = new NumberAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateAnswerStatisticsDto") {
            let result = new DateAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "TimeAnswerStatisticsDto") {
            let result = new TimeAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "DateTimeAnswerStatisticsDto") {
            let result = new DateTimeAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "LikertAnswerStatisticsDto") {
            let result = new LikertAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "ContainerAnswerStatisticsDto") {
            let result = new ContainerAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        if (data["$type"] === "BoolAnswerStatisticsDto") {
            let result = new BoolAnswerStatisticsDto();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AnswerStatisticsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["$type"] = this._discriminator;
        return data;
    }

    clone(): AnswerStatisticsDto {
        throw new Error("The abstract class 'AnswerStatisticsDto' cannot be instantiated.");
    }
}

export interface IAnswerStatisticsDto {
}

export class ChoiceAnswerStatisticsDto extends AnswerStatisticsDto implements IChoiceAnswerStatisticsDto {
    count!: { [key: string]: number; };
    series!: TimeSeriesDtoOfListOfGuid;

    constructor(data?: IChoiceAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.series = new TimeSeriesDtoOfListOfGuid();
        }
        this._discriminator = "ChoiceAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
            this.series = _data["series"] ? TimeSeriesDtoOfListOfGuid.fromJS(_data["series"]) : new TimeSeriesDtoOfListOfGuid();
        }
    }

    static override fromJS(data: any): ChoiceAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        data["series"] = this.series ? this.series.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): ChoiceAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new ChoiceAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IChoiceAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
    series: TimeSeriesDtoOfListOfGuid;
}

export abstract class SeriesDto implements ISeriesDto {
    name!: string;

    constructor(data?: ISeriesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SeriesDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SeriesDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): SeriesDto {
        throw new Error("The abstract class 'SeriesDto' cannot be instantiated.");
    }
}

export interface ISeriesDto {
    name: string;
}

export class TimeSeriesDtoOfListOfGuid extends SeriesDto implements ITimeSeriesDtoOfListOfGuid {
    values!: TimeSeriesDataPointDtoOfListOfGuid[];

    constructor(data?: ITimeSeriesDtoOfListOfGuid) {
        super(data);
        if (!data) {
            this.values = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TimeSeriesDataPointDtoOfListOfGuid.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDtoOfListOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDtoOfListOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDtoOfListOfGuid {
        const json = this.toJSON();
        let result = new TimeSeriesDtoOfListOfGuid();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDtoOfListOfGuid extends ISeriesDto {
    values: TimeSeriesDataPointDtoOfListOfGuid[];
}

export abstract class DataPointDto implements IDataPointDto {

    constructor(data?: IDataPointDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DataPointDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'DataPointDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DataPointDto {
        throw new Error("The abstract class 'DataPointDto' cannot be instantiated.");
    }
}

export interface IDataPointDto {
}

export class TimeSeriesDataPointDtoOfListOfGuid extends DataPointDto implements ITimeSeriesDataPointDtoOfListOfGuid {
    x!: Date;
    y!: string[];

    constructor(data?: ITimeSeriesDataPointDtoOfListOfGuid) {
        super(data);
        if (!data) {
            this.y = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : <any>undefined;
            if (Array.isArray(_data["y"])) {
                this.y = [] as any;
                for (let item of _data["y"])
                    this.y!.push(item);
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDataPointDtoOfListOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDataPointDtoOfListOfGuid();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : <any>undefined;
        if (Array.isArray(this.y)) {
            data["y"] = [];
            for (let item of this.y)
                data["y"].push(item);
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDataPointDtoOfListOfGuid {
        const json = this.toJSON();
        let result = new TimeSeriesDataPointDtoOfListOfGuid();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDataPointDtoOfListOfGuid extends IDataPointDto {
    x: Date;
    y: string[];
}

export class SliderAnswerStatisticsDto extends AnswerStatisticsDto implements ISliderAnswerStatisticsDto {
    min!: number;
    max!: number;
    average!: number;
    percentile25!: number;
    median!: number;
    percentile75!: number;
    count!: { [key: string]: number; };
    series!: TimeSeriesDtoOfDouble;

    constructor(data?: ISliderAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.series = new TimeSeriesDtoOfDouble();
        }
        this._discriminator = "SliderAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
            this.series = _data["series"] ? TimeSeriesDtoOfDouble.fromJS(_data["series"]) : new TimeSeriesDtoOfDouble();
        }
    }

    static override fromJS(data: any): SliderAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SliderAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        data["series"] = this.series ? this.series.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }

    clone(): SliderAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new SliderAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ISliderAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    average: number;
    percentile25: number;
    median: number;
    percentile75: number;
    count: { [key: string]: number; };
    series: TimeSeriesDtoOfDouble;
}

export class TimeSeriesDtoOfDouble extends SeriesDto implements ITimeSeriesDtoOfDouble {
    values!: TimeSeriesDataPointDtoOfDouble[];

    constructor(data?: ITimeSeriesDtoOfDouble) {
        super(data);
        if (!data) {
            this.values = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(TimeSeriesDataPointDtoOfDouble.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): TimeSeriesDtoOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDtoOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDtoOfDouble {
        const json = this.toJSON();
        let result = new TimeSeriesDtoOfDouble();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDtoOfDouble extends ISeriesDto {
    values: TimeSeriesDataPointDtoOfDouble[];
}

export class TimeSeriesDataPointDtoOfDouble extends DataPointDto implements ITimeSeriesDataPointDtoOfDouble {
    x!: Date;
    y!: number;

    constructor(data?: ITimeSeriesDataPointDtoOfDouble) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.x = _data["x"] ? new Date(_data["x"].toString()) : <any>undefined;
            this.y = _data["y"];
        }
    }

    static override fromJS(data: any): TimeSeriesDataPointDtoOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSeriesDataPointDtoOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["x"] = this.x ? this.x.toISOString() : <any>undefined;
        data["y"] = this.y;
        super.toJSON(data);
        return data;
    }

    clone(): TimeSeriesDataPointDtoOfDouble {
        const json = this.toJSON();
        let result = new TimeSeriesDataPointDtoOfDouble();
        result.init(json);
        return result;
    }
}

export interface ITimeSeriesDataPointDtoOfDouble extends IDataPointDto {
    x: Date;
    y: number;
}

export class TextAnswerStatisticsDto extends AnswerStatisticsDto implements ITextAnswerStatisticsDto {
    min!: number;
    max!: number;
    averageChars?: number | undefined;
    averageWords?: number | undefined;
    lengthDistribution?: { [key: string]: number; } | undefined;

    constructor(data?: ITextAnswerStatisticsDto) {
        super(data);
        this._discriminator = "TextAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.averageChars = _data["averageChars"];
            this.averageWords = _data["averageWords"];
            if (_data["lengthDistribution"]) {
                this.lengthDistribution = {} as any;
                for (let key in _data["lengthDistribution"]) {
                    if (_data["lengthDistribution"].hasOwnProperty(key))
                        (<any>this.lengthDistribution)![key] = _data["lengthDistribution"][key];
                }
            }
        }
    }

    static override fromJS(data: any): TextAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TextAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["averageChars"] = this.averageChars;
        data["averageWords"] = this.averageWords;
        if (this.lengthDistribution) {
            data["lengthDistribution"] = {};
            for (let key in this.lengthDistribution) {
                if (this.lengthDistribution.hasOwnProperty(key))
                    (<any>data["lengthDistribution"])[key] = (<any>this.lengthDistribution)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): TextAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new TextAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ITextAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    averageChars?: number | undefined;
    averageWords?: number | undefined;
    lengthDistribution?: { [key: string]: number; } | undefined;
}

export class NumberAnswerStatisticsDto extends AnswerStatisticsDto implements INumberAnswerStatisticsDto {
    min!: number;
    max!: number;
    average!: number;
    percentile25!: number;
    median!: number;
    percentile75!: number;

    constructor(data?: INumberAnswerStatisticsDto) {
        super(data);
        this._discriminator = "NumberAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
        }
    }

    static override fromJS(data: any): NumberAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new NumberAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        super.toJSON(data);
        return data;
    }

    clone(): NumberAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new NumberAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface INumberAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: number;
    max: number;
    average: number;
    percentile25: number;
    median: number;
    percentile75: number;
}

export class DateAnswerStatisticsDto extends AnswerStatisticsDto implements IDateAnswerStatisticsDto {
    min!: Date;
    max!: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: IDateAnswerStatisticsDto) {
        super(data);
        this._discriminator = "DateAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : <any>undefined;
            this.average = _data["average"] ? new Date(_data["average"].toString()) : <any>undefined;
            this.percentile25 = _data["percentile25"] ? new Date(_data["percentile25"].toString()) : <any>undefined;
            this.median = _data["median"] ? new Date(_data["median"].toString()) : <any>undefined;
            this.percentile75 = _data["percentile75"] ? new Date(_data["percentile75"].toString()) : <any>undefined;
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): DateAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? formatDate(this.min) : <any>undefined;
        data["max"] = this.max ? formatDate(this.max) : <any>undefined;
        data["average"] = this.average ? formatDate(this.average) : <any>undefined;
        data["percentile25"] = this.percentile25 ? formatDate(this.percentile25) : <any>undefined;
        data["median"] = this.median ? formatDate(this.median) : <any>undefined;
        data["percentile75"] = this.percentile75 ? formatDate(this.percentile75) : <any>undefined;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new DateAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IDateAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: Date;
    max: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class TimeAnswerStatisticsDto extends AnswerStatisticsDto implements ITimeAnswerStatisticsDto {
    min!: string;
    max!: string;
    average?: string | undefined;
    percentile25?: string | undefined;
    median?: string | undefined;
    percentile75?: string | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: ITimeAnswerStatisticsDto) {
        super(data);
        this._discriminator = "TimeAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.average = _data["average"];
            this.percentile25 = _data["percentile25"];
            this.median = _data["median"];
            this.percentile75 = _data["percentile75"];
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): TimeAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["average"] = this.average;
        data["percentile25"] = this.percentile25;
        data["median"] = this.median;
        data["percentile75"] = this.percentile75;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): TimeAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new TimeAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ITimeAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: string;
    max: string;
    average?: string | undefined;
    percentile25?: string | undefined;
    median?: string | undefined;
    percentile75?: string | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class DateTimeAnswerStatisticsDto extends AnswerStatisticsDto implements IDateTimeAnswerStatisticsDto {
    min!: Date;
    max!: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;

    constructor(data?: IDateTimeAnswerStatisticsDto) {
        super(data);
        this._discriminator = "DateTimeAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? new Date(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? new Date(_data["max"].toString()) : <any>undefined;
            this.average = _data["average"] ? new Date(_data["average"].toString()) : <any>undefined;
            this.percentile25 = _data["percentile25"] ? new Date(_data["percentile25"].toString()) : <any>undefined;
            this.median = _data["median"] ? new Date(_data["median"].toString()) : <any>undefined;
            this.percentile75 = _data["percentile75"] ? new Date(_data["percentile75"].toString()) : <any>undefined;
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): DateTimeAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? this.min.toISOString() : <any>undefined;
        data["max"] = this.max ? this.max.toISOString() : <any>undefined;
        data["average"] = this.average ? this.average.toISOString() : <any>undefined;
        data["percentile25"] = this.percentile25 ? this.percentile25.toISOString() : <any>undefined;
        data["median"] = this.median ? this.median.toISOString() : <any>undefined;
        data["percentile75"] = this.percentile75 ? this.percentile75.toISOString() : <any>undefined;
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): DateTimeAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new DateTimeAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IDateTimeAnswerStatisticsDto extends IAnswerStatisticsDto {
    min: Date;
    max: Date;
    average?: Date | undefined;
    percentile25?: Date | undefined;
    median?: Date | undefined;
    percentile75?: Date | undefined;
    count?: { [key: string]: number; } | undefined;
}

export class LikertAnswerStatisticsDto extends AnswerStatisticsDto implements ILikertAnswerStatisticsDto {
    count!: { [key: string]: number; };

    constructor(data?: ILikertAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
        }
        this._discriminator = "LikertAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
        }
    }

    static override fromJS(data: any): LikertAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new LikertAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): LikertAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new LikertAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface ILikertAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
}

export class ContainerAnswerStatisticsDto extends AnswerStatisticsDto implements IContainerAnswerStatisticsDto {
    count!: { [key: string]: number; };
    containers!: { [key: string]: TenantEntityDto; };

    constructor(data?: IContainerAnswerStatisticsDto) {
        super(data);
        if (!data) {
            this.count = {};
            this.containers = {};
        }
        this._discriminator = "ContainerAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["count"]) {
                this.count = {} as any;
                for (let key in _data["count"]) {
                    if (_data["count"].hasOwnProperty(key))
                        (<any>this.count)![key] = _data["count"][key];
                }
            }
            if (_data["containers"]) {
                this.containers = {} as any;
                for (let key in _data["containers"]) {
                    if (_data["containers"].hasOwnProperty(key))
                        (<any>this.containers)![key] = _data["containers"][key] ? TenantEntityDto.fromJS(_data["containers"][key]) : new TenantEntityDto();
                }
            }
        }
    }

    static override fromJS(data: any): ContainerAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.count) {
            data["count"] = {};
            for (let key in this.count) {
                if (this.count.hasOwnProperty(key))
                    (<any>data["count"])[key] = (<any>this.count)[key];
            }
        }
        if (this.containers) {
            data["containers"] = {};
            for (let key in this.containers) {
                if (this.containers.hasOwnProperty(key))
                    (<any>data["containers"])[key] = this.containers[key] ? this.containers[key].toJSON() : <any>undefined;
            }
        }
        super.toJSON(data);
        return data;
    }

    clone(): ContainerAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new ContainerAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IContainerAnswerStatisticsDto extends IAnswerStatisticsDto {
    count: { [key: string]: number; };
    containers: { [key: string]: TenantEntityDto; };
}

export class BoolAnswerStatisticsDto extends AnswerStatisticsDto implements IBoolAnswerStatisticsDto {
    trueCount!: number;
    falseCount!: number;

    constructor(data?: IBoolAnswerStatisticsDto) {
        super(data);
        this._discriminator = "BoolAnswerStatisticsDto";
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.trueCount = _data["trueCount"];
            this.falseCount = _data["falseCount"];
        }
    }

    static override fromJS(data: any): BoolAnswerStatisticsDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolAnswerStatisticsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["trueCount"] = this.trueCount;
        data["falseCount"] = this.falseCount;
        super.toJSON(data);
        return data;
    }

    clone(): BoolAnswerStatisticsDto {
        const json = this.toJSON();
        let result = new BoolAnswerStatisticsDto();
        result.init(json);
        return result;
    }
}

export interface IBoolAnswerStatisticsDto extends IAnswerStatisticsDto {
    trueCount: number;
    falseCount: number;
}

export class GetQuestionStatisticsQuery implements IGetQuestionStatisticsQuery {
    questionId!: string;
    participantIds?: string[] | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;

    constructor(data?: IGetQuestionStatisticsQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            if (Array.isArray(_data["participantIds"])) {
                this.participantIds = [] as any;
                for (let item of _data["participantIds"])
                    this.participantIds!.push(item);
            }
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.until = _data["until"] ? new Date(_data["until"].toString()) : <any>undefined;
            if (Array.isArray(_data["anyOfFilterParameters"])) {
                this.anyOfFilterParameters = [] as any;
                for (let item of _data["anyOfFilterParameters"])
                    this.anyOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
            if (Array.isArray(_data["allOfFilterParameters"])) {
                this.allOfFilterParameters = [] as any;
                for (let item of _data["allOfFilterParameters"])
                    this.allOfFilterParameters!.push(QuestionFilterParameter.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetQuestionStatisticsQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetQuestionStatisticsQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        if (Array.isArray(this.participantIds)) {
            data["participantIds"] = [];
            for (let item of this.participantIds)
                data["participantIds"].push(item);
        }
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["until"] = this.until ? this.until.toISOString() : <any>undefined;
        if (Array.isArray(this.anyOfFilterParameters)) {
            data["anyOfFilterParameters"] = [];
            for (let item of this.anyOfFilterParameters)
                data["anyOfFilterParameters"].push(item.toJSON());
        }
        if (Array.isArray(this.allOfFilterParameters)) {
            data["allOfFilterParameters"] = [];
            for (let item of this.allOfFilterParameters)
                data["allOfFilterParameters"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetQuestionStatisticsQuery {
        const json = this.toJSON();
        let result = new GetQuestionStatisticsQuery();
        result.init(json);
        return result;
    }
}

export interface IGetQuestionStatisticsQuery {
    questionId: string;
    participantIds?: string[] | undefined;
    from?: Date | undefined;
    until?: Date | undefined;
    anyOfFilterParameters?: QuestionFilterParameter[] | undefined;
    allOfFilterParameters?: QuestionFilterParameter[] | undefined;
}

export class PaginatedListOfStudyDto implements IPaginatedListOfStudyDto {
    items!: StudyDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfStudyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StudyDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfStudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfStudyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfStudyDto {
        const json = this.toJSON();
        let result = new PaginatedListOfStudyDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfStudyDto {
    items: StudyDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export abstract class ProjectDto extends TenantEntityDto implements IProjectDto {
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility!: ProjectVisibility;
    languages!: LanguageDto[];

    constructor(data?: IProjectDto) {
        super(data);
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.languages = [];
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : <any>undefined;
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["published"] = this.published ? this.published.toISOString() : <any>undefined;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }

    clone(): ProjectDto {
        throw new Error("The abstract class 'ProjectDto' cannot be instantiated.");
    }
}

export interface IProjectDto extends ITenantEntityDto {
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    asset?: AssetDto | undefined;
    published?: Date | undefined;
    visibility: ProjectVisibility;
    languages: LanguageDto[];
}

export class StudyDto extends ProjectDto implements IStudyDto {

    constructor(data?: IStudyDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudyDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StudyDto {
        const json = this.toJSON();
        let result = new StudyDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDto extends IProjectDto {
}

export enum ProjectVisibility {
    Private = "private",
    Internal = "internal",
    Public = "public",
}

export abstract class ProjectDetailsDto implements IProjectDetailsDto {
    id!: string;
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguage!: LanguageDto;
    languages!: LanguageDto[];
    asset?: AssetDto | undefined;
    assetFolder?: AssetFolderDto | undefined;
    published?: Date | undefined;
    visibility!: ProjectVisibility;
    permissions!: Permission[];

    constructor(data?: IProjectDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new LanguageDto();
            this.languages = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageDto.fromJS(_data["defaultLanguage"]) : new LanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            this.assetFolder = _data["assetFolder"] ? AssetFolderDto.fromJS(_data["assetFolder"]) : <any>undefined;
            this.published = _data["published"] ? new Date(_data["published"].toString()) : <any>undefined;
            this.visibility = _data["visibility"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectDetailsDto {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ProjectDetailsDto' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        data["assetFolder"] = this.assetFolder ? this.assetFolder.toJSON() : <any>undefined;
        data["published"] = this.published ? this.published.toISOString() : <any>undefined;
        data["visibility"] = this.visibility;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): ProjectDetailsDto {
        throw new Error("The abstract class 'ProjectDetailsDto' cannot be instantiated.");
    }
}

export interface IProjectDetailsDto {
    id: string;
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguage: LanguageDto;
    languages: LanguageDto[];
    asset?: AssetDto | undefined;
    assetFolder?: AssetFolderDto | undefined;
    published?: Date | undefined;
    visibility: ProjectVisibility;
    permissions: Permission[];
}

export class StudyDetailsDto extends ProjectDetailsDto implements IStudyDetailsDto {

    constructor(data?: IStudyDetailsDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): StudyDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new StudyDetailsDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): StudyDetailsDto {
        const json = this.toJSON();
        let result = new StudyDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IStudyDetailsDto extends IProjectDetailsDto {
}

export enum Permission {
    CanEditPages = "canEditPages",
    CanEditContainers = "canEditContainers",
    CanEditSchedules = "canEditSchedules",
    CanEditAssets = "canEditAssets",
    CanEditParticipants = "canEditParticipants",
    CanEditAdministrators = "canEditAdministrators",
    CanEditSettings = "canEditSettings",
    CanReadContainerInstances = "canReadContainerInstances",
    CanEditContainerInstances = "canEditContainerInstances",
    CanReadLicenses = "canReadLicenses",
    CanEditLicenses = "canEditLicenses",
}

export class CreateStudyCommand implements ICreateStudyCommand {
    name!: string;

    constructor(data?: ICreateStudyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CreateStudyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateStudyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }

    clone(): CreateStudyCommand {
        const json = this.toJSON();
        let result = new CreateStudyCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateStudyCommand {
    name: string;
}

export class UpdateStudyCommand implements IUpdateStudyCommand {
    studyId!: string;
    name!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguageId!: string;
    languageIds!: string[];
    visibility!: ProjectVisibility;
    assetId?: string | undefined;

    constructor(data?: IUpdateStudyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.languageIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studyId = _data["studyId"];
            this.name = _data["name"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguageId = _data["defaultLanguageId"];
            if (Array.isArray(_data["languageIds"])) {
                this.languageIds = [] as any;
                for (let item of _data["languageIds"])
                    this.languageIds!.push(item);
            }
            this.visibility = _data["visibility"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateStudyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studyId"] = this.studyId;
        data["name"] = this.name;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguageId"] = this.defaultLanguageId;
        if (Array.isArray(this.languageIds)) {
            data["languageIds"] = [];
            for (let item of this.languageIds)
                data["languageIds"].push(item);
        }
        data["visibility"] = this.visibility;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateStudyCommand {
        const json = this.toJSON();
        let result = new UpdateStudyCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudyCommand {
    studyId: string;
    name: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguageId: string;
    languageIds: string[];
    visibility: ProjectVisibility;
    assetId?: string | undefined;
}

export class QrCodeDto implements IQrCodeDto {
    base64QrCode!: string;
    qrCodeUrl!: string;

    constructor(data?: IQrCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.base64QrCode = _data["base64QrCode"];
            this.qrCodeUrl = _data["qrCodeUrl"];
        }
    }

    static fromJS(data: any): QrCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new QrCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["base64QrCode"] = this.base64QrCode;
        data["qrCodeUrl"] = this.qrCodeUrl;
        return data;
    }

    clone(): QrCodeDto {
        const json = this.toJSON();
        let result = new QrCodeDto();
        result.init(json);
        return result;
    }
}

export interface IQrCodeDto {
    base64QrCode: string;
    qrCodeUrl: string;
}

export class PaginatedListOfProjectParticipantDto implements IPaginatedListOfProjectParticipantDto {
    items!: ProjectParticipantDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfProjectParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectParticipantDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfProjectParticipantDto {
        const json = this.toJSON();
        let result = new PaginatedListOfProjectParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfProjectParticipantDto {
    items: ProjectParticipantDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class PaginatedListOfProjectAdministratorDto implements IPaginatedListOfProjectAdministratorDto {
    items!: ProjectAdministratorDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfProjectAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProjectAdministratorDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfProjectAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfProjectAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfProjectAdministratorDto {
        const json = this.toJSON();
        let result = new PaginatedListOfProjectAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfProjectAdministratorDto {
    items: ProjectAdministratorDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class ProjectAdministratorDto implements IProjectAdministratorDto {
    user!: UserDto;
    projectId!: string;
    permissions!: Permission[];

    constructor(data?: IProjectAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): ProjectAdministratorDto {
        const json = this.toJSON();
        let result = new ProjectAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IProjectAdministratorDto {
    user: UserDto;
    projectId: string;
    permissions: Permission[];
}

export class TenantDetailsDto implements ITenantDetailsDto {
    id!: string;
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    defaultLanguage!: LanguageDto;
    languages!: LanguageDto[];
    asset?: AssetDto | undefined;
    permissions!: Permission[];
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;

    constructor(data?: ITenantDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
            this.defaultLanguage = new LanguageDto();
            this.languages = [];
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.defaultLanguage = _data["defaultLanguage"] ? LanguageDto.fromJS(_data["defaultLanguage"]) : new LanguageDto();
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(LanguageDto.fromJS(item));
            }
            this.asset = _data["asset"] ? AssetDto.fromJS(_data["asset"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            this.iosLinksConfiguration = _data["iosLinksConfiguration"];
            this.androidLinksConfiguration = _data["androidLinksConfiguration"];
        }
    }

    static fromJS(data: any): TenantDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["defaultLanguage"] = this.defaultLanguage ? this.defaultLanguage.toJSON() : <any>undefined;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        data["asset"] = this.asset ? this.asset.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        data["iosLinksConfiguration"] = this.iosLinksConfiguration;
        data["androidLinksConfiguration"] = this.androidLinksConfiguration;
        return data;
    }

    clone(): TenantDetailsDto {
        const json = this.toJSON();
        let result = new TenantDetailsDto();
        result.init(json);
        return result;
    }
}

export interface ITenantDetailsDto {
    id: string;
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    defaultLanguage: LanguageDto;
    languages: LanguageDto[];
    asset?: AssetDto | undefined;
    permissions: Permission[];
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
}

export class DeploymentInformation implements IDeploymentInformation {
    databaseActualSizeBytes!: number;

    constructor(data?: IDeploymentInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.databaseActualSizeBytes = _data["databaseActualSizeBytes"];
        }
    }

    static fromJS(data: any): DeploymentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new DeploymentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["databaseActualSizeBytes"] = this.databaseActualSizeBytes;
        return data;
    }

    clone(): DeploymentInformation {
        const json = this.toJSON();
        let result = new DeploymentInformation();
        result.init(json);
        return result;
    }
}

export interface IDeploymentInformation {
    databaseActualSizeBytes: number;
}

export class UpdateTenantCommand implements IUpdateTenantCommand {
    title!: InternationalizedString;
    shortDescription!: InternationalizedString;
    description!: InternationalizedDocument;
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
    assetId?: string | undefined;

    constructor(data?: IUpdateTenantCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.title = new InternationalizedString();
            this.shortDescription = new InternationalizedString();
            this.description = new InternationalizedDocument();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] ? InternationalizedString.fromJS(_data["title"]) : new InternationalizedString();
            this.shortDescription = _data["shortDescription"] ? InternationalizedString.fromJS(_data["shortDescription"]) : new InternationalizedString();
            this.description = _data["description"] ? InternationalizedDocument.fromJS(_data["description"]) : new InternationalizedDocument();
            this.iosLinksConfiguration = _data["iosLinksConfiguration"];
            this.androidLinksConfiguration = _data["androidLinksConfiguration"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): UpdateTenantCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title ? this.title.toJSON() : <any>undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : <any>undefined;
        data["description"] = this.description ? this.description.toJSON() : <any>undefined;
        data["iosLinksConfiguration"] = this.iosLinksConfiguration;
        data["androidLinksConfiguration"] = this.androidLinksConfiguration;
        data["assetId"] = this.assetId;
        return data;
    }

    clone(): UpdateTenantCommand {
        const json = this.toJSON();
        let result = new UpdateTenantCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateTenantCommand {
    title: InternationalizedString;
    shortDescription: InternationalizedString;
    description: InternationalizedDocument;
    iosLinksConfiguration?: string | undefined;
    androidLinksConfiguration?: string | undefined;
    assetId?: string | undefined;
}

export class PaginatedListOfTenantAdministratorDto implements IPaginatedListOfTenantAdministratorDto {
    items!: TenantAdministratorDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantAdministratorDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantAdministratorDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantAdministratorDto {
    items: TenantAdministratorDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantAdministratorDto implements ITenantAdministratorDto {
    user!: UserDto;
    tenantId!: string;
    permissions!: Permission[];

    constructor(data?: ITenantAdministratorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
            this.permissions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.tenantId = _data["tenantId"];
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
        }
    }

    static fromJS(data: any): TenantAdministratorDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantAdministratorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): TenantAdministratorDto {
        const json = this.toJSON();
        let result = new TenantAdministratorDto();
        result.init(json);
        return result;
    }
}

export interface ITenantAdministratorDto {
    user: UserDto;
    tenantId: string;
    permissions: Permission[];
}

export class PaginatedListOfTenantParticipantDto implements IPaginatedListOfTenantParticipantDto {
    items!: TenantParticipantDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfTenantParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantParticipantDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfTenantParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfTenantParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfTenantParticipantDto {
        const json = this.toJSON();
        let result = new PaginatedListOfTenantParticipantDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfTenantParticipantDto {
    items: TenantParticipantDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class TenantParticipantDto implements ITenantParticipantDto {
    user!: UserDto;
    tenantId!: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status!: TenantParticipantStatus;

    constructor(data?: ITenantParticipantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
            this.tenantId = _data["tenantId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.invited = _data["invited"] ? new Date(_data["invited"].toString()) : <any>undefined;
            this.enrolled = _data["enrolled"] ? new Date(_data["enrolled"].toString()) : <any>undefined;
            this.withdrawn = _data["withdrawn"] ? new Date(_data["withdrawn"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TenantParticipantDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantParticipantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["invited"] = this.invited ? this.invited.toISOString() : <any>undefined;
        data["enrolled"] = this.enrolled ? this.enrolled.toISOString() : <any>undefined;
        data["withdrawn"] = this.withdrawn ? this.withdrawn.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }

    clone(): TenantParticipantDto {
        const json = this.toJSON();
        let result = new TenantParticipantDto();
        result.init(json);
        return result;
    }
}

export interface ITenantParticipantDto {
    user: UserDto;
    tenantId: string;
    created?: Date | undefined;
    invited?: Date | undefined;
    enrolled?: Date | undefined;
    withdrawn?: Date | undefined;
    status: TenantParticipantStatus;
}

export enum TenantParticipantStatus {
    Created = "created",
    Invited = "invited",
    Enrolled = "enrolled",
    Withdrawn = "withdrawn",
}

export class PaginatedListOfUserDto implements IPaginatedListOfUserDto {
    items!: UserDto[];
    pageNumber!: number;
    pageSize!: number;
    totalCount!: number;
    totalPages!: number;
    hasPreviousPage!: boolean;
    hasNextPage!: boolean;

    constructor(data?: IPaginatedListOfUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDto.fromJS(item));
            }
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.totalCount = _data["totalCount"];
            this.totalPages = _data["totalPages"];
            this.hasPreviousPage = _data["hasPreviousPage"];
            this.hasNextPage = _data["hasNextPage"];
        }
    }

    static fromJS(data: any): PaginatedListOfUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaginatedListOfUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["totalCount"] = this.totalCount;
        data["totalPages"] = this.totalPages;
        data["hasPreviousPage"] = this.hasPreviousPage;
        data["hasNextPage"] = this.hasNextPage;
        return data;
    }

    clone(): PaginatedListOfUserDto {
        const json = this.toJSON();
        let result = new PaginatedListOfUserDto();
        result.init(json);
        return result;
    }
}

export interface IPaginatedListOfUserDto {
    items: UserDto[];
    pageNumber: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export class CreateUserCommand implements ICreateUserCommand {
    email!: string;

    constructor(data?: ICreateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): CreateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }

    clone(): CreateUserCommand {
        const json = this.toJSON();
        let result = new CreateUserCommand();
        result.init(json);
        return result;
    }
}

export interface ICreateUserCommand {
    email: string;
}

export class SendNotificationCommand implements ISendNotificationCommand {
    userId!: string;
    title!: string;
    body!: string;
    encrypted!: boolean;

    constructor(data?: ISendNotificationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.encrypted = _data["encrypted"];
        }
    }

    static fromJS(data: any): SendNotificationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SendNotificationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["title"] = this.title;
        data["body"] = this.body;
        data["encrypted"] = this.encrypted;
        return data;
    }

    clone(): SendNotificationCommand {
        const json = this.toJSON();
        let result = new SendNotificationCommand();
        result.init(json);
        return result;
    }
}

export interface ISendNotificationCommand {
    userId: string;
    title: string;
    body: string;
    encrypted: boolean;
}

export class UpdateUserCommand implements IUpdateUserCommand {
    userId!: string;
    email!: string;
    firstName!: string;
    lastName!: string;

    constructor(data?: IUpdateUserCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): UpdateUserCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }

    clone(): UpdateUserCommand {
        const json = this.toJSON();
        let result = new UpdateUserCommand();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserCommand {
    userId: string;
    email: string;
    firstName: string;
    lastName: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}